/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  recentlyViewedStorageLimit: 20,
  recentlyViewedCardCacheKey: 'recent-product-cards-v4',
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productCards: {} // will store server-rendered custom cards to reduce requests
};

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },

    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },

    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    safeStorageSet: function(storage, key, value) {
      try {
        storage.setItem(key, value);
      } catch (e) {
        // Silently swallow quota exceptions to gracefully degrade and preserve existing cache
      }
    },

    trimRecentlyViewedCache: function(recent, productInfo, limit) {
      if (!recent || recent.constructor !== Object) {
        return;
      }

      var recentHandles = Object.keys(recent);

      while (recentHandles.length > limit) {
        delete recent[recentHandles.shift()];
      }

      if (!productInfo || productInfo.constructor !== Object) {
        return;
      }

      recentHandles = Object.keys(recent);

      Object.keys(productInfo).forEach(function(handle) {
        if (recentHandles.indexOf(handle) === -1) {
          delete productInfo[handle];
        }
      });
    },

    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();

      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;

        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },

    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  const trapFocusHandlers = {};

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

  theme.Images = (function() {

    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    function buildImagePath(string, widths) {

      if (string == null) return [];

      if (widths) {
        const imageUrls = [];

        widths.forEach(width => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`
          } else {
            url += ` ${width}w,`
          }
          imageUrls.push(url);
        })
        return imageUrls;
      } else {
        return [string];
      }
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath
    };
  })();

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback()
            observer.unobserve(entry.target)
          }
        }
      })
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' })

    observer.observe(options.element)
  }

  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;

      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function() {

    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });

      if (options.initModal) {
        this.initModal();
      }
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {

      initModal: function() {
        var variantLabels = this.container.querySelectorAll('[data-variant-label]');
        variantLabels.forEach(elm => {
          // Setup variant modal
          var label = elm.innerText.toLowerCase().replace(/ /g,'-');
          var modalId = 'ProductInfoModal-' + label;
          var name = 'product-info-modal-' + label;
          new theme.Modals(modalId, name);
        })
      },

      _getCurrentOptions: function() {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function(key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function(variant) {
        return this._getCurrentOptions().reduce((count, {value, index}) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        },0)
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find(variant => {
          const isMatch = currentlySelectedOptions.every(({value, index}) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function(lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches = lastSelectedOption && variants.filter(variant => {
          return currentlySelectedOptions
            .filter(
              // Only match based selected options that are equal and preceeding the last selected option
              ({value, index}) => this._numberFromOptionKey(index) <= this._numberFromOptionKey(lastSelectedOption.index)
            ).every(({value, index}) => {
              // Variant needs to have options that match the current and preceeding selection options
              return variant[index] === value;
            }) && variant.available
        });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(bestMatch, lastSelectedOption);
          const newCount = this._getWeightedOptionMatchCount(variant, lastSelectedOption);

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function(lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch = this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return availableFullMatch || closestAvailableMatch || fullMatch || null;
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }

      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            input.checked = variant[index] === value
          } else {
            input.value = variant[index];
          }
        }
      },

      _onSelectChange: function({srcElement}) {
        const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);

        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(this._updateInputState(variant, srcElement))

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index,
          productSection: this.container && this.container.getAttribute ? this.container.getAttribute('data-section-id') : null,
          sourceContainer: this.container
        }

        this.container.dispatchEvent(new CustomEvent('variantChange', {detail}));
        document.dispatchEvent(new CustomEvent('variant:change', {detail}));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this._updateVariantUrl(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function(variant) {
        if (!variant.featured_image) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },

      _updateMasterSelect: function(variant) {
        let masterSelect = this.container.querySelector(this.originalSelectorId);
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      },

      _updateVariantUrl:function(variant) {
        if (variant.id === this.currentVariant.id) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUrlChange', {
          detail: {
            variant: variant
          }
        }));
      }
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true
        theme.config.vimeoLoading = false
        document.dispatchEvent(new CustomEvent('vimeoReady'))
      })
  }

  function checkIfVimeoIsReady () {
    let wait
    let timeout

    return new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return
        }

        clearInterval(wait)
        clearTimeout(timeout)
        resolve()
      }, 500)

      timeout = setTimeout(function () {
        clearInterval(wait)
        reject()
      }, 4000) // subjective. test up to 8 times over 4 seconds
    })
  }

  theme.VimeoPlayer = (function () {
    const classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    const defaults = {
      byline: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    }

    function VimeoPlayer (divId, videoId, options) {
      this.divId = divId
      this.el = document.getElementById(divId)
      this.videoId = videoId
      this.iframe = null
      this.options = options

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent)
      }

      this.setAsLoading()

      if (theme.config.vimeoReady) {
        this.init()
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady)
        document.addEventListener('vimeoReady', this.init.bind(this))
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        const args = defaults
        args.id = this.videoId

        this.videoPlayer = new Vimeo.Player(this.el, args)

        this.videoPlayer.ready().then(this.playerReady.bind(this))
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe')
        this.iframe.setAttribute('tabindex', '-1')

        if (this.options.loop === 'false') {
          this.videoPlayer.setLoop(false)
        }

        // When sound is enabled in section settings,
        // for some mobile browsers Vimeo video playback
        // will stop immediately after starting and
        // will require users to tap the play button once more
        if (this.options.style === 'sound') {
          this.videoPlayer.setVolume(1)
        } else {
          this.videoPlayer.setVolume(0)
        }

        this.setAsLoaded()

        // pause when out of view
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play()
            } else {
              this.pause()
            }
          })
        }, { rootMargin: '0px 0px 50px 0px' })

        observer.observe(this.iframe)
      },

      setAsLoading: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.loading)
      },

      setAsLoaded: function () {
        if (!this.parent) return
        this.parent.classList.remove(classes.loading)
        this.parent.classList.add(classes.loaded)
        this.parent.classList.add(classes.interactable) // Once video is loaded, we should be able to interact with it
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },

      enableInteraction: function () {
        if (!this.parent) return
        this.parent.classList.add(classes.interactable)
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play()
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause()
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy()
        }
      }
    })

    return VimeoPlayer
  })()

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }

      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});

        observer.observe(this.iframe);
      },

      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },

      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return YouTube;
  })();

  // Prevent vertical scroll while using flickity sliders
  (function() {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })

    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();


  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)

        const sectionRenders = this.sections.map(section => {

          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(updatedParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );

        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
        const currentEntries = Array.from(clone.entries());

        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of currentEntries) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }

        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }

        return clone;
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },

    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(response => response.text())
      .catch(e => console.error(e));
    },

    changeItem: function(key, qty) {

      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => { return response.text() })
      .then(cart => { return cart; });
    },

    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },

    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },

    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',

      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };

    var classes = {
      btnLoading: 'btn--loading'
    };

    var config = {
      requiresTerms: false
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      this.cartItemsUpdated = false;

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();

        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },

      reInit: function() {
        this.initQtySelectors();
      },

      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        /*
          Checks for drawer or cart open class on body element
          and then stops the form from being submitted. We are also
          checking against a custom property, this.cartItemsUpdated = false.

          Error is handled in the quantityChanged method

          For Expanse/Fetch/Gem quick add, if an error is present it is alerted
          through the add to cart fetch request in quick-add.js.

          Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
          Expanse/Fetch/Gem when using quick add
        */

        if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
          document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
          this.submitBtn.classList.remove(classes.btnLoading);
          evt.preventDefault();
          return false;
        }

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(text) {
        const html = document.createElement('div');
        html.innerHTML = text;

        return {
          items: html.querySelector('.cart__items'),
          discounts: html.querySelector('.cart__discounts')
        }
      },

      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function(text) {
        var markup = this._parseProductHTML(text);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

        this.reInit();

        if (window.AOS) { AOS.refreshHard() }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart.changeItem(key, qty)
          .then(function(cart) {

            const parsedCart = JSON.parse(cart);

            if (parsedCart.status === 422) {
              alert(parsedCart.message);
            } else {
              const updatedItem = parsedCart.items.find(item => item.key === key);

              // Update cartItemsUpdated property on object so we can reference later
              if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                this.cartItemsUpdated = true;
              }

              if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                if (updatedItem.quantity !== qty) {
                }
                // Reset property on object so that checkout button will work as usual
                this.cartItemsUpdated = false;
              }

              if (parsedCart.item_count > 0) {
                this.wrapper.classList.remove('is-empty');
              } else {
                this.wrapper.classList.add('is-empty');
              }
            }

            this.buildCart();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedCart
              }
            }));
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');

        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === 'auto') {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {

        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },

      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },

      _connectOptions: function(event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });

    return Disclosure;
  })();

  theme.Drawers = (function() {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },

      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);
        if (this.config.id === 'FilterDrawer') {
          document.documentElement.classList.add('js-filter-drawer-open');
        }
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },

      close: function(evt) {
        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        if (this.config.id === 'FilterDrawer') {
          document.documentElement.classList.remove('js-filter-drawer-open');
        }
        document.documentElement.classList.add(this.config.closingClass);

        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();

        document.dispatchEvent(new CustomEvent('drawerClose'));
        document.dispatchEvent(new CustomEvent('drawerClose.' + this.config.id));
      },

      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: 'modal_focus'
        });
      }, 100);


      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  /*============================================================================
    ParallaxImage
  ==============================================================================*/

  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      this.parallaxImage = this.querySelector('[data-parallax-image]');
      this.windowInnerHeight = window.innerHeight;
      this.isActive = false;
      this.timeout = null;
      this.directionMap = {
        right: 0,
        top: 90,
        left: 180,
        bottom: 270
      }
      this.directionMultipliers = {
        0: [  1,  0 ],
        90: [  0, -1 ],
        180: [ -1,  0 ],
        270: [  0,  1 ]
      }

      this.init();
      window.addEventListener('scroll', () => this.scrollHandler());
    }

    getParallaxInfo() {
      const { width, height, top } = this.parallaxImage.getBoundingClientRect();
      let element = this.parallaxImage;
      let multipliers;
      let { angle, movement } = element.dataset;

      let movementPixels = angle === 'top' ? Math.ceil(height * (parseFloat(movement) / 100)) : Math.ceil(width * (parseFloat(movement) / 100));

      // angle has shorthands "top", "left", "bottom" and "right"
      // nullish coalescing. using `||` here would fail for `0`
      angle = this.directionMap[angle] ?? parseFloat(angle);

      // fallback if undefined
      // NaN is the only value that doesn't equal itself
      if (angle !== angle) angle = 270; // move to bottom (default parallax effect)
      if (movementPixels !== movementPixels) movementPixels = 100; // 100px

      // check if angle is located in top half and/or left half
      angle %= 360;
      if (angle < 0) angle += 360

      const toLeft = angle > 90 && angle < 270;
      const toTop  = angle < 180;

      element.style[toLeft ? 'left' : 'right'] = 0;
      element.style[toTop  ? 'top' : 'bottom'] = 0;

      // if it's not a perfectly horizontal or vertical movement, get cos and sin
      if (angle % 90) {
        const radians = angle * Math.PI / 180
        multipliers = [ Math.cos(radians), Math.sin(radians) * -1 ] // only sin has to be inverted
      } else {
        multipliers = this.directionMultipliers[angle];
      }

      // increase width and height according to movement and multipliers
      if (multipliers[0]) element.style.width  = `calc(100% + ${movementPixels * Math.abs(multipliers[0])}px)`;
      if (multipliers[1]) element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])}px)`;

      return {
        element,
        movementPixels,
        multipliers,
        top,
        height
      }
    }

    init() {
      const { element, movementPixels, multipliers, top, height } = this.getParallaxInfo();;

      const scrolledInContainer = this.windowInnerHeight - top;
      const scrollArea = this.windowInnerHeight + height;
      const progress = scrolledInContainer / scrollArea;

      if (progress > -0.1 && progress < 1.1) {
        const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
        element.style.transform = `translate3d(${position * multipliers[0]}px, ${position * multipliers[1]}px, 0)`;
      }

      if (this.isActive) requestAnimationFrame(this.init.bind(this));
    }

    scrollHandler() {
      if (this.isActive) {
        clearTimeout(this.timeout);
      } else {
        this.isActive = true;
        requestAnimationFrame(this.init.bind(this));
      }

      this.timeout = setTimeout(() => this.isActive = false, 20);
    }
  }

  customElements.define('parallax-image', ParallaxImage);

  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };

    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }

        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : '.add-to-cart';

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');

        status.loading = true;

        var data = theme.utils.serialize(this.form);

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);
          }

          status.loading = false;
          this.addToCart.classList.remove('btn--loading');

          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));
      },

      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        if (theme.settings.cartType === 'page') {
          window.location = theme.routes.cartPage;
        }

        this.form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          },
          bubbles: true
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },

      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');

        if (typeof error.description === 'object') {
          errorDiv.textContent = error.message;
        } else {
          errorDiv.textContent = error.description;
        }

        this.form.append(errorDiv);

        this.form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          },
          bubbles: true
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };

      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };

      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function(event) {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        if (!event.detail.autoplayMedia) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));

        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));

        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },

      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.initQuickShop = function(scope) {
    var ids = [];
    var roots = [];
    var products = [];

    if (scope) {
      if (scope instanceof Element || scope instanceof Document) {
        roots = [scope];
      } else if (scope.length) {
        roots = Array.prototype.slice.call(scope);
      }
    } else {
      roots = [document];
    }

    roots.forEach(function(root) {
      if (!root) return;

      if (root.matches && root.matches('.grid-product')) {
        products.push(root);
      }

      if (root.querySelectorAll) {
        products = products.concat(Array.prototype.slice.call(root.querySelectorAll('.grid-product')));
      }
    });

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      if (product.dataset.quickShopBound === 'true') {
        return;
      }

      product.dataset.quickShopBound = 'true';
      product.addEventListener('mouseover', productMouseover);
      product.addEventListener('focusin', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        el.removeEventListener('focusin', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const div = html.querySelector('.product-section[data-product-handle="'+handle+'"]');

      if (!holder) {
        return;
      }

      holder.innerHTML = '';
      holder.append(div);

      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);

      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);



      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === 'true') {
        this.slideshow.on('dragStart', () => {
          this.slideshow.slider.style.pointerEvents = 'none';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'none';
          }
        });
        this.slideshow.on('dragEnd', () => {
          this.slideshow.slider.style.pointerEvents = 'auto';

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector('.is-selected').style.pointerEvents = 'auto';
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }

        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },

      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, use the Variant Picker Block setting
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {

          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {

            if (variant[index] === null) return;

            let entry = options[index].find(option => option.value === variant[index]);

            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')

            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })

          return options;
        }, { option1: [], option2: [], option3: []})
      },

      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });

        const currentlySelectedValues = this.currentVariantObject.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, this.currentVariantObject);

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function(evt) {

        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues, variant} = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues, variant, lastSelectedIndex, lastSelectedValue)

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function(option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');

        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOption: function(group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');

        if (this.type === 'dropdown') {
          if (obj.soldOut) {
            group.querySelector('option[value="'+ value +'"]').disabled = true;
          } else {
            group.querySelector('option[value="'+ value +'"]').disabled = false;
          }
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },

      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }

    });

    return availability;
  })();

  theme.VariantScroller = (function() {
    var SCROLL_AMOUNT_FACTOR = 0.8;

    function VariantScroller(container) {
      this.container = container;
      this.scrollers = [];
      this.skipInitialSelectedScroll = true;
      this.shouldRevealInitialSelection = this._shouldRevealInitialSelection();
      this.init();
    }

    VariantScroller.prototype = {
      init: function() {
        var targets = this.container.querySelectorAll('[data-variant-scroller]');
        targets.forEach(this._bindScroller.bind(this));

        requestAnimationFrame(function() {
          this.skipInitialSelectedScroll = false;
        }.bind(this));
      },

      _shouldRevealInitialSelection: function() {
        var hasVariantParam = false;

        try {
          hasVariantParam = new URLSearchParams(window.location.search).has('variant');
        } catch (e) {}

        if (hasVariantParam) {
          return true;
        }

        var currentVariantJson = this.container.querySelector('[data-current-variant-json]');
        var variantJson = this.container.querySelector('[data-variant-json]');

        if (!currentVariantJson || !variantJson) {
          return false;
        }

        try {
          var currentVariant = JSON.parse(currentVariantJson.innerHTML);
          var variants = JSON.parse(variantJson.innerHTML);

          if (!currentVariant || !variants || !variants.length) {
            return false;
          }

          return currentVariant.id !== variants[0].id;
        } catch (e) {
          return false;
        }
      },

      _bindScroller: function(root) {
        var viewport = root.querySelector('[data-variant-scroller-viewport]');
        var prevBtn = root.querySelector('[data-variant-scroller-prev]');
        var nextBtn = root.querySelector('[data-variant-scroller-next]');

        if (!viewport || !prevBtn || !nextBtn) return;

        // Mark as enhanced to activate flex-nowrap CSS
        root.classList.add('is-enhanced');

        var scroller = {
          root: root,
          viewport: viewport,
          prevBtn: prevBtn,
          nextBtn: nextBtn,
          observer: null
        };
        this.scrollers.push(scroller);

        scroller._onScroll = theme.utils.debounce(50, function() {
          this._updateBoundaryClasses(scroller);
        }.bind(this));
        viewport.addEventListener('scroll', scroller._onScroll, { passive: true });

        scroller._onPrevClick = function() {
          var amount = Math.round(viewport.clientWidth * SCROLL_AMOUNT_FACTOR);
          viewport.scrollTo({
            left: this._clampScrollLeft(scroller, viewport.scrollLeft - amount),
            behavior: 'smooth'
          });
        }.bind(this);
        scroller._onNextClick = function() {
          var amount = Math.round(viewport.clientWidth * SCROLL_AMOUNT_FACTOR);
          viewport.scrollTo({
            left: this._clampScrollLeft(scroller, viewport.scrollLeft + amount),
            behavior: 'smooth'
          });
        }.bind(this);
        prevBtn.addEventListener('click', scroller._onPrevClick);
        nextBtn.addEventListener('click', scroller._onNextClick);

        if (typeof ResizeObserver !== 'undefined') {
          scroller.observer = new ResizeObserver(function() {
            this._checkOverflow(scroller);
          }.bind(this));
          scroller.observer.observe(viewport);
        } else {
          scroller._onResize = theme.utils.debounce(100, function() {
            this._checkOverflow(scroller);
          }.bind(this));
          window.addEventListener('resize', scroller._onResize);
        }

        viewport.scrollLeft = 0;
        this._checkOverflow(scroller);
        this._updateBoundaryClasses(scroller);

        requestAnimationFrame(function() {
          viewport.scrollLeft = 0;
          this._checkOverflow(scroller);
          this._updateBoundaryClasses(scroller);
        }.bind(this));

        setTimeout(function() {
          viewport.scrollLeft = 0;
          this._checkOverflow(scroller);
          this._updateBoundaryClasses(scroller);

          if (this.shouldRevealInitialSelection) {
            this._revealInitialSelection(scroller);
          }
        }.bind(this), 80);
      },

      _checkOverflow: function(s) {
        var usefulMaxScroll = this._getUsefulMaxScroll(s);
        var isOverflowing = usefulMaxScroll > 1;
        
        s.root.classList.toggle('is-overflowing', isOverflowing);
        
        if (isOverflowing) {
          if (s.viewport.scrollLeft > usefulMaxScroll) {
            s.viewport.scrollLeft = usefulMaxScroll;
          }
          this._updateBoundaryClasses(s);
        } else {
          s.viewport.scrollLeft = 0;
          s.root.classList.add('is-at-start', 'is-at-end');
        }
      },

      _updateBoundaryClasses: function(s) {
        var maxScroll = this._getUsefulMaxScroll(s);
        var scrollLeft = s.viewport.scrollLeft;

        s.root.classList.toggle('is-at-start', scrollLeft <= 1);
        s.root.classList.toggle('is-at-end', scrollLeft >= maxScroll - 1);
      },

      _getUsefulMaxScroll: function(s) {
        var nativeMaxScroll = Math.max(0, s.viewport.scrollWidth - s.viewport.clientWidth);
        if (!nativeMaxScroll) return 0;

        var items = s.root.querySelectorAll('.variant-input');
        if (!items.length) return nativeMaxScroll;

        var lastItem = items[items.length - 1];
        var viewportRect = s.viewport.getBoundingClientRect();
        var lastItemRect = lastItem.getBoundingClientRect();
        var edgeGap = 8;
        var usefulMaxScroll = s.viewport.scrollLeft + (lastItemRect.right - viewportRect.right) + edgeGap;

        return Math.min(nativeMaxScroll, Math.max(0, Math.ceil(usefulMaxScroll)));
      },

      _clampScrollLeft: function(s, scrollLeft) {
        return Math.max(0, Math.min(scrollLeft, this._getUsefulMaxScroll(s)));
      },

      _scrollSelectedIntoView: function(s, activeInput, animate) {
        if (!activeInput) return;
        var target = activeInput.closest('.variant-input');
        if (!target) return;
        var behavior = animate === false ? 'auto' : 'smooth';
        
        var viewportRect = s.viewport.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        
        var isFullyVisible = (targetRect.left >= viewportRect.left) && (targetRect.right <= viewportRect.right);
        
        if (!isFullyVisible) {
          // Calculate target center relative to viewport scroll area
          var scrollLeft = target.offsetLeft - (s.viewport.clientWidth / 2) + (target.clientWidth / 2);
          s.viewport.scrollTo({ left: this._clampScrollLeft(s, scrollLeft), behavior: behavior });
        }
      },

      _revealInitialSelection: function(s) {
        var checkedInput = s.root.querySelector('input[type="radio"]:checked');
        if (!checkedInput) return;

        this._scrollSelectedIntoView(s, checkedInput, false);
        this._updateBoundaryClasses(s);
      },

      scrollToSelected: function() {
        if (this.skipInitialSelectedScroll) {
          this.skipInitialSelectedScroll = false;
          return;
        }

        this.scrollers.forEach(function(s) {
          var checkedInput = s.root.querySelector('input[type="radio"]:checked');
          if (checkedInput) {
            // Wait slightly for layout stabilization if other changes occurred
            setTimeout(function() {
              this._scrollSelectedIntoView(s, checkedInput);
            }.bind(this), 0);
          }
        }.bind(this));
      },

      destroy: function() {
        this.scrollers.forEach(function(s) {
          s.viewport.removeEventListener('scroll', s._onScroll);
          s.prevBtn.removeEventListener('click', s._onPrevClick);
          s.nextBtn.removeEventListener('click', s._onNextClick);
          
          if (s.observer) {
            s.observer.disconnect();
          } else if (s._onResize) {
            window.removeEventListener('resize', s._onResize);
          }
          
          s.root.classList.remove('is-enhanced', 'is-overflowing', 'is-at-start', 'is-at-end');
        });
        this.scrollers = [];
      }
    };

    return VariantScroller;
  })();

  theme.VariantCollapse = (function() {
    function VariantCollapse(container) {
      this.container = container;
      this.groups = [];
      this.autoExpandInitialSelected = /(?:\?|&)variant=/.test(window.location.search);
      this.init();
    }

    VariantCollapse.prototype = {
      init: function() {
        var targets = this.container.querySelectorAll('[data-variant-collapse]');
        targets.forEach(this._bindGroup.bind(this));
        this.autoExpandInitialSelected = false;
      },

      _bindGroup: function(root) {
        var fieldset = root.querySelector('[data-variant-collapse-fieldset]');
        var toggle = root.querySelector('[data-variant-collapse-toggle]');
        var toggleItem = root.querySelector('[data-variant-collapse-toggle-item]');
        var items = Array.prototype.slice.call(root.querySelectorAll('[data-variant-collapse-item]'));

        if (!fieldset || !items.length) return;

        var group = {
          root: root,
          fieldset: fieldset,
          toggle: toggle,
          toggleItem: toggleItem,
          items: items,
          expanded: false,
          userExpanded: false,
          collapsedCount: items.length
        };

        if (toggle && toggleItem && items.length > 1) {
          group._onToggleClick = function() {
            group.userExpanded = !group.expanded;
            this._setExpanded(group, group.userExpanded);
          }.bind(this);

          toggle.addEventListener('click', group._onToggleClick);

          group._onResize = theme.utils.debounce(80, function() {
            this._refreshGroup(group, {
              immediate: true,
              preserveExpanded: true
            });
          }.bind(this));

          window.addEventListener('resize', group._onResize);
        } else {
          root.classList.add('variant-collapse--compact');
        }

        this.groups.push(group);
        this._refreshGroup(group, {
          autoExpandSelected: this.autoExpandInitialSelected,
          immediate: true,
          preserveExpanded: false
        });
      },

      _getCheckedIndex: function(group) {
        var checkedInput = group.root.querySelector('input[type="radio"]:checked');
        if (!checkedInput) return -1;

        var checkedItem = checkedInput.closest('[data-variant-collapse-item]');
        if (!checkedItem) return -1;

        return group.items.indexOf(checkedItem);
      },

      _resetCollapsedItems: function(group) {
        group.items.forEach(function(item) {
          item.hidden = false;
          item.classList.remove('is-collapsed-hidden');
        });
      },

      _measureCollapsedCount: function(group) {
        var toggleItem = group.toggleItem;
        var items = group.items;
        var firstRowTop;
        var collapsedCount = items.length;

        if (!toggleItem || items.length <= 1) {
          return items.length;
        }

        this._resetCollapsedItems(group);
        toggleItem.hidden = true;

        firstRowTop = items[0].offsetTop;

        if (items.every(function(item) { return item.offsetTop === firstRowTop; })) {
          toggleItem.hidden = false;
          return items.length;
        }

        toggleItem.hidden = false;

        for (collapsedCount = items.length - 1; collapsedCount > 0; collapsedCount--) {
          items.forEach(function(item, index) {
            var isHidden = index >= collapsedCount;
            item.hidden = isHidden;
            item.classList.toggle('is-collapsed-hidden', isHidden);
          });

          if (toggleItem.offsetTop === firstRowTop) {
            break;
          }
        }

        this._resetCollapsedItems(group);
        return Math.max(1, collapsedCount);
      },

      _refreshGroup: function(group, options) {
        options = options || {};

        var checkedIndex;
        var nextExpanded = false;

        group.collapsedCount = this._measureCollapsedCount(group);

        if (group.toggleItem) {
          group.toggleItem.hidden = group.collapsedCount >= group.items.length;
        }

        group.root.classList.toggle('variant-collapse--compact', group.collapsedCount >= group.items.length);

        checkedIndex = this._getCheckedIndex(group);

        if (group.collapsedCount < group.items.length) {
          if (options.preserveExpanded && group.userExpanded) {
            nextExpanded = true;
          } else if (options.autoExpandSelected && checkedIndex >= group.collapsedCount && checkedIndex !== -1) {
            nextExpanded = true;
            group.userExpanded = true;
          }
        } else {
          group.userExpanded = false;
        }

        this._setExpanded(group, nextExpanded, {
          immediate: options.immediate
        });
      },

      _animateHeight: function(group, mutate) {
        var fieldset = group.fieldset;
        var startHeight = fieldset.offsetHeight;
        var fallbackTimer;
        var cleanup = function() {
          clearTimeout(fallbackTimer);
          fieldset.style.height = '';
          fieldset.style.overflow = '';
          fieldset.style.transition = '';
          fieldset.classList.remove('is-animating');
          fieldset.removeEventListener('transitionend', cleanup);
        };

        fieldset.style.height = startHeight + 'px';
        fieldset.style.overflow = 'hidden';
        fieldset.classList.add('is-animating');

        mutate();

        var endHeight = fieldset.scrollHeight;

        if (Math.abs(endHeight - startHeight) < 1) {
          cleanup();
          return;
        }

        fieldset.addEventListener('transitionend', cleanup);
        fallbackTimer = setTimeout(cleanup, 260);

        fieldset.offsetHeight;
        fieldset.style.transition = 'height 180ms ease';
        fieldset.style.height = endHeight + 'px';
      },

      _setExpanded: function(group, expanded, options) {
        options = options || {};

        var hasToggle = group.toggle && group.toggleItem && group.collapsedCount < group.items.length;
        var shouldExpand = hasToggle ? expanded : true;
        var hiddenCount = 0;
        var collapsedCount = group.collapsedCount || group.items.length;
        var applyState = function() {
          if (!hasToggle) {
            group.items.forEach(function(item) {
              item.hidden = false;
              item.classList.remove('is-collapsed-hidden');
            });
          } else if (shouldExpand) {
            group.items.forEach(function(item) {
              item.hidden = false;
              item.classList.remove('is-collapsed-hidden');
            });
          } else {
            group.items.forEach(function(item, index) {
              var isHidden = index >= collapsedCount;
              item.hidden = isHidden;
              item.classList.toggle('is-collapsed-hidden', isHidden);
            });
          }

          hiddenCount = hasToggle && !shouldExpand ? Math.max(0, group.items.length - collapsedCount) : 0;
        };

        group.expanded = shouldExpand;
        group.root.classList.toggle('is-expanded', shouldExpand);
        group.root.classList.toggle('is-collapsed', !shouldExpand && hasToggle);
        group.root.classList.toggle('is-all-visible', !hasToggle);

        if (options.immediate) {
          applyState();
        } else {
          this._animateHeight(group, applyState);
        }

        if (group.toggle) {
          group.toggle.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
          group.toggle.setAttribute('aria-label', shouldExpand ? 'Show fewer options' : 'Show more options');

          var label = group.toggle.querySelector('.variant-collapse__toggle-label');
          if (label) {
            label.textContent = shouldExpand ? 'Show fewer options' : 'Show more options';
          }

          group.toggle.dataset.hiddenCount = hiddenCount;
        }
      },

      syncToSelected: function(options) {
        options = options || {};

        if (!options.autoExpandSelected) return;

        this.groups.forEach(function(group) {
          if (!group.toggle || group.collapsedCount >= group.items.length) return;

          var checkedIndex = this._getCheckedIndex(group);
          if (checkedIndex >= group.collapsedCount) {
            group.userExpanded = true;
            this._setExpanded(group, true);
          }
        }.bind(this));
      },

      destroy: function() {
        this.groups.forEach(function(group) {
          if (group.toggle && group._onToggleClick) {
            group.toggle.removeEventListener('click', group._onToggleClick);
          }

          if (group._onResize) {
            window.removeEventListener('resize', group._onResize);
          }

          group.root.classList.remove('is-expanded', 'is-collapsed', 'is-all-visible', 'variant-collapse--compact');
          if (group.toggleItem) {
            group.toggleItem.hidden = false;
          }
          group.items.forEach(function(item) {
            item.hidden = false;
            item.classList.remove('is-collapsed-hidden');
          });
        });

        this.groups = [];
      }
    };

    return VariantCollapse;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
    var vimeoPlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !vimeoTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    if (vimeoTriggers.length) {
      theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    vimeoTriggers.forEach(btn => {
      btn.addEventListener('click', triggerVimeoModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(
        videoHolderId,
        videoId,
        {
          style: 'sound',
          loop: videoLoop,
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === 'function') {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };


  /*============================================================================
    ToolTip
  ==============================================================================*/

  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.toolTipTitle = this.querySelector('[data-tool-tip-title]');

      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');

      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }

    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;

      // Ensure we set a title for product availability
      if (context != 'store-availability') {
        this.toolTipTitle.remove();
      }

      this._lockScrolling();

      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }

      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });

      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });

      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }

    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';

      this._unlockScrolling();

      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }

    _lockScrolling() {
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.lockMobileScrolling();
      document.documentElement.classList.add('modal-open');
    }

    _unlockScrolling() {
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });

      theme.a11y.unlockMobileScrolling();
      document.documentElement.classList.remove('modal-open');
    }
  }

  customElements.define('tool-tip', ToolTip);

  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/

  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
      this.init();
    }

    init() {
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });

      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }

  customElements.define('tool-tip-trigger', ToolTipTrigger);

  /*============================================================================
    NewsletterReminder
  ==============================================================================*/

  class NewsletterReminder extends HTMLElement {
    constructor() {
      super();
      this.closeBtn = this.querySelector('[data-close-button]');
      this.popupTrigger = this.querySelector('[data-message]');

      this.id = this.dataset.sectionId;
      this.newsletterId = `NewsletterPopup-${ this.id }`;
      this.cookie = Cookies.get(`newsletter-${this.id}`);
      this.cookieName = `newsletter-${this.id}`;
      this.secondsBeforeShow = this.dataset.delaySeconds;
      this.expiry = parseInt(this.dataset.delayDays);
      this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, 'newsletter-popup-modal');

      this.init();
    }

    init() {
      document.addEventListener('shopify:block:select', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.show(0, true)
        }
      });

      document.addEventListener('shopify:block:deselect', (evt) => {
        if (evt.detail.sectionId === this.id) {
          this.hide();
        }
      });

      document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide());
      document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show());
      document.addEventListener(`newsletter:openReminder`, () => this.show(0));

      this.closeBtn.addEventListener('click', () => {
        this.hide();
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: this.expiry });
      });

      this.popupTrigger.addEventListener('click', () => {
        const reminderOpen = new CustomEvent('reminder:openNewsletter', { bubbles: true });
        this.dispatchEvent(reminderOpen);

        this.hide();
      });
    }

    show(time = this.secondsBeforeShow, forceOpen = false) {
      const reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

      if (!reminderAppeared) {
        setTimeout(() => {
          this.dataset.enabled = 'true';
          theme.utils.safeStorageSet(sessionStorage, 'reminderAppeared', true);
        }, time * 1000);
      }
    }

    hide() {
      this.dataset.enabled = 'false';
    }
  }

  customElements.define('newsletter-reminder', NewsletterReminder);

  /*============================================================================
    ImageElement
  ==============================================================================*/

  class ImageElement extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        this.removeAnimations();

        observer.unobserve(this);
      }

      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }

    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest('.image-wrap');
      const skrimWrap = this.closest('.skrim__link');

      if (imageWrap) {
        imageWrap.classList.add('loaded');
      }

      if (skrimWrap) {
        skrimWrap.classList.add('loaded');
      }
    }
  }

  customElements.define('image-element', ImageElement);

  /*============================================================================
    PredictiveSearch
  ==============================================================================*/

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.searchTypes = this.getAttribute('data-search-types') || 'product';
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;

      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');

        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);

        document.body.classList.add('predictive-overflow-hidden');
      });

      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });

        observer.observe(this.SearchModal, {
          attributes: true
        });
      }

      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });

      if (this.enabled === 'false') return;

      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });

      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) return;

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[limit]': 3,
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      };

      searchObj['resources[type]'] = this.searchTypes;

      const params = this.paramUrl(searchObj);

      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();

          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');

      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
      this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
      this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.dateInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
      this.addEventListener('change', () => this.onChange());
      this.recipientFields = this.querySelector('.recipient-fields');

      this.checkboxInput.addEventListener('change', () => {
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
      });
    }

    connectedCallback() {
      document.addEventListener('ajaxProduct:error', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.displayErrorMessage(event.detail.errorMessage);
        }
      });

      document.addEventListener('ajaxProduct:added', (event) => {
        const productVariantID = event.target.querySelector('[name="id"]').value;
        if (productVariantID === this.dataset.productVariantId) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      });
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields() {
      this.querySelectorAll('.field__input').forEach(el => el.value = '');
    }

    displayErrorMessage(body) {
      this.clearErrorMessage();
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute('aria-invalid', true);
          inputElement.classList.add('field__input--error');
        });
      }
    }

    clearErrorMessage() {
      this.querySelectorAll('.field__input').forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
        inputElement.classList.remove('field__input--error');
      });
    }
  };

  customElements.define('recipient-form', RecipientForm);


  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };

  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function() {
        this.drawer.open();

        theme.a11y.trapFocus({
          container: this.form,
          elementToFocus: this.form,
          namespace: 'cartdrawer_focus'
        });
      },

      close: function() {
        this.drawer.close();

        theme.a11y.removeTrapFocus({
          container: this.form,
          namespace: 'cartdrawer_focus'
        });
      }
    });

    return CartDrawer;
  })();

  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level',
      navDetails: '.site-nav__details',
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      menuDetailsHandler();
      searchDrawer();
    }

    function menuDetailsHandler() {
      const navDetails = document.querySelectorAll(selectors.navDetails);

      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector('summary');

        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener('click', (evt) => {
          if (navDetail.hasAttribute('open') && !navDetail.contains(evt.target)) {
            navDetail.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          } else {
            if (navDetail.hasAttribute('open')) {
              summary.setAttribute('aria-expanded', 'false');
            } else {
              summary.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderInitialPosition(siteHeader);
      stickyHeaderHeight();

      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderInitialPosition(header) {
      const headerParent = header.closest('.shopify-section-group-header-group');
      const parentNextSibling = headerParent.nextElementSibling;

      // if parentNextSibling has same class as headerParent, then header is above announcement bar
      if (parentNextSibling && parentNextSibling.classList.contains('shopify-section-group-header-group')) {
        // get height of announcement bar and set header wrapper top to that value
        const nextSiblingHeight = parentNextSibling.offsetHeight;
        document.querySelector(selectors.wrapper).style.top = nextSiblingHeight + 'px';
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }

      var h = siteHeader.offsetHeight;

      // If sticky header is 'active' i.e. we have scrolled a bit down the page
      // the site header has 20px less padding when sticky
      // and this is not factored into the height calculation
      // The 20px is what causes the header to overlap the announcement bar
      // This only applies when the height is being calculated on larger screen sizes
      if (siteHeader.classList.contains('site-header--stuck') && !theme.config.bpSmall) {
        let siteHeaderPadding = parseFloat(window.getComputedStyle(siteHeader, null).getPropertyValue('padding-top'));
        h += siteHeaderPadding * 2;
      }

      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', function(evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(new CustomEvent('predictive-search:open', {
            detail: {
              context: 'header'
            },
            bubbles: true
          }));

          // add is-active class to .site-header__search-container
          document.querySelector(selectors.searchContainer).classList.add('is-active');
        });
      });

      document.addEventListener('predictive-search:close-all', function() {
        closeSearchDrawer();
      });
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');

      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
    }

    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };

  /*============================================================================
    Age Verification Popup
  ==============================================================================*/

  class AgeVerificationPopup extends HTMLElement {
    constructor() {
      super();

      this.cookieName = this.id;
      this.cookie = Cookies.get(this.cookieName);

      this.classes = {
        activeContent: 'age-verification-popup__content--active',
        inactiveContent: 'age-verification-popup__content--inactive',
        inactiveDeclineContent: 'age-verification-popup__decline-content--inactive',
        activeDeclineContent: 'age-verification-popup__decline-content--active',
      }

      this.declineButton = this.querySelector('[data-age-verification-popup-decline-button]');
      this.declineContent = this.querySelector('[data-age-verification-popup-decline-content]');
      this.content = this.querySelector('[data-age-verification-popup-content]');
      this.returnButton = this.querySelector('[data-age-verification-popup-return-button]');
      this.exitButton = this.querySelector('[data-age-verification-popup-exit-button]');
      this.backgroundImage = this.querySelector('[data-background-image]');
      this.mobileBackgroundImage = this.querySelector('[data-mobile-background-image]');

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();
          }
        })

        document.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.init();

            // If 'Test mode' is enabled, remove the cookie we've set
            if (this.dataset.testMode === 'true' && this.cookie) {
              Cookies.remove(this.cookieName);
            }

            // Check session storage if user was editing on the second view
            const secondViewVisited = sessionStorage.getItem(this.id);

            if (!secondViewVisited) return;

            this.showDeclineContent();
          }
        })

        document.addEventListener('shopify:section:unload', (event) => {
          if (event.detail.sectionId === this.dataset.sectionId) {
            this.modal.close();
          }
        })
      }

      // Age verification popup will only be hidden if test mode is disabled AND
      // either a cookie exists OR visibility is toggled in the editor
      if ((this.cookie) && this.dataset.testMode === 'false') return;

      this.init();
    }

    init() {
      this.modal = new theme.Modals(this.id, 'age-verification-popup-modal', {
        closeOffContentClick: false
      });

      if (this.backgroundImage) {
        this.backgroundImage.style.display = 'block';
      }

      if (theme.config.bpSmall && this.mobileBackgroundImage) {
        this.mobileBackgroundImage.style.display = 'block';
      }

      this.modal.open();

      theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));

      if (this.declineButton) {
        this.declineButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.showDeclineContent();

          // If in editor, save to session storage to indicate that user has moved on to the second view
          // Allows view to persist while making changes in the editor
          if (Shopify.designMode) {
            theme.utils.safeStorageSet(sessionStorage, this.id, 'second-view');
          }
        });
      }

      if (this.returnButton) {
        this.returnButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.hideDeclineContent();

          // Remove data from session storage so second view doesn't persist
          const secondViewVisited = sessionStorage.getItem(this.id);

          if (Shopify.designMode && secondViewVisited) {
            sessionStorage.removeItem(this.id);
          }
        })
      }

      if (this.exitButton) {
        this.exitButton.addEventListener('click', (e) => {
          e.preventDefault();

          // We don't want to set a cookie if in test mode
          if (this.dataset.testMode === 'false') {
            Cookies.set(this.cookieName, 'entered', { expires: 30, sameSite: 'none', secure: true });
          }

          if (this.backgroundImage) {
            this.backgroundImage.style.display = 'none';
          }

          if (theme.config.bpSmall && this.mobileBackgroundImage) {
            this.mobileBackgroundImage.style.display = 'none';
          }

          this.modal.close();

          theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector('#MainContent'));
        })
      }
    }

    showDeclineContent() {
      this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
      this.declineContent.classList.add(this.classes.activeDeclineContent);

      this.content.classList.add(this.classes.inactiveContent);
      this.content.classList.remove(this.classes.activeContent);
    }

    hideDeclineContent() {
      this.declineContent.classList.add(this.classes.inactiveDeclineContent);
      this.declineContent.classList.remove(this.classes.activeDeclineContent);

      this.content.classList.remove(this.classes.inactiveContent);
      this.content.classList.add(this.classes.activeContent);
    }
  }

  customElements.define('age-verification-popup', AgeVerificationPopup);



  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {};

    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }

      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });

      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError);
    };

    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };

    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;

      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };

      if (!this.key) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }

    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }

    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting;

      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {

              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      createMap: function() {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };

              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });

              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );

              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });

    return Map;
  })();

  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');

      this.cookieName = 'newsletter-' + sectionId;
      this.cookie = Cookies.get(this.cookieName);

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        hasReminder: container.dataset.hasReminder,
        testMode: container.dataset.testMode
      };

      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function () {
          this.closePopup(true);
        }.bind(this));
      }

      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      if (!this.cookie) {
        this.initPopupDelay();
      }

      // Open modal if triggered by newsletter reminder
      document.addEventListener('reminder:openNewsletter', () => {
        this.modal.open();
      });
    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (this.data.testMode === 'true') {
          return;
        }
        setTimeout(function () {
          const newsletterAppeared = (sessionStorage.getItem('newsletterAppeared') === 'true');
          if (newsletterAppeared) {
            const openReminder = new CustomEvent('newsletter:openReminder', { bubbles: true });
            this.container.dispatchEvent(openReminder);
          } else {
            this.modal.open();
            theme.utils.safeStorageSet(sessionStorage, 'newsletterAppeared', true);
          }

        }.bind(this), this.data.secondsBeforeShow * 1000);
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;
        var hasReminder = (this.data.hasReminder === 'true');
        var reminderAppeared = (sessionStorage.getItem('reminderAppeared') === 'true');

        if (hasReminder && reminderAppeared) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        } else if(!hasReminder) {
          Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
        }
      },

      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      },

      onBlockSelect: function () {
        this.modal.close();
      },

      onBlockDeselect: function () {
        this.modal.open();
      },

      onUnload: function() {
        this.modal.close();
      }
    });

    return NewsletterPopup;
  })();

  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected',
      prevButton: '.pswp__button--arrow--left',
      nextButton: '.pswp__button--arrow--right'
    };

    function Photoswipe(container, sectionId, options) {
      this.container = container;
      this.sectionId = sectionId;
      this.options = options || {};
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
      this._boundSyncHeight = this.syncHeight.bind(this);
      this._iosInitialScrollPos = null;
      this._iosScrollLockActive = false;
      this._pswpArrowButtons = [];

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      triggerClick: function(evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }

        var imageTargets = this.getImageTargets();
        this.items = this.getImageData(imageTargets);

        var activeTarget = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget.closest('.product-main-slide') || evt.currentTarget;
        var index = this.getTargetIndex(activeTarget, imageTargets, this.items);

        if (!this.items.length || index < 1) {
          return;
        }

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }

      // 1-based index required
        return i + 1;
      },

      getImageTargetRoot: function() {
        if (this.options && this.options.sharedImageScopeRoot) {
          return this.options.sharedImageScopeRoot;
        }

        if (this.inSlideshow) {
          return this.container.querySelector(selectors.slideshowTrack) || this.container;
        }

        return this.container;
      },

      getImageTargets: function() {
        var root = this.getImageTargetRoot();
        var slides = root.querySelectorAll('.product-main-slide');

        if (!slides.length) {
          return Array.prototype.slice.call(root.querySelectorAll(selectors.images)).map(function(image) {
            return image.closest('.js-photoswipe__zoom') || image;
          });
        }

        return Array.prototype.slice.call(slides).filter(function(slide) {
          if (slide.dataset.mediaType && slide.dataset.mediaType !== 'image') {
            return false;
          }

          if (!slide.querySelector(selectors.images)) {
            return false;
          }

          return slide.offsetParent !== null;
        });
      },

      getTargetIndex: function(target, targets) {
        if (this.options && typeof this.options.getTargetIndex === 'function') {
          return this.options.getTargetIndex(target, targets, this.items);
        }

        if (!target || !targets || !targets.length) {
          return 0;
        }

        return targets.indexOf(target) + 1;
      },

      getImageData: function(targets) {
        if (this.options && typeof this.options.getItems === 'function') {
          this.images = [];
          return this.options.getItems(targets) || [];
        }

        this.images = (targets || []).map(function(target) {
          return target.matches && target.matches(selectors.images)
            ? target
            : target.querySelector(selectors.images);
        }).filter(Boolean);

        var items = [];

        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var hasMultipleItems = items && items.length > 1;

        this.toggleArrowButtons(pswpElement, hasMultipleItems);

        var options = {
          allowPanToNext: false,
          arrowEl: hasMultipleItems,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          loop: hasMultipleItems,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.listen('destroy', this.resetArrowButtons.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      toggleArrowButtons: function(pswpElement, shouldShow) {
        if (!pswpElement) return;

        var buttons = pswpElement.querySelectorAll(selectors.prevButton + ', ' + selectors.nextButton);
        this._pswpArrowButtons = Array.prototype.slice.call(buttons);

        this._pswpArrowButtons.forEach(function(button) {
          button.style.display = shouldShow ? '' : 'none';
          button.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          button.disabled = !shouldShow;
        });
      },

      resetArrowButtons: function() {
        this._pswpArrowButtons.forEach(function(button) {
          button.style.display = '';
          button.setAttribute('aria-hidden', 'false');
          button.disabled = false;
        });
        this._pswpArrowButtons = [];
      },

      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },

      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        this._iosInitialScrollPos = window.scrollY;
        this._iosScrollLockActive = true;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');

        window.addEventListener('resize', this._boundSyncHeight);

        this.gallery.listen('destroy', () => {
          window.removeEventListener('resize', this._boundSyncHeight);
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, this._iosInitialScrollPos || 0);
          this._iosScrollLockActive = false;
        });
      },

      destroy: function() {
        if (!this.container) return;

        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.off('click' + this.namespace);
        });

        if (this.gallery && typeof this.gallery.close === 'function') {
          this.gallery.close();
        }

        this.resetArrowButtons();

        if (this._iosScrollLockActive) {
          window.removeEventListener('resize', this._boundSyncHeight);
          document.documentElement.classList.remove('pswp-open-in-ios');
          this._iosScrollLockActive = false;
        }

        this.gallery = null;
      }
    });

    return Photoswipe;
  })();


  /*============================================================================
    ProductRecommendations
  ==============================================================================*/

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.url = this.dataset.url;
      this.intent = this.dataset.intent;
      this.placeholder = this.querySelector('.product-recommendations-placeholder');
      this.productResults =  this.querySelector('.grid-product');
      this.sectionId = this.dataset.sectionId;
      this.blockId = this.dataset.blockId;

      document.addEventListener('recommendations:loaded', (e) => {
        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
          this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
          this.colorSwatchHovering();
        }
      });
    }

    connectedCallback() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          if (!this.isConnected) {
            return;
          }

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (!this.isConnected) {
            return;
          }

          if (!recommendations) {
            this.el.classList.add('hide');
            if (AOS) { AOS.refreshHard() }
            return;
          }

          this.placeholder.innerHTML = '';
          this.placeholder.innerHTML = recommendations.innerHTML;

          theme.reinitProductGridItem(this.el);

          this.slideshow = this.querySelector('[data-slideshow]');

          if (this.slideshow) {
            this.setupSlider();
          }

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: this.el,
              intent: this.intent
            }
          }));

        })
        .catch(e => {
          console.error(e);
        });
    }

    setupSlider() {
      const controlType = this.slideshow.dataset.controls;
      const perSlide = parseFloat(this.slideshow.dataset.perSlide);
      const count = parseFloat(this.slideshow.dataset.count);

      let prevNextButtons = false;
      let pageDots = true;

      if (controlType === 'arrows') {
        pageDots = false;
        prevNextButtons = true;
      }

      if (perSlide < count) {
        this.flickity = new theme.Slideshow(this.slideshow, {
          prevNextButtons,
          pageDots,
          adaptiveHeight: true,
          wrapAround: false,
        });
      }
    }

    colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));

        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});

        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }

    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });

      // Unset all active swatches
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });

      // Set active image and swatch
      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);

      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // Update product grid item href with variant URL
      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }

    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  theme.SlideshowSection = (function() {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) { return }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }

    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        this.slideshow.classList.remove('loading', 'loading--delayed');
        this.slideshow.classList.add('loaded');

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
      },

      forceReload: function() {
        this.onUnload();
        this.init();
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        var self = this;

        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });

    return StoreAvailability;
  })();

  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },

      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },

      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },

      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();

  /*============================================================================
    CountdownTimer
  ==============================================================================*/

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.display = this.querySelector('[data-time-display]');
      this.block = this.closest('.countdown__block--timer');
      this.year = this.el.dataset.year;
      this.month = this.el.dataset.month;
      this.day = this.el.dataset.day;
      this.hour = this.el.dataset.hour;
      this.minute = this.el.dataset.minute;
      this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
      this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
      this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
      this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
      this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
      this.hideTimerOnComplete = this.el.dataset.hideTimer;
      this.completeMessage = this.el.dataset.completeMessage;
      this.showTotalHours = this.el.dataset.showTotalHours === 'true';

      this.timerComplete = false;

      this.init();
    }

    init() {
      setInterval(() => {
        if (!this.timerComplete) {
          this._calculate();
        }
      }, 1000);

    }

    _calculate() {
      // Find time difference and convert to integer
      const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
      // If time difference is greater than 0, calculate remaining time
      if (timeDifference > 0) {
        const intervals = {
          days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((timeDifference / 1000 / 60) % 60),
          seconds: Math.floor((timeDifference / 1000) % 60),
        };

        if (this.showTotalHours) {
          intervals.hours += intervals.days * 24;
        }

        if (this.daysPlaceholder) {
          this.daysPlaceholder.innerHTML = intervals.days;
        }
        this.hoursPlaceholder.innerHTML = this.showTotalHours ? String(intervals.hours).padStart(2, '0') : intervals.hours;
        this.minutesPlaceholder.innerHTML = this.showTotalHours ? String(intervals.minutes).padStart(2, '0') : intervals.minutes;
        this.secondsPlaceholder.innerHTML = this.showTotalHours ? String(intervals.seconds).padStart(2, '0') : intervals.seconds;

        setTimeout(() => {
          this.display.classList.add('countdown__display--loaded');
        }, 1);
      } else {
        if (this.completeMessage && this.messagePlaceholder) {
          this.messagePlaceholder.classList.add('countdown__timer-message--visible');
        }

        if (this.hideTimerOnComplete === 'true') {
          this.display.classList.remove('countdown__display--visible');
          this.display.classList.add('countdown__display--hidden');
        }

        if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
          this.block.classList.add('countdown__block--hidden');
        }

        this.timerComplete = true;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);

  /*============================================================================
    HotSpots
  ==============================================================================*/

  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll('[data-button]');
      this.hotspotBlocks = this.querySelectorAll('[data-hotspot-block]');
      this.blockContainer = this.querySelector('[data-block-container]');
      this.colorImages = this.querySelectorAll('.grid-product__color-image');
      this.colorSwatches = this.querySelectorAll('.color-swatch--with-image');

      this._bindEvents();
      this._setupQuickShop();

      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }

    _colorSwatchHovering() {
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this._setActiveColorImage(swatch);
        }.bind(this));

        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this), {passive: true});

        swatch.addEventListener('mouseleave', function() {
          this._removeActiveColorImage(swatch);
        }.bind(this));
      });
    }

    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });

      // Unset all active swatches
      this.colorSwatches.forEach(el => {
        el.classList.remove('is-active');
      });

      // Set active image and swatch
      var imageEl = this.el.querySelector('.grid-product__color-image--' + id);
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest('.grid-item__link');

      if (gridItem) gridItem.setAttribute('href', variantUrl);
    }

    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }

    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach(button => {
        const id = button.dataset.button;

        button.on('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });

      // Display active hotspot block on theme editor select
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }

    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add('is-active');
        } else {
          block.classList.remove('is-active');
        }
      });
    }

    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === 'function') {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === 'function') {
          theme.initQuickShop();
        }

        if (typeof theme.QuickAdd === 'function') {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }

  customElements.define('hot-spots', HotSpots);

  /*============================================================================
    ImageCompare
  ==============================================================================*/

  class ImageCompare extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.sectionId = this.dataset.sectionId;
      this.button = this.querySelector('[data-button]');
      this.draggableContainer = this.querySelector('[data-draggable]');
      this.primaryImage = this.querySelector('[data-primary-image]');
      this.secondaryImage = this.querySelector('[data-secondary-image]');

      this.calculateSizes();

      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2;

      this.el.addEventListener("touchstart", this.dragStart, false);
      this.el.addEventListener("touchend", this.dragEnd, false);
      this.el.addEventListener("touchmove", this.drag, false);

      this.el.addEventListener("mousedown", this.dragStart, false);
      this.el.addEventListener("mouseup", this.dragEnd, false);
      this.el.addEventListener("mousemove", this.drag, false);

      window.on('resize', theme.utils.debounce(250, () => { this.calculateSizes(true)}));

      document.addEventListener('shopify:section:load', event => {
        if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
          this.calculateSizes();
        }
      });
    }

    calculateSizes(hasResized = false) {
      this.active = false;
      this.currentX = 0;
      this.initialX = 0;
      this.xOffset = 0;

      this.buttonOffset = this.button.offsetWidth / 2;

      this.elWidth = this.el.offsetWidth;

      this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;

      if (this.primaryImage) {
        this.primaryImage.style.width = `${this.elWidth}px`;
      }

      if (hasResized) this.draggableContainer.style.width = `${this.elWidth/2}px`;
    }

    dragStart(e) {
      if (e.type === "touchstart") {
        this.initialX = e.touches[0].clientX - this.xOffset;
      } else {
        this.initialX = e.clientX - this.xOffset;
      }

      if (e.target === this.button) {
        this.active = true;
      }
    }

    dragEnd(e) {
      this.initialX = this.currentX;

      this.active = false;
    }

    drag(e) {
      if (this.active) {

        e.preventDefault();

        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }

        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
    }

    setTranslate(xPos, el) {
      let newXpos = xPos - this.buttonOffset;
      let newVal = (this.elWidth/2) + xPos;

      const boundaryPadding = 50;
      const XposMin = (this.elWidth/2 + this.buttonOffset) * -1;
      const XposMax = this.elWidth/2 - this.buttonOffset;

      // Set boundaries for dragging
      if (newXpos < (XposMin + boundaryPadding)) {
        newXpos = XposMin + boundaryPadding;
        newVal = boundaryPadding
      } else if (newXpos > (XposMax - boundaryPadding)) {
        newXpos = XposMax - boundaryPadding;
        newVal = this.elWidth - boundaryPadding;
      }

      el.style.transform = `translate(${newXpos}px, -50%)`;
      this.draggableContainer.style.width = `${newVal}px`;
    }
  }

  customElements.define('image-compare', ImageCompare);



  theme.Blog = (function() {



    function Blog(container) {

      this.tagFilters();

    }



    Blog.prototype = Object.assign({}, Blog.prototype, {

      tagFilters: function() {

        var filterBy = document.getElementById('BlogTagFilter');



        if (!filterBy) {

          return;

        }



        filterBy.addEventListener('change', function() {

          location.href = filterBy.value;

        });

      }

    });



    return Blog;

  })();


  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        heroImageContainer.classList.remove('loading', 'loading--delayed');
        heroImageContainer.classList.add('loaded');
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      }
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function() {
    var selectors = {
      sidebar: '#CollectionSidebar',
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
      this.drawerStyle = false;
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        // Do not load when no sidebar exists
        if(!this.container) {
          return;
        }

        this.onUnload();

        this.drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },

      forceReload: function() {
        this.init();
      },

      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!this.drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (this.drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },

      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },

      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });

    return CollectionSidebar;
  })();

  theme.MaterialSwatchCard = (function(){

    function MaterialSwatchCard(container) {
      this.container = container;
      this.swatchInputs = [];

      this.selectors = {
        swatchInput: '[data-material-swatch-input]',
        variantImage: '[data-variant-image]',
        variantURL: '[data-variant-url]',
      };

      this.init();
    }

    MaterialSwatchCard.prototype = Object.assign({}, MaterialSwatchCard.prototype, {
      init: function() {
        this.swatchInputs = Array.prototype.slice.call(
          this.container.querySelectorAll(this.selectors.swatchInput)
        );
        if (!this.swatchInputs.length) return;

        var initialVariantId = this.container.dataset.initialVariantId || '';
        var initialInput = this.swatchInputs.find(function(input) {
          return !input.disabled && String(input.dataset.variantId) === String(initialVariantId);
        }) || this.swatchInputs.find(function(input) {
          return !input.disabled;
        }) || this.swatchInputs[0];

        this._boundOnSwatchChange = this.onSwatchChange.bind(this);
        this.swatchInputs.forEach(function(input) {
          input.addEventListener('change', this._boundOnSwatchChange);
        }.bind(this));

        initialInput.checked = true;
        this.selectSwatch(initialInput);
      },

      onSwatchChange: function(evt) {
        var input = evt.currentTarget;
        if (input.disabled) return;
        this.selectSwatch(input);
      },

      selectSwatch: function(input) {
        var variantId = input.dataset.variantId;
        if (!variantId) return;

        this.updateVariantImage(input);
        this.updateVariantUrl(variantId);
      },

      updateVariantImage: function(input) {
        var featuredImageSrc = input.dataset.variantImageSrc;
        if (featuredImageSrc) {
          var imageContainer = this.container.querySelector(this.selectors.variantImage);
          var image = imageContainer ? imageContainer.querySelector('img') : null;
          if (!image) return;

          var imageWidths = [360, 540, 720, 900, 1080];
          var sizedImageUrl = function(src, width) {
            try {
              var url = new URL(src, window.location.origin);
              url.searchParams.set('width', width);
              return url.toString();
            } catch (error) {
              var separator = src.indexOf('?') === -1 ? '?' : '&';
              return src + separator + 'width=' + width;
            }
          };

          image.srcset = imageWidths.map(function(width) {
            return sizedImageUrl(featuredImageSrc, width) + ' ' + width + 'w';
          }).join(', ');
          image.src = sizedImageUrl(featuredImageSrc, 1080);
          image.alt = input.dataset.variantImageAlt || image.alt || '';

          var imageWidth = Number(input.dataset.variantImageWidth) || null;
          var imageHeight = Number(input.dataset.variantImageHeight) || null;
          if (imageWidth) {
            image.width = imageWidth;
          }
          if (imageHeight) {
            image.height = imageHeight;
          }

          var aspectRatio = Number(input.dataset.variantImageAspectRatio) || null;
          if (!aspectRatio && imageWidth && imageHeight) {
            aspectRatio = imageWidth / imageHeight;
          }
          if (imageContainer.classList.contains('image-wrap') && aspectRatio) {
            imageContainer.style.paddingBottom = (100 / aspectRatio) + '%';
          }
        }
      },

      updateVariantUrl: function(variantId) {
        this.container.querySelectorAll(this.selectors.variantURL).forEach(function(el) {
          if (!el.href) return;

          var url = new URL(el.href, window.location.origin);
          url.searchParams.set('variant', variantId);
          el.href = url.toString();
        });
      },

      destroy: function() {
        this.swatchInputs.forEach(function(input) {
          input.removeEventListener('change', this._boundOnSwatchChange);
        }.bind(this));

        this._boundOnSwatchChange = null;
        this.swatchInputs = [];
      }

    });

    return MaterialSwatchCard;
  })();

  class MaterialSwatchCardElement extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      var card = this.closest('.custom-product-card');
      if (card) {
        this.controller = new theme.MaterialSwatchCard(card);
      }
    }

    disconnectedCallback() {
      if (this.controller) {
        this.controller.destroy();
        this.controller = null;
      }
    }
  }

  if (!customElements.get('material-swatch-card')) {
    customElements.define('material-swatch-card', MaterialSwatchCardElement);
  }

  theme.Collection = (function() {
    var isAnimating = false;

    var selectors = {
      sortSelect: '[data-sort-select]',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',

      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };

    var collectionFilterState = {
      getParamValue: function(params, key, fallbackValue) {
        if (!key) return fallbackValue;
        var value = params.get(key);
        return value !== null && value !== '' ? value : fallbackValue;
      },

      getResultCount: function(root) {
        if (!root || !root.querySelector) return null;
        var countEl = root.querySelector('[data-collection-count-value]');
        if (!countEl) return null;
        var countValue = parseInt(countEl.getAttribute('data-collection-count-value'), 10);
        return Number.isNaN(countValue) ? null : countValue;
      },

      syncOptionState: function(el) {
        if (!el || !el.classList || !el.classList.contains('tag__input')) return;
        var option = el.closest('.tag');
        if (!option) return;

        if (el.type === 'radio') {
          var formEl = el.closest('form');
          if (formEl && el.name) {
            formEl.querySelectorAll('input.tag__input[type="radio"][name="' + CSS.escape(el.name) + '"]').forEach(function(input) {
              var inputOption = input.closest('.tag');
              if (inputOption) inputOption.classList.toggle('tag--active', input.checked);
            });
          }
          return;
        }

        option.classList.toggle('tag--active', el.checked);
      },

      syncAllOptionStates: function(root) {
        if (!root) return;
        root.querySelectorAll('.tag__input').forEach(function(input) {
          var option = input.closest('.tag');
          if (option) option.classList.toggle('tag--active', input.checked);
        });
      },

      syncFormWithSearchParams: function(formEl, searchParams) {
        if (!formEl) return;
        formEl.querySelectorAll('.tag__input').forEach(function(input) {
          input.checked = searchParams.getAll(input.name).includes(input.value);
        });

        formEl.querySelectorAll(selectors.priceRange).forEach(function(priceRangeEl) {
          var minValue = collectionFilterState.getParamValue(searchParams, priceRangeEl.dataset.minName, priceRangeEl.dataset.min);
          var maxValue = collectionFilterState.getParamValue(searchParams, priceRangeEl.dataset.maxName, priceRangeEl.dataset.max);
          var inputMinEl = priceRangeEl.querySelector('.price-range__input-min');
          var inputMaxEl = priceRangeEl.querySelector('.price-range__input-max');

          priceRangeEl.dataset.minValue = minValue;
          priceRangeEl.dataset.maxValue = maxValue;
          if (inputMinEl) inputMinEl.value = minValue;
          if (inputMaxEl) inputMaxEl.value = maxValue;
        });
      }
    };

    function CollectionFilterDrawerController(collection) {
      this.collection = collection;
      this.requestId = 0;
      this.committedParams = new URLSearchParams(window.location.search);
      this.pendingParams = null;
      this.previewResponse = null;
      this.loading = false;
      this.button = null;
      this.clearButton = null;
      this.summaryEl = null;
      this.buttonTextEl = null;
      this.abortController = null;
      this.boundViewResultsClick = null;
      this.boundClearClick = null;
      this.boundActiveTagClick = null;
      this.boundDrawerClose = null;
      this.isApplyingViewResults = false;
    }

    CollectionFilterDrawerController.prototype = Object.assign({}, CollectionFilterDrawerController.prototype, {
      isEnabled: function() {
        return Boolean(
          this.collection.container.querySelector('#FilterDrawer[data-filter-apply-mode="staged"]')
        );
      },

      destroy: function() {
        if (this.button && this.boundViewResultsClick) {
          this.button.removeEventListener('click', this.boundViewResultsClick);
        }

        if (this.clearButton && this.boundClearClick) {
          this.clearButton.removeEventListener('click', this.boundClearClick);
        }

        if (this.boundDrawerClose) {
          document.removeEventListener('drawerClose.FilterDrawer', this.boundDrawerClose);
        }

        this.abortPrefetch();
        this.pendingParams = null;
        this.previewResponse = null;
        this.isApplyingViewResults = false;
        this.button = null;
        this.clearButton = null;
        this.summaryEl = null;
        this.buttonTextEl = null;
        this.boundViewResultsClick = null;
        this.boundClearClick = null;
        this.boundActiveTagClick = null;
        this.boundDrawerClose = null;
        this.loading = false;
      },

      init: function() {
        this.destroy();

        if (!this.isEnabled()) {
          return;
        }

        this.committedParams = new URLSearchParams(window.location.search);
        this.pendingParams = null;
        this.previewResponse = null;
        this.isApplyingViewResults = false;

        this.button = this.collection.container.querySelector('[data-drawer-view-results]');
        this.clearButton = this.collection.container.querySelector('[data-drawer-clear-filters]');
        this.summaryEl = this.collection.container.querySelector('[data-drawer-filter-summary]');
        this.buttonTextEl = this.collection.container.querySelector('[data-drawer-view-results-text]');
        if (!this.button) {
          return;
        }

        this.boundViewResultsClick = this.onViewResultsClick.bind(this);
        this.boundClearClick = this.onClearClick.bind(this);
        this.boundActiveTagClick = this.onActiveTagClick.bind(this);
        this.boundDrawerClose = this.onDrawerClose.bind(this);
        this.button.addEventListener('click', this.boundViewResultsClick);
        if (this.clearButton) {
          this.clearButton.addEventListener('click', this.boundClearClick);
        }
        document.addEventListener('drawerClose.FilterDrawer', this.boundDrawerClose);

        this.syncDrawerMeta();
        this.updateButtonState();
      },

      isDrawerForm: function(formEl) {
        return this.isEnabled() && Boolean(formEl && formEl.closest('#FilterDrawer'));
      },

      isDrawerElement: function(el) {
        return this.isEnabled() && Boolean(el && el.closest('#FilterDrawer'));
      },

      getCommittedParams: function() {
        return new URLSearchParams(this.committedParams.toString());
      },

      getCurrentDrawerForm: function() {
        return this.collection.container.querySelector('#FilterDrawer form');
      },

      getSelectionCount: function(formEl) {
        var count = 0;

        if (!formEl) {
          return count;
        }

        count += formEl.querySelectorAll('.tag__input:checked').length;

        formEl.querySelectorAll(selectors.priceRange).forEach(function(priceRangeEl) {
          var minValue = priceRangeEl.dataset.minValue || priceRangeEl.dataset.min;
          var maxValue = priceRangeEl.dataset.maxValue || priceRangeEl.dataset.max;

          if (String(minValue) !== String(priceRangeEl.dataset.min) || String(maxValue) !== String(priceRangeEl.dataset.max)) {
            count += 1;
          }
        });

        return count;
      },

      getResultCountFromRoot: function(root) {
        return collectionFilterState.getResultCount(root);
      },

      updateSummary: function(formEl) {
        if (!this.summaryEl) {
          return;
        }

        var label = this.summaryEl.dataset.label || '__COUNT__';
        this.summaryEl.textContent = label.replace('__COUNT__', this.getSelectionCount(formEl));
      },

      updateViewResultsText: function(resultCount) {
        if (!this.buttonTextEl) {
          return;
        }
        this.buttonTextEl.textContent = this.buttonTextEl.dataset.label || this.buttonTextEl.textContent;
      },

      syncGroupTitles: function(formEl) {
        if (!formEl) {
          return;
        }

        formEl.querySelectorAll('[data-filter-group-title]').forEach(function(titleEl) {
          var groupIndex = titleEl.getAttribute('data-filter-group-title-index');
          var groupContainer = formEl.querySelector('[data-filter-group-index="' + groupIndex + '"]');
          var valueEl = titleEl.querySelector('[data-filter-group-value]');
          var activeInputs = groupContainer
            ? Array.prototype.slice.call(groupContainer.querySelectorAll('.tag__input:checked'))
            : [];
          var activeLabels = activeInputs.map(function(activeInput) {
            var label = activeInput.closest('label');
            var labelTextEl = label && label.querySelector('.tag__text');
            return labelTextEl ? labelTextEl.textContent.trim() : activeInput.value;
          });

          if (!valueEl) {
            return;
          }

          valueEl.textContent = activeLabels.length ? ': ' + activeLabels.join(', ') : '';
        });
      },

      syncDrawerMeta: function(formEl, resultCount) {
        var activeFormEl = formEl || this.getCurrentDrawerForm();
        var resolvedCount = typeof resultCount === 'number' ? resultCount : this.getResultCountFromRoot(this.collection.container);

        this.updateSummary(activeFormEl);
        this.syncGroupTitles(activeFormEl);
        this.updateViewResultsText(resolvedCount);
      },

      syncFormWithCommittedState: function(formEl) {
        this.syncFormWithSearchParams(formEl, this.getCommittedParams());
      },

      syncFormWithSearchParams: function(formEl, searchParams) {
        collectionFilterState.syncFormWithSearchParams(formEl, searchParams);
      },

      discardPreview: function(resetFormState) {
        this.abortPrefetch();
        this.pendingParams = null;
        this.previewResponse = null;
        this.setLoading(false);

        if (!resetFormState) {
          return;
        }

        this.collection.container.querySelectorAll('#FilterDrawer form').forEach(function(formEl) {
          this.syncFormWithCommittedState(formEl);
          this.syncAllOptionStates(formEl);
          this.syncActiveTags(formEl);
          this.syncDrawerMeta(formEl);
        }.bind(this));

        this.collection.initPriceRange();
      },

      syncOptionState: function(el) {
        collectionFilterState.syncOptionState(el);
      },

      syncAllOptionStates: function(formEl) {
        collectionFilterState.syncAllOptionStates(formEl);
      },

      syncActiveTags: function(formEl) {
        if (!formEl) {
          return;
        }

        var activeTagLists = formEl.querySelectorAll('.tag-list--active-tags');
        if (!activeTagLists.length) {
          return;
        }

        var currentParams = this.getCommittedParams();
        var formParams = new URLSearchParams(new FormData(formEl));
        var appliedParams = this.collection.ajaxRenderer.getUpdatedParams(currentParams, formParams);
        var activeInputs = Array.prototype.slice.call(
          formEl.querySelectorAll('.tag__input:checked')
        );
        var hasActiveFilters = this.getSelectionCount(formEl) > 0;

        activeTagLists.forEach(function(list) {
          list.innerHTML = '';

          if (hasActiveFilters) {
            var clearParams = new URLSearchParams(appliedParams.toString());
            Array.from(clearParams.keys()).forEach(function(key) {
              if (key.indexOf('filter.') === 0 || key === 'page') {
                clearParams.delete(key);
              }
            });
            var clearTag = document.createElement('li');
            var clearLink = document.createElement('a');
            clearTag.classList.add('tag', 'tag--remove', 'tag--clear-all');
            clearLink.classList.add('active-filter-tag', 'active-filter-tag--clear');
            clearLink.href = window.location.pathname + (clearParams.toString() ? '?' + clearParams.toString() : '');
            clearLink.textContent = formEl.dataset.clearAllLabel || 'Clear All';
            clearLink.setAttribute('data-clear-all-filters', '');
            clearLink.addEventListener('click', this.boundActiveTagClick);
            clearTag.appendChild(clearLink);
            list.appendChild(clearTag);
          }
        });

        activeInputs.forEach(function(input) {
          var labelTextEl = input.closest('label') && input.closest('label').querySelector('.tag__text');
          var labelText = labelTextEl ? labelTextEl.textContent.trim() : input.value;
          var removeParams = new URLSearchParams(appliedParams.toString());
          var retainedValues = removeParams.getAll(input.name).filter(function(value) {
            return value !== input.value;
          });

          removeParams.delete(input.name);
          retainedValues.forEach(function(value) {
            removeParams.append(input.name, value);
          });

          activeTagLists.forEach(function(list) {
            var newTag = document.createElement('li');
            var newTagLink = document.createElement('a');
            var valueWrap = document.createElement('span');
            var valueLabel = document.createElement('span');
            var removeWrap = document.createElement('span');
            var closeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            var closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            var href = window.location.pathname + (removeParams.toString() ? '?' + removeParams.toString() : '');

            newTag.classList.add('tag', 'tag--remove');
            newTagLink.classList.add('active-filter-tag');
            newTagLink.href = href;
            newTagLink.addEventListener('click', this.boundActiveTagClick);
            valueWrap.classList.add('active-filter-tag__value');
            valueLabel.textContent = labelText;
            valueWrap.appendChild(valueLabel);
            removeWrap.classList.add('active-filter-tag__remove');
            removeWrap.setAttribute('aria-hidden', 'true');

            closeIcon.setAttribute('aria-hidden', 'true');
            closeIcon.setAttribute('focusable', 'false');
            closeIcon.setAttribute('role', 'presentation');
            closeIcon.setAttribute('viewBox', '0 0 64 64');

            closePath.setAttribute('d', 'M19 17.61l27.12 27.13m0-27.12L19 44.74');
            closeIcon.appendChild(closePath);

            removeWrap.appendChild(closeIcon);
            newTagLink.appendChild(valueWrap);
            newTagLink.appendChild(removeWrap);
            newTag.appendChild(newTagLink);
            list.appendChild(newTag);
          }.bind(this));
        }.bind(this));

        this.syncDrawerMeta(formEl);
      },

      updateButtonState: function() {
        if (!this.button) {
          return;
        }

        var isDisabled = this.loading;

        this.button.disabled = isDisabled;
        this.button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      },

      setLoading: function(isLoading) {
        this.loading = isLoading;

        if (!this.button) {
          return;
        }

        this.button.classList.toggle('btn--loading', isLoading);
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.updateButtonState();
      },

      abortPrefetch: function() {
        this.requestId += 1;

        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      },

      prefetch: function(searchParams) {
        var currentParams = this.getCommittedParams();
        var updatedParams = this.collection.ajaxRenderer.getUpdatedParams(currentParams, searchParams);
        var section = this.collection.ajaxRenderer.sections[0];
        var requestId = 0;
        var requestUrl = new URL(window.location.pathname, window.location.origin);

        if (!this.isEnabled()) {
          return;
        }

        this.abortPrefetch();

        if (updatedParams.toString() === currentParams.toString()) {
          this.pendingParams = null;
          this.previewResponse = null;
          this.setLoading(false);
          return;
        }

        requestId = this.requestId;

        requestUrl.searchParams.set('section_id', section.sectionId);
        updatedParams.forEach(function(value, key) {
          requestUrl.searchParams.append(key, value);
        });

        this.pendingParams = updatedParams;
        this.previewResponse = null;
        this.setLoading(true);

        if (window.AbortController) {
          this.abortController = new AbortController();
        }

        fetch(requestUrl.toString(), this.abortController ? { signal: this.abortController.signal } : undefined)
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Drawer filter preview failed: ' + response.status);
            }

            return response.text();
          })
          .then(function(html) {
            var previewDom = null;

            if (requestId !== this.requestId) {
              return;
            }

            previewDom = new DOMParser().parseFromString(html, 'text/html');

            this.previewResponse = {
              html: html,
              searchParams: updatedParams,
              section: section,
              resultCount: this.getResultCountFromRoot(previewDom),
            };

            this.abortController = null;
            this.syncDrawerMeta(this.getCurrentDrawerForm(), this.previewResponse.resultCount);
            this.setLoading(false);
          }.bind(this))
          .catch(function(error) {
            if (requestId !== this.requestId) {
              return;
            }

            this.abortController = null;

            if (error.name === 'AbortError') {
              return;
            }

            console.error(error);
            this.pendingParams = null;
            this.previewResponse = null;
            this.syncDrawerMeta(this.getCurrentDrawerForm());
            this.setLoading(false);
          }.bind(this));
      },

      applyPreviewResponse: function(previewResponse) {
        var newDom = new DOMParser().parseFromString(previewResponse.html, 'text/html');

        this.collection.onReplaceAjaxContent(newDom, previewResponse.section);
        this.collection.ajaxRenderer.updateURLHash(previewResponse.searchParams);
        theme.sections.reinit('collection-grid');
        this.collection.updateScroll(false);
        this.collection.initPriceRange();
        theme.reinitProductGridItem();

        document.dispatchEvent(new CustomEvent('collection:reloaded'));

        this.pendingParams = null;
        this.previewResponse = null;
        this.syncDrawerMeta(this.getCurrentDrawerForm(), this.getResultCountFromRoot(document));
        this.setLoading(false);
        isAnimating = false;
      },

      onActiveTagClick: function(evt) {
        var el = evt.currentTarget;
        var formEl = el.closest('form');

        evt.preventDefault();
        evt.stopPropagation();

        if (el.hasAttribute('data-clear-all-filters')) {
          this.abortPrefetch();
          this.pendingParams = null;
          this.previewResponse = null;
          this.isApplyingViewResults = true;
          this.collection.clearAllFilters();
          return;
        }

        var targetUrl = new URL(el.href, window.location.origin);

        this.syncFormWithSearchParams(formEl, targetUrl.searchParams);
        this.syncAllOptionStates(formEl);
        this.syncActiveTags(formEl);
        this.prefetch(targetUrl.searchParams);
      },

      onDrawerClose: function() {
        if (this.isApplyingViewResults) {
          this.isApplyingViewResults = false;
          return;
        }

        if (this.pendingParams || this.previewResponse) {
          this.discardPreview(true);
        }
      },

      onClearClick: function(evt) {
        evt.preventDefault();
        this.abortPrefetch();
        this.pendingParams = null;
        this.previewResponse = null;
        this.isApplyingViewResults = true;
        this.collection.clearAllFilters();
      },

      onViewResultsClick: function(evt) {
        evt.preventDefault();

        if (this.loading) {
          return;
        }

        if (!this.previewResponse && !this.pendingParams) {
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }

          return;
        }

        if (!this.previewResponse) {
          this.discardPreview(true);

          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }

          return;
        }

        if (theme.FilterDrawer) {
          this.isApplyingViewResults = true;
          theme.FilterDrawer.close();
        }

        if (this.previewResponse) {
          isAnimating = true;
          this.collection.startLoading();
          this.committedParams = new URLSearchParams(this.previewResponse.searchParams.toString());
          this.applyPreviewResponse(this.previewResponse);
          return;
        }
      }
    });

    function CollectionSortDropdownController(collection) {
      this.collection = collection;
      this.activeRoot = null;
      this.boundClick = this.onClick.bind(this);
      this.boundDocumentClick = this.onDocumentClick.bind(this);
      this.boundKeydown = this.onKeydown.bind(this);
    }

    CollectionSortDropdownController.prototype = Object.assign({}, CollectionSortDropdownController.prototype, {
      init: function() {
        this.destroy();
        if (!this.collection.container.querySelector('[data-custom-sort]')) return;

        this.collection.container.addEventListener('click', this.boundClick);
        this.collection.container.addEventListener('keydown', this.boundKeydown);
        document.addEventListener('click', this.boundDocumentClick);
      },

      destroy: function() {
        this.collection.container.removeEventListener('click', this.boundClick);
        this.collection.container.removeEventListener('keydown', this.boundKeydown);
        document.removeEventListener('click', this.boundDocumentClick);
        this.close();
      },

      onClick: function(evt) {
        var trigger = evt.target.closest('[data-custom-sort-trigger]');
        var option = evt.target.closest('[data-custom-sort-option]');
        var root;

        if (trigger) {
          evt.preventDefault();
          root = trigger.closest('[data-custom-sort]');
          this.toggle(root);
          return;
        }

        if (!option) return;
        evt.preventDefault();
        root = option.closest('[data-custom-sort]');
        this.select(root, option);
      },

      onDocumentClick: function(evt) {
        if (this.activeRoot && !this.activeRoot.contains(evt.target)) {
          this.close();
        }
      },

      onKeydown: function(evt) {
        var root = evt.target.closest('[data-custom-sort]');
        if (!root) return;

        if (evt.key === 'Escape') {
          evt.preventDefault();
          this.close(true);
          return;
        }

        if (evt.key === 'ArrowDown' && evt.target.matches('[data-custom-sort-trigger]')) {
          evt.preventDefault();
          this.open(root);
          var selected = root.querySelector('[data-custom-sort-option][aria-selected="true"]');
          var first = root.querySelector('[data-custom-sort-option]');
          if (selected || first) {
            (selected || first).focus();
          }
        }
      },

      toggle: function(root) {
        if (this.activeRoot === root) {
          this.close();
        } else {
          this.open(root);
        }
      },

      open: function(root) {
        this.close();
        var trigger = root && root.querySelector('[data-custom-sort-trigger]');
        var menu = root && root.querySelector('[data-custom-sort-menu]');
        if (!trigger || !menu) return;
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        root.classList.add('is-open');
        this.activeRoot = root;
      },

      close: function(restoreFocus) {
        if (!this.activeRoot) return;
        var trigger = this.activeRoot.querySelector('[data-custom-sort-trigger]');
        var menu = this.activeRoot.querySelector('[data-custom-sort-menu]');
        if (menu) menu.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        this.activeRoot.classList.remove('is-open');
        if (restoreFocus && trigger) trigger.focus();
        this.activeRoot = null;
      },

      select: function(root, option) {
        var select = root && root.parentElement.querySelector('[data-sort-select]');
        var label = root && root.querySelector('[data-custom-sort-label]');
        if (!select || !option) return;

        select.value = option.dataset.value;
        if (label) label.textContent = option.textContent.trim();
        root.querySelectorAll('[data-custom-sort-option]').forEach(function(item) {
          item.setAttribute('aria-selected', item === option ? 'true' : 'false');
        });
        this.close();
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    function CollectionFilterRailController(collection) {
      this.collection = collection;
      this.rails = [];
    }

    CollectionFilterRailController.prototype = Object.assign({}, CollectionFilterRailController.prototype, {
      init: function() {
        this.destroy();

        this.collection.container.querySelectorAll('[data-filter-rail]').forEach(function(root) {
          var viewport = root.querySelector('[data-filter-rail-viewport]');
          var content = root.querySelector('[data-filter-rail-content]') || root.querySelector('.custom-filter-inline__items');
          var prevButton = root.querySelector('[data-filter-rail-prev]');
          var nextButton = root.querySelector('[data-filter-rail-next]');
          var controller = sharedCreateScrollableRail({
            root: root,
            viewport: viewport,
            content: content,
            prevButton: prevButton,
            nextButton: nextButton,
            measureMode: 'content',
            tolerance: 2,
            boundaryTolerance: 8,
            getActiveElement: function() {
              var checkedInput = root.querySelector('.tag__input:checked');
              return checkedInput ? checkedInput.closest('.horizontal-filter') : null;
            }
          });

          if (controller) {
            controller.init();
            this.rails.push(controller);
          }
        }.bind(this));
      },

      destroy: function() {
        this.rails.forEach(function(controller) {
          controller.destroy();
        });
        this.rails = [];
      }
    });

    function CollectionDesktopFilterDrawerController(collection) {
      this.collection = collection;
      this.popovers = [];
      this.activePopover = null;
      this.activeTrigger = null;
      this.abortController = null;
      this.requestId = 0;
      this.previewResponse = null;
      this.pendingParams = null;
      this.dirty = false;
      this.applying = false;
      this.boundClick = this.onClick.bind(this);
      this.boundDrawerOpen = this.onDrawerOpen.bind(this);
      this.boundDocumentClick = this.onDocumentClick.bind(this);
      this.boundKeyup = this.onKeyup.bind(this);
    }

    CollectionDesktopFilterDrawerController.prototype = Object.assign({}, CollectionDesktopFilterDrawerController.prototype, {
      init: function() {
        this.destroy();
        this.popovers = Array.prototype.slice.call(
          this.collection.container.querySelectorAll('[data-desktop-filter-drawer]')
        );

        if (!this.popovers.length) {
          return;
        }

        this.collection.container.addEventListener('click', this.boundClick);
        document.addEventListener('drawerOpen', this.boundDrawerOpen);
        document.addEventListener('click', this.boundDocumentClick);
        document.addEventListener('keyup', this.boundKeyup);
      },

      destroy: function() {
        this.abortPreview();
        document.documentElement.classList.remove('js-desktop-filter-drawer-open');
        this.collection.container.removeEventListener('click', this.boundClick);
        document.removeEventListener('drawerOpen', this.boundDrawerOpen);
        document.removeEventListener('click', this.boundDocumentClick);
        document.removeEventListener('keyup', this.boundKeyup);

        this.popovers = [];
        this.activePopover = null;
        this.activeTrigger = null;
        this.previewResponse = null;
        this.pendingParams = null;
        this.dirty = false;
        this.applying = false;
      },

      isDrawerElement: function(element) {
        return Boolean(element && element.closest && element.closest('[data-desktop-filter-drawer]'));
      },

      onClick: function(evt) {
        var trigger = evt.target.closest('[data-desktop-filter-drawer-trigger]');
        var closeButton = evt.target.closest('[data-desktop-filter-drawer-close]');
        var clearButton = evt.target.closest('[data-desktop-filter-drawer-clear]');
        var applyButton = evt.target.closest('[data-desktop-filter-drawer-apply]');
        var popover = null;

        if (trigger) {
          this.activeTrigger = trigger;
          evt.preventDefault();
          popover = this.getPopoverForTrigger(trigger);
          if (popover) {
            this.togglePopover(popover, trigger);
          }
          return;
        }

        if (closeButton) {
          evt.preventDefault();
          this.closePopover(closeButton.closest('[data-desktop-filter-drawer]'));
          return;
        }

        if (clearButton) {
          evt.preventDefault();
          popover = clearButton.closest('[data-desktop-filter-drawer]');
          this.clearPopover(popover);
          return;
        }

        if (applyButton) {
          evt.preventDefault();
          this.apply(applyButton.closest('[data-desktop-filter-drawer]'));
        }
      },

      onInput: function(input, formData, popover) {
        var activePopover = popover || (input && input.closest('[data-desktop-filter-drawer]'));
        var form = activePopover && activePopover.closest('form');

        if (!activePopover || !form) {
          return;
        }

        if (input) {
          collectionFilterState.syncOptionState(input);
        }

        this.activePopover = activePopover;
        this.dirty = true;
        this.prefetch(formData || new FormData(form), activePopover);
      },

      clearPopover: function(popover) {
        var form = popover && popover.closest('form');
        if (!form) {
          return;
        }

        popover.querySelectorAll('.tag__input').forEach(function(input) {
          input.checked = false;
        });

        popover.querySelectorAll(selectors.priceRange).forEach(function(priceRange) {
          priceRange.dataset.minValue = priceRange.dataset.min;
          priceRange.dataset.maxValue = priceRange.dataset.max;
          var minInput = priceRange.querySelector('.price-range__input-min');
          var maxInput = priceRange.querySelector('.price-range__input-max');
          if (minInput) minInput.value = priceRange.dataset.min;
          if (maxInput) maxInput.value = priceRange.dataset.max;
        });

        collectionFilterState.syncAllOptionStates(popover);
        this.collection.initPriceRange();
        this.activePopover = popover;
        this.dirty = true;
        this.prefetch(new FormData(form), popover);
      },

      prefetch: function(formData, popover) {
        var currentParams = new URLSearchParams(window.location.search);
        var formParams = new URLSearchParams(formData);
        var updatedParams = this.collection.ajaxRenderer.getUpdatedParams(currentParams, formParams);
        var section = this.collection.ajaxRenderer.sections[0];
        var requestUrl = new URL(window.location.pathname, window.location.origin);
        var requestId = 0;

        this.abortPreview();
        this.pendingParams = updatedParams;
        this.previewResponse = null;
        this.setLoading(popover, true);

        if (updatedParams.toString() === currentParams.toString()) {
          this.pendingParams = null;
          this.dirty = false;
          this.setLoading(popover, false);
          this.updateApplyText(popover, null);
          return;
        }

        requestId = this.requestId;
        requestUrl.searchParams.set('section_id', section.sectionId);
        updatedParams.forEach(function(value, key) {
          requestUrl.searchParams.append(key, value);
        });

        if (window.AbortController) {
          this.abortController = new AbortController();
        }

        fetch(requestUrl.toString(), this.abortController ? { signal: this.abortController.signal } : undefined)
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Filter popover preview failed: ' + response.status);
            }
            return response.text();
          })
          .then(function(html) {
            if (requestId !== this.requestId) {
              return;
            }

            var previewDom = new DOMParser().parseFromString(html, 'text/html');
            this.previewResponse = {
              html: html,
              searchParams: updatedParams,
              section: section,
            };
            this.abortController = null;
            this.updateApplyText(popover, collectionFilterState.getResultCount(previewDom));
            this.setLoading(popover, false);
          }.bind(this))
          .catch(function(error) {
            if (requestId !== this.requestId || error.name === 'AbortError') {
              return;
            }
            console.error(error);
            this.abortController = null;
            this.previewResponse = null;
            this.setLoading(popover, false);
            this.updateApplyText(popover, null);
          }.bind(this));
      },

      apply: function(popover) {
        if (!popover || popover.querySelector('[data-desktop-filter-drawer-apply][aria-busy="true"]')) {
          return;
        }

        if (!this.pendingParams) {
          this.closePopover(popover);
          return;
        }

        if (!this.previewResponse) {
          var pendingParams = new URLSearchParams(this.pendingParams.toString());
          this.applying = true;
          this.closePopover(popover);
          isAnimating = true;
          this.collection.startLoading();
          this.collection.renderCollectionPage(pendingParams);
          return;
        }

        var previewResponse = this.previewResponse;
        var newDom = new DOMParser().parseFromString(previewResponse.html, 'text/html');
        this.applying = true;
        this.closePopover(popover);
        isAnimating = true;
        this.collection.startLoading();
        this.collection.onReplaceAjaxContent(newDom, previewResponse.section);
        this.collection.ajaxRenderer.updateURLHash(previewResponse.searchParams);
        theme.sections.reinit('collection-grid');
        this.collection.updateScroll(false);
        this.collection.initPriceRange();
        theme.reinitProductGridItem();
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
        isAnimating = false;
      },

      abortPreview: function() {
        this.requestId += 1;
        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      },

      setLoading: function(popover, loading) {
        var button = popover && popover.querySelector('[data-desktop-filter-drawer-apply]');
        if (!button) return;
        button.disabled = loading;
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
      },

      updateApplyText: function(popover, resultCount) {
        var text = popover && popover.querySelector('[data-desktop-filter-drawer-apply-text]');
        if (!text) return;
        text.textContent = text.dataset.label || text.textContent;
      },

      handleToggle: function(popover, open) {
        var trigger = this.collection.container.querySelector('[aria-controls="' + CSS.escape(popover.id) + '"]');
        popover.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (popover.classList.contains('desktop-filter-drawer')) {
          document.documentElement.classList.toggle('js-desktop-filter-drawer-open', open);
        }
        if (trigger) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        if (open) {
          this.activePopover = popover;
          this.activeTrigger = trigger;
          window.requestAnimationFrame(function() {
            var focusTarget = popover.querySelector('.tag__input:not(:disabled), .price-range__input, [data-desktop-filter-drawer-close]');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          });
          return;
        }

        if (!this.applying && this.dirty) {
          this.resetForm(popover.closest('form'));
        }

        if (trigger && !this.applying) {
          trigger.focus({ preventScroll: true });
        }

        this.abortPreview();
        this.previewResponse = null;
        this.pendingParams = null;
        this.dirty = false;
        this.activePopover = null;
      },

      resetForm: function(form) {
        if (!form) return;
        var committedParams = new URLSearchParams(window.location.search);
        collectionFilterState.syncFormWithSearchParams(form, committedParams);
        collectionFilterState.syncAllOptionStates(form);
        this.collection.initPriceRange();
      },

      getPopoverForTrigger: function(trigger) {
        var id = trigger && trigger.getAttribute('aria-controls');
        return id ? this.collection.container.querySelector('#' + CSS.escape(id)) : null;
      },

      togglePopover: function(popover, trigger) {
        var open = !popover.classList.contains('is-open');
        this.popovers.forEach(function(item) {
          if (item !== popover && item.classList.contains('is-open')) {
            item.classList.remove('is-open');
            this.handleToggle(item, false);
          }
        }.bind(this));
        popover.classList.toggle('is-open', open);
        this.activeTrigger = trigger;
        this.handleToggle(popover, open);
      },

      closePopover: function(popover) {
        if (!popover) return;
        if (popover.classList.contains('is-open')) {
          popover.classList.remove('is-open');
          this.handleToggle(popover, false);
        }
      },

      onDrawerOpen: function() {
        this.closePopover(this.activePopover);
      },

      onDocumentClick: function(evt) {
        if (!this.activePopover || this.activePopover.contains(evt.target) || (this.activeTrigger && this.activeTrigger.contains(evt.target))) {
          return;
        }
        this.closePopover(this.activePopover);
      },

      onKeyup: function(evt) {
        if (evt.key === 'Escape') {
          this.closePopover(this.activePopover);
        }
      },
    });

    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.context = container.getAttribute('data-context');
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });
      this.filterDrawerController = new CollectionFilterDrawerController(this);
      this.desktopFilterDrawerController = new CollectionDesktopFilterDrawerController(this);
      this.filterRailController = new CollectionFilterRailController(this);
      this.sortDropdownController = new CollectionSortDropdownController(this);
      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {

        /* Prevent extra JS from running for featured collection on a collection template */
        if (this.context && this.context === 'featured-collection') {
          this.colorSwatchHovering();
        } else {
          this.initSort();
          this.colorSwatchHovering();
          this.initFilters();
          this.initPriceRange();
          this.sidebar.init();
          this.desktopFilterDrawerController.init();
          this.filterRailController.init();
          this.sortDropdownController.init();
          this.initLoadMore();
          this.initStickyFilterButton();
          this.filterDrawerController.init();
        }
      },

      initSort: function() {
        this.sortSelects = Array.prototype.slice.call(this.container.querySelectorAll(selectors.sortSelect));
        this.sortSelect = this.sortSelects[0] || null;

        this.sortSelects.forEach(function(sortSelect) {
          sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }.bind(this));
      },

      getSortValue: function(sortSelect) {
        return sortSelect.value || sortSelect.getAttribute('data-default-sortby');
      },

      onSortChange: function(evt) {
        this.queryParams = new URLSearchParams(window.location.search);

        this.queryParams.set('sort_by', this.getSortValue(evt.currentTarget));
        this.queryParams.delete('page'); // Delete if it exists

        window.location.search = this.queryParams.toString();
      },

      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', () => {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = this.container.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', () => {
            var id = swatch.dataset.variantId;
            this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = this.container.querySelectorAll(selectors.tags);
        var activeTags = this.container.querySelectorAll(selectors.activeTags);

        if (!tags.length && !activeTags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          if (!this._boundSetFilterStickyPosition) {
            this._boundSetFilterStickyPosition = theme.utils.debounce(500, this.setFilterStickyPosition.bind(this));
          }

          window.off('resize' + this.namespace);
          window.on('resize' + this.namespace, this._boundSetFilterStickyPosition);
        }

        activeTags.forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });

        this.container.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },

      initPriceRange: function() {
        const priceRangeEls = this.container.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: function(formData) {
            this.renderFromFormData(formData, {
              formEl: el.closest('form'),
              sourceEl: el,
            });
          }.bind(this),
        }));
      },

      tagClick: function(evt) {
        var el = evt.currentTarget;
        var isDrawerInteraction = this.filterDrawerController.isDrawerElement(el);
        var newUrl = null;

        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();

        if (el.hasAttribute('data-clear-all-filters')) {
          this.clearAllFilters();
          return;
        }

        newUrl = new URL(el.href, window.location.origin);

        if (isDrawerInteraction) {
          if (el.closest('.tag--remove')) {
            el.href = newUrl.toString();
            evt.stopPropagation();
            this.filterDrawerController.onActiveTagClick(evt);
            return;
          }

          this.filterDrawerController.prefetch(new URL(el.href).searchParams);
          return;
        }

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      clearAllFilters: function() {
        var clearParams = new URLSearchParams(window.location.search);

        Array.from(clearParams.keys()).forEach(function(key) {
          if (key.indexOf('filter.') === 0 || key === 'page') {
            clearParams.delete(key);
          }
        });

        // This method is the single clear-all path for desktop, drawer tags and
        // the mobile footer. Do not proxy through a rendered desktop element:
        // collection markup is replaced after every AJAX filter request.
        this.filterDrawerController.abortPrefetch();
        this.filterDrawerController.pendingParams = null;
        this.filterDrawerController.previewResponse = null;
        this.filterDrawerController.isApplyingViewResults = true;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        isAnimating = true;
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(clearParams);
      },

      onFormSubmit: function(evt) {
        var el = evt.target;
        var formEl = el.closest('form');
        var isDrawerInteraction = this.filterDrawerController.isDrawerForm(formEl);

        evt.preventDefault();

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        if (this.desktopFilterDrawerController.isDrawerElement(el)) {
          this.desktopFilterDrawerController.onInput(el);
          return;
        }

        if (isDrawerInteraction) {
          this.filterDrawerController.syncOptionState(el);
          this.filterDrawerController.syncActiveTags(formEl);
          const formData = new FormData(formEl);
          this.filterDrawerController.prefetch(new URLSearchParams(formData));
          return;
        }

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.closest('li');
        const formData = new FormData(formEl);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      fetchOpenCollasibleFilters: function() {
        return Array.from(
          this.container.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function(parent, el) {
        const textEl = parent.querySelector('.tag__text');

        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            this.container.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);

              list.appendChild(newTag);
            });
          }
        }
      },

      renderFromFormData: function(formData, options) {
        const searchParams = new URLSearchParams(formData);
        const formEl = options && options.formEl;
        const sourceEl = options && options.sourceEl;

        if (this.desktopFilterDrawerController.isDrawerElement(sourceEl)) {
          this.desktopFilterDrawerController.onInput(null, formData, sourceEl.closest('[data-desktop-filter-drawer]'));
          return;
        }

        if (this.filterDrawerController.isDrawerForm(formEl)) {
          this.filterDrawerController.prefetch(searchParams);
          return;
        }

        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function(newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;

        // Controllers are rebound once by theme.sections.reinit after replacement.
      },

      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }

        el.classList.add(classes.isOpen);
      },

      renderCollectionPage: function(searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid');
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();

            document.dispatchEvent(new CustomEvent('collection:reloaded'));

            isAnimating = false;
          });
      },

      bindBackButton: function() {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function(state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },

      updateScroll: function(animate) {
        var scrollToElement = this.container.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;

        if (!theme.config.bpSmall) {
          scrollTo -= 15;
        }

        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },

      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        var filters = this.container.querySelector(selectors.filters);
        if (filters) {
          filters.style.top = headerHeight + 10 + 'px';
        }

        // Also update top position of sticky sidebar
        var stickySidebar = this.container.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },

      forceReload: function() {
        this.init();
      },

      onUnload: function() {
        window.off('popstate' + this.namespace);
        window.off('resize' + this.namespace);

        (this.sortSelects || []).forEach(function(sortSelect) {
          sortSelect.off('change' + this.namespace);
        }.bind(this));

        if (this._loadMoreBtn && this._boundLoadMore) {
          this._loadMoreBtn.removeEventListener('click', this._boundLoadMore);
        }

        this.teardownStickyFilterButton();
        this.desktopFilterDrawerController.destroy();
        this.filterRailController.destroy();
        this.sortDropdownController.destroy();
        this.filterDrawerController.destroy();
        this.sidebar.onUnload();
      },

      startLoading: function() {
        var collectionGrid = this.container.querySelector(selectors.collectionGrid);
        if (collectionGrid) {
          collectionGrid.classList.add('unload');
        }
      },

      initLoadMore: function() {
        // Remove any stale listener from a previous init (e.g. after filter AJAX)
        if (this._loadMoreBtn) {
          this._loadMoreBtn.removeEventListener('click', this._boundLoadMore);
          this._loadMoreBtn = null;
        }

        var btn = document.querySelector('[data-load-more-btn]');
        if (!btn) return;

        this._loadMoreBtn = btn;
        this._boundLoadMore = this.onLoadMoreClick.bind(this);
        btn.addEventListener('click', this._boundLoadMore);
      },

      initStickyFilterButton: function() {
        this.teardownStickyFilterButton();

        this._stickyFilter = this.container.querySelector('[data-sticky-filter]');
        this._stickyFilterBtn = this.container.querySelector('[data-sticky-filter-btn]');
        this._primaryFilterBtn = this.container.querySelector('.js-drawer-open-collection-filters');

        if (!this._stickyFilter || !this._stickyFilterBtn || !this._primaryFilterBtn) {
          return;
        }

        this._boundStickyFilterClick = this.onStickyFilterClick.bind(this);
        this._boundStickyFilterVisibility = theme.utils.throttle(50, this.updateStickyFilterVisibility.bind(this));

        this._stickyFilterBtn.addEventListener('click', this._boundStickyFilterClick);
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
        window.on('scroll' + this.namespace, this._boundStickyFilterVisibility);
        window.on('resize' + this.namespace, this._boundStickyFilterVisibility);

        this.updateStickyFilterVisibility();
      },

      teardownStickyFilterButton: function() {
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);

        if (this._stickyFilterBtn && this._boundStickyFilterClick) {
          this._stickyFilterBtn.removeEventListener('click', this._boundStickyFilterClick);
        }

        if (this._stickyFilter) {
          this._stickyFilter.classList.remove('is-visible');
        }

        this._stickyFilter = null;
        this._stickyFilterBtn = null;
        this._primaryFilterBtn = null;
        this._boundStickyFilterClick = null;
        this._boundStickyFilterVisibility = null;
      },

      updateStickyFilterVisibility: function() {
        if (!this._stickyFilter || !this._primaryFilterBtn) {
          return;
        }

        if (!theme.config.bpSmall) {
          this._stickyFilter.classList.remove('is-visible');
          return;
        }

        var sectionRect = this.container.getBoundingClientRect();
        var buttonRect = this._primaryFilterBtn.getBoundingClientRect();
        var stickyHeader = document.querySelector('.site-header--stuck');
        var viewportTopOffset = stickyHeader ? stickyHeader.getBoundingClientRect().bottom : 0;
        var sectionInStickyRange = sectionRect.top < window.innerHeight && sectionRect.bottom > window.innerHeight;
        var buttonHiddenAboveViewport = buttonRect.bottom <= viewportTopOffset;
        var buttonHiddenBelowViewport = buttonRect.top >= window.innerHeight;
        var shouldShow = sectionInStickyRange && (buttonHiddenAboveViewport || buttonHiddenBelowViewport);

        this._stickyFilter.classList.toggle('is-visible', shouldShow);
      },

      onStickyFilterClick: function(evt) {
        evt.preventDefault();

        if (theme.FilterDrawer) {
          theme.FilterDrawer.open(evt, this._stickyFilterBtn);
          return;
        }

        if (this._primaryFilterBtn) {
          this._primaryFilterBtn.click();
        }
      },

      onLoadMoreClick: function(evt) {
        var btn = evt.currentTarget;
        var nextUrl = btn.getAttribute('data-next-url');
        if (!nextUrl || this._loadMoreInProgress) return;

        var requestUrl = new URL(nextUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', this.sectionId);

        this._loadMoreInProgress = true;
        btn.classList.add('load-more-btn--loading');
        btn.disabled = true;

        fetch(requestUrl.toString())
          .then(function(response) {
            if (!response.ok) throw new Error('Load more failed: ' + response.status);
            return response.text();
          })
          .then(function(html) {
            var parser = new DOMParser();
            var newDom = parser.parseFromString(html, 'text/html');
            var newContent = newDom.getElementById('CollectionAjaxContent');
            var contentRoot = newContent || newDom;

            // Find the product grid in the new page and in the current page
            var newGrid = contentRoot.querySelector('.collection-grid__wrapper .grid');
            var currentGrid = document.querySelector('.collection-grid__wrapper .grid');
            var appendedItems = [];

            if (newGrid && currentGrid) {
              var newItems = newGrid.querySelectorAll('.grid__item');
              var fragment = document.createDocumentFragment();

              newItems.forEach(function(item) {
                appendedItems.push(item);
                fragment.appendChild(item);
              });

              currentGrid.appendChild(fragment);
            }

            // Replace the load more container with the one from the new page
            // (it will either have a new data-next-url, or be absent if last page)
            var currentContainer = document.querySelector('[data-load-more-container]');
            var newContainer = contentRoot.querySelector('[data-load-more-container]');

            if (currentContainer) {
              if (newContainer) {
                currentContainer.innerHTML = newContainer.innerHTML;
              } else {
                // No more pages – remove the button entirely
                currentContainer.parentNode.removeChild(currentContainer);
              }
            }

            // Re-init JS for newly added product cards
            if (appendedItems.length) {
              theme.reinitProductGridItem(appendedItems);
            }

            document.dispatchEvent(new CustomEvent('collection:load-more'));

            this._loadMoreInProgress = false;

            // Bind the new button (if any)
            this.initLoadMore();
          }.bind(this))
          .catch(function(err) {
            console.error(err);
            // Restore button on error
            btn.classList.remove('load-more-btn--loading');
            btn.disabled = false;
            this._loadMoreInProgress = false;
          }.bind(this));
      },
    });

    return Collection;
  })();


  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function() {

    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
        this.hoverMenu();
      },

      hoverMenu: function() {
        const detailsEl = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');

        detailsEl.forEach((detail) => {
          const summary = detail.querySelector('summary');
          const summaryLink = summary.dataset.link;

          summary.addEventListener('click', e => {
            e.preventDefault();
            window.location.href = summaryLink;
          });

          // if detail has :focus-within
          detail.addEventListener('focusin', () => {
            if (!detail.hasAttribute('open')) {

              // close all other details
              detailsEl.forEach((detail) => {
                detail.removeAttribute('open');
                detail.setAttribute('aria-expanded', 'false');
              });

              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });

          detail.addEventListener('focusout', () => {
            if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });

          detail.addEventListener('mouseover', () => {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });

          detail.addEventListener('mouseleave', () => {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        });
      },

      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }

        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      onUnload: function() {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return HeaderSection;
  })();

  theme.VideoManager = (function() {
    function VideoManager() {
      this._players = {};
    }

    VideoManager.prototype = {
      register: function(id, playerObj) {
        this._players[id] = playerObj;
      },

      get: function(id) {
        return this._players[id] || null;
      },

      ids: function() {
        return Object.keys(this._players);
      },

      stopAll: function(containerEl) {
        Object.entries(this._players).forEach(function(entry) {
          var id = entry[0];
          var vid = entry[1];

          if (vid.videoPlayer && typeof vid.videoPlayer.stopVideo === 'function') {
            vid.videoPlayer.stopVideo();
          } else if (vid.type === 'mp4' && containerEl) {
            var player = containerEl.querySelector('#' + id);
            if (player && typeof player.pause === 'function') {
              player.pause();
            }
          }
        });
      },

      destroy: function(id, containerEl) {
        var vid = this._players[id];
        if (!vid) return;

        if (vid.videoPlayer && typeof vid.videoPlayer.destroy === 'function') {
          vid.videoPlayer.destroy();
        } else if (vid.type === 'mp4' && containerEl) {
          var player = containerEl.querySelector('#' + id);
          if (player && typeof player.pause === 'function') {
            player.pause();
          }
        }

        delete this._players[id];
      },

      destroyList: function(ids, containerEl) {
        var self = this;
        (ids || []).forEach(function(id) {
          self.destroy(id, containerEl);
        });
      },

      destroyAll: function(containerEl) {
        this.destroyList(this.ids(), containerEl);
      }
    };

    return VideoManager;
  })();

  theme.SpinViewerManager = (function() {
    function SpinViewerManager(product) {
      this.product = product;
      this.container = product.container;
      this.sectionId = product.sectionId;
      this.namespace = product.settings.namespace;

      this._data = undefined;
      this._disabled = false;
      this._initialized = false;
      this._currentUrl = null;
      this._boundUpdate = null;
      this._panel = null;
      this._button = null;
      this._container = null;
      this._sirvEl = null;
      this._sizeObserver = null;
      this._observerStopTimeout = null;
      this._sizingTimeouts = null;
      this._sizingFrame = null;
      this._mountCheckInterval = null;
      this._mountTimeout = null;
      this._lazyMountScheduled = false;
      this._lazyMounted = false;
      this._lazyIdleId = null;
      this._lazyTimeoutId = null;
      this._lazySpinCard = null;
      this._lazyHoverHandler = null;
      this._lazyClickHandler = null;
    }

    SpinViewerManager.prototype = {
      init: function(currentVariant) {
        if (!this.parseData()) return false;

        this.bindElements({
          panel: this.container.querySelector('.media-tab-panel[data-tab="spin360"]'),
          button: this.container.querySelector('.tab-button[data-tab="spin360"]'),
          container: this.container.querySelector('[data-spin360-container]'),
          sirvEl: this.container.querySelector('[data-spin360-element]')
        });

        this._currentUrl = this.getUrlForVariant(currentVariant);
        this._disabled = false;
        this._initialized = false;

        if (!this._boundUpdate) {
          this._boundUpdate = this.updateState.bind(this);
          this.container.on('variantChange' + this.namespace, this._boundUpdate);
        }

        this.product._updateTabIndicatorVars();
        return true;
      },

      bindElements: function(elements) {
        elements = elements || {};
        this._panel = elements.panel || null;
        this._button = elements.button || null;
        this._container = elements.container || null;
        this._sirvEl = elements.sirvEl || null;
      },

      parseData: function() {
        if (typeof this._data !== 'undefined') {
          return !!this._data;
        }

        var spinDataEl = this.container.querySelector('#Spin360Data-' + this.sectionId);
        if (!spinDataEl) {
          this._data = null;
          return false;
        }

        try {
          this._data = JSON.parse(spinDataEl.textContent);
        } catch (error) {
          console.warn('Failed to parse 360 spin data:', error);
          this._data = null;
        }

        return !!this._data;
      },

      hasData: function() {
        return !!this._data || this.parseData();
      },

      getUrlForVariant: function(variant) {
        if (!variant || this._disabled) return null;
        if (!this.hasData()) return null;

        var product = this.product;
        var optionValue = product.settings.imageSetIndex != null ? variant[product.settings.imageSetIndex] : null;
        var group = product.getVariantGroup(product.settings.imageSetName, optionValue);
        var spinUrl = null;

        if (group && this._data[group]) {
          spinUrl = this._data[group];
        } else if (!group && this._data.default) {
          spinUrl = this._data.default;
        }

        return spinUrl;
      },

      setCurrentUrl: function(url) {
        this._currentUrl = url || null;
      },

      isInitialized: function() {
        return this._initialized;
      },

      updateState: function(evt) {
        var variant = evt && evt.detail ? evt.detail.variant : null;
        if (this._disabled) return;

        var nextUrl = this.getUrlForVariant(variant);

        if (!nextUrl) {
          this._currentUrl = null;

          if (this.product.settings.currentMediaType === 'spin360') {
            var availableTabs = this.product.mediaTabsController.getAvailableTabs(variant).filter(function(tab) {
              return tab !== 'spin360';
            });
            var fallbackTab = availableTabs[0] || this.product.mediaTabsController.getFirstAvailableTab('spin360');
            if (fallbackTab) {
              this.product.mediaTabsController.switchTab(fallbackTab);
            }
          }

          return;
        }

        if (this._currentUrl !== nextUrl) {
          this._currentUrl = nextUrl;
          this.resetElement(nextUrl);

          if (this.product.settings.currentMediaType === 'spin360') {
            this.activate();
          }
        }
      },

      ensureSirvScript: function() {
        if (window.Sirv) {
          return Promise.resolve(window.Sirv);
        }

        if (window.__sirvLoadingPromise) {
          return window.__sirvLoadingPromise;
        }

        window.__sirvLoadingPromise = new Promise(function(resolve, reject) {
          var script = document.createElement('script');
          script.async = true;
          script.src = 'https://scripts.sirv.com/sirvjs/v3/sirv.js';
          script.onload = function() {
            if (window.Sirv) {
              resolve(window.Sirv);
              return;
            }

            window.__sirvLoadingPromise = null;
            reject(new Error('Sirv SDK loaded without window.Sirv'));
          };
          script.onerror = function() {
            window.__sirvLoadingPromise = null;
            reject(new Error('Failed to load Sirv SDK'));
          };
          document.head.appendChild(script);
        });

        return window.__sirvLoadingPromise;
      },

      activate: function() {
        if (!this._currentUrl || !this._sirvEl || !this._container) return;

        var requestedUrl = this._currentUrl;
        var requestedElement = this._sirvEl;

        this.ensureSirvScript()
          .then(function() {
            if (!this._sirvEl) return;
            if (!window.Sirv || typeof window.Sirv.start !== 'function') {
              throw new Error('Sirv SDK is unavailable');
            }

            if (
              this.product.settings.currentMediaType !== 'spin360' ||
              this._disabled ||
              this._currentUrl !== requestedUrl ||
              this._sirvEl !== requestedElement
            ) {
              return;
            }

            if (this._initialized) {
              this.hidePoster();
              this.applySizingFix();
              this.queueSizingFixes();
              return;
            }

            if (this._sirvEl.getAttribute('data-src') !== this._currentUrl) {
              this._sirvEl.setAttribute('data-src', this._currentUrl);
            }

            this.startSizeObserver();
            window.Sirv.start(this._sirvEl);
            this._initialized = true;
            this.startMountWatchdog(requestedUrl, requestedElement);
            this.applySizingFix();
            this.queueSizingFixes();
            window.dispatchEvent(new Event('resize'));
          }.bind(this))
          .catch(function(error) {
            console.warn('Failed to initialize 360 spin viewer:', error);
            this.disableFeature();
          }.bind(this));
      },

      deactivate: function() {
        this.clearMountWatchdog();
        this.stopSizeObserver();

        if (window.Sirv && this._sirvEl && typeof window.Sirv.stop === 'function') {
          window.Sirv.stop(this._sirvEl);
        }

        this._initialized = false;
      },

      disableFeature: function() {
        this.deactivate();
        this._disabled = true;
        this._currentUrl = null;

        if (this._button) {
          this._button.style.display = 'none';
          this._button.setAttribute('aria-hidden', 'true');
        }

        if (this._panel) {
          this._panel.classList.remove('is-active');
          this._panel.classList.add('is-hidden');
          this._panel.setAttribute('aria-hidden', 'true');
        }

        var fallbackTab = this.product.mediaTabsController.getFirstAvailableTab('spin360');
        if (fallbackTab && this.product.settings.currentMediaType === 'spin360') {
          this.product.mediaTabsController.switchTab(fallbackTab);
        }

        this.product._updateTabIndicatorVars();
      },

      applySizingFix: function() {
        if (!this._container || !this._sirvEl) return;

        var selectors = [
          '.spin-canvas-container',
          '.spin-zoom-container',
          '.spin-container',
          '.spin-view',
          '.spin-figure',
          '.sirv-spin-container',
          'canvas'
        ];

        this._container.style.width = '100%';
        this._container.style.height = '100%';
        this._sirvEl.style.width = '100%';
        this._sirvEl.style.height = '100%';

        selectors.forEach(function(selector) {
          this._sirvEl.querySelectorAll(selector).forEach(function(node) {
            node.style.setProperty('width', '100%', 'important');
            node.style.setProperty('height', '100%', 'important');
            node.style.setProperty('max-width', '100%', 'important');
            node.style.setProperty('max-height', '100%', 'important');
          });
        }.bind(this));
      },

      queueSizingFixes: function() {
        if (this._sizingTimeouts) {
          this._sizingTimeouts.forEach(function(timeoutId) {
            clearTimeout(timeoutId);
          });
        }

        this._sizingTimeouts = [0, 80, 180, 320, 520, 900].map(function(delay) {
          return setTimeout(function() {
            this.applySizingFix();
          }.bind(this), delay);
        }.bind(this));
      },

      scheduleSizingFix: function() {
        if (this._sizingFrame) return;

        this._sizingFrame = requestAnimationFrame(function() {
          this._sizingFrame = null;
          this.applySizingFix();
        }.bind(this));
      },

      startSizeObserver: function() {
        this.stopSizeObserver();

        if (!this._sirvEl || typeof MutationObserver === 'undefined') return;

        this._sizeObserver = new MutationObserver(function() {
          this.scheduleSizingFix();
        }.bind(this));

        this._sizeObserver.observe(this._sirvEl, {
          childList: true,
          subtree: true
        });

        this._observerStopTimeout = setTimeout(function() {
          this.stopSizeObserver();
        }.bind(this), 1500);
      },

      stopSizeObserver: function() {
        if (this._sizeObserver) {
          this._sizeObserver.disconnect();
          this._sizeObserver = null;
        }

        if (this._observerStopTimeout) {
          clearTimeout(this._observerStopTimeout);
          this._observerStopTimeout = null;
        }

        if (this._sizingTimeouts) {
          this._sizingTimeouts.forEach(function(timeoutId) {
            clearTimeout(timeoutId);
          });
          this._sizingTimeouts = null;
        }
      },

      resetElement: function(nextUrl) {
        if (!this._sirvEl) return;

        this.clearMountWatchdog();
        this.cancelLazyMount();

        if (window.Sirv && typeof window.Sirv.stop === 'function') {
          window.Sirv.stop(this._sirvEl);
        }

        var nextEl = this._sirvEl.cloneNode(false);
        nextEl.innerHTML = '';
        nextEl.className = 'Sirv';

        if (nextUrl) {
          nextEl.setAttribute('data-src', nextUrl);
        } else {
          nextEl.removeAttribute('data-src');
        }

        this._sirvEl.parentNode.replaceChild(nextEl, this._sirvEl);
        this._sirvEl = nextEl;
        this._initialized = false;
        this._lazyMountScheduled = false;
        this._lazyMounted = false;
        this.showPoster(nextUrl);
        this.startSizeObserver();
      },

      hasRenderedContent: function() {
        if (!this._sirvEl) return false;

        return Boolean(
          this._sirvEl.querySelector(
            '.spin-canvas-container, .spin-zoom-container, .spin-container, .spin-view, .spin-figure, .sirv-spin-container, canvas, img, picture, video'
          )
        );
      },

      clearMountWatchdog: function() {
        if (this._mountCheckInterval) {
          clearInterval(this._mountCheckInterval);
          this._mountCheckInterval = null;
        }

        if (this._mountTimeout) {
          clearTimeout(this._mountTimeout);
          this._mountTimeout = null;
        }

      },

      startMountWatchdog: function(requestedUrl, requestedElement) {
        this.clearMountWatchdog();

        var mountGracePeriods = [3500, 8500];

        var hasMounted = function() {
          return (
            this.product.settings.currentMediaType === 'spin360' &&
            !this._disabled &&
            this._currentUrl === requestedUrl &&
            this._sirvEl === requestedElement &&
            this.hasRenderedContent()
          );
        }.bind(this);

        this._mountCheckInterval = setInterval(function() {
          if (hasMounted()) {
            this.hidePoster();
            this.clearMountWatchdog();
          }
        }.bind(this), 150);

        this._mountTimeout = setTimeout(function() {
          if (hasMounted()) {
            this.clearMountWatchdog();
            return;
          }

          if (
            this.product.settings.currentMediaType === 'spin360' &&
            !this._disabled &&
            this._currentUrl === requestedUrl &&
            this._sirvEl === requestedElement
          ) {
            console.warn('Sirv 360 viewer is mounting slower than expected. Retrying before fallback.');

            this._mountTimeout = setTimeout(function() {
              if (hasMounted()) {
                this.clearMountWatchdog();
                return;
              }

              if (
                this.product.settings.currentMediaType === 'spin360' &&
                !this._disabled &&
                this._currentUrl === requestedUrl &&
                this._sirvEl === requestedElement
              ) {
                console.warn('Sirv 360 viewer did not mount after extended wait. Falling back to native media.');
                this.disableFeature();
              } else {
                this.clearMountWatchdog();
              }
            }.bind(this), mountGracePeriods[1] - mountGracePeriods[0]);
          } else {
            this.clearMountWatchdog();
          }
        }.bind(this), mountGracePeriods[0]);
      },

      syncForTab: function(tab) {
        if (tab === 'spin360' && this.hasData()) {
          this.activate();
        } else if (tab !== 'spin360' && this._initialized) {
          this.deactivate();
        }
      },

      hidePoster: function() {
        if (!this._container) return;
        this._container.classList.add('is-spin-ready');
      },

      showPoster: function(nextUrl) {
        if (!this._container) return;
        this._container.classList.remove('is-spin-ready');
        var poster = this._container.querySelector('.product-360-viewer__poster');
        if (!poster) return;
        if (nextUrl) {
          poster.src = nextUrl + '?thumb';
        }
      },

      scheduleLazyMount: function() {
        if (!this._currentUrl || !this._container || this._disabled) return;
        if (this._lazyMountScheduled) return;
        this._lazyMountScheduled = true;

        var self = this;
        var idleId = null;
        var timeoutId = null;

        var doMount = function() {
          if (self._lazyMounted) return;
          self._lazyMounted = true;

          // Cleanup timers
          if (idleId && window.cancelIdleCallback) {
            window.cancelIdleCallback(idleId);
          } else if (idleId) {
            clearTimeout(idleId);
          }
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          self._cleanupLazyListeners();

          self.activate();
        };

        // Trigger 1: requestIdleCallback with 3s fallback timeout
        if (window.requestIdleCallback) {
          idleId = window.requestIdleCallback(doMount, { timeout: 3000 });
        } else {
          // Fallback: setTimeout 2s for browsers without requestIdleCallback
          timeoutId = setTimeout(doMount, 2000);
        }

        // Trigger 2 & 3: hover / click on spin card
        var spinCard = this._container.closest('.product-media-desktop-grid__card--spin')
          || this._container.closest('.media-tab-panel--spin360');

        if (spinCard) {
          this._lazyHoverHandler = function() { doMount(); };
          this._lazyClickHandler = function() { doMount(); };
          spinCard.addEventListener('mouseenter', this._lazyHoverHandler, { once: true });
          spinCard.addEventListener('click', this._lazyClickHandler, { once: true });
        }

        this._lazyIdleId = idleId;
        this._lazyTimeoutId = timeoutId;
        this._lazySpinCard = spinCard;
      },

      _cleanupLazyListeners: function() {
        if (this._lazySpinCard) {
          if (this._lazyHoverHandler) {
            this._lazySpinCard.removeEventListener('mouseenter', this._lazyHoverHandler);
          }
          if (this._lazyClickHandler) {
            this._lazySpinCard.removeEventListener('click', this._lazyClickHandler);
          }
        }
        this._lazySpinCard = null;
        this._lazyHoverHandler = null;
        this._lazyClickHandler = null;
      },

      cancelLazyMount: function() {
        if (this._lazyIdleId) {
          if (window.cancelIdleCallback) {
            window.cancelIdleCallback(this._lazyIdleId);
          } else {
            clearTimeout(this._lazyIdleId);
          }
          this._lazyIdleId = null;
        }
        if (this._lazyTimeoutId) {
          clearTimeout(this._lazyTimeoutId);
          this._lazyTimeoutId = null;
        }
        this._cleanupLazyListeners();
        this._lazyMountScheduled = false;
        this._lazyMounted = false;
      },

      destroy: function(options) {
        var preserveData = options && options.preserveData;

        this.clearMountWatchdog();
        this.cancelLazyMount();

        if (window.Sirv && this._sirvEl && typeof window.Sirv.stop === 'function') {
          window.Sirv.stop(this._sirvEl);
        }

        this.stopSizeObserver();

        if (!preserveData && this._boundUpdate) {
          this.container.off('variantChange' + this.namespace, this._boundUpdate);
        }

        if (this._sizingFrame) {
          cancelAnimationFrame(this._sizingFrame);
          this._sizingFrame = null;
        }

        if (this.product.cache && this.product.cache.thumbSlider) {
          this.product.cache.thumbSlider.classList.remove('is-hidden');
        }

        this._container = null;
        this._panel = null;
        this._button = null;
        this._sirvEl = null;
        this._currentUrl = null;
        this._initialized = false;

        if (!preserveData) {
          this._data = null;
          this._disabled = false;
          this._boundUpdate = null;
        }
      }
    };

    return SpinViewerManager;
  })();

  var mediaModeStateKeys = [
    'mediaMode',
    'mediaModeRoot',
    'desktopGridTemplate',
    'desktopGridSpinTemplate',
    'desktopGridFlickities',
    'desktopGridVideoIds',
    'defaultModeVideoIds',
    'defaultModePhotoswipe',
    'desktopGridPhotoswipe'
  ];

  function defineMediaModeStateAccessors(instance) {
    if (instance._mediaModeStateAccessorsDefined) {
      return;
    }

    mediaModeStateKeys.forEach(function(key) {
      Object.defineProperty(instance, key, {
        configurable: true,
        enumerable: true,
        get: function() {
          return this.mediaModeController ? this.mediaModeController.getState(key) : undefined;
        },
        set: function(value) {
          if (!this.mediaModeController) {
            return;
          }

          this.mediaModeController.setState(key, value);
        }
      });
    });

    instance._mediaModeStateAccessorsDefined = true;
  }

  theme.MediaModeController = (function() {
    function MediaModeController(product) {
      this.product = product;
      this.container = product.container;
      this.selectors = product.selectors;
      this.state = {
        mediaMode: null,
        mediaModeRoot: null,
        desktopGridTemplate: null,
        desktopGridSpinTemplate: null,
        desktopGridFlickities: [],
        desktopGridVideoIds: [],
        defaultModeVideoIds: [],
        defaultModePhotoswipe: null,
        desktopGridPhotoswipe: []
      };
      this._desktopMq = null;
      this._boundMqChange = null;
    }

    MediaModeController.prototype = {
      getState: function(key) {
        return this.state[key];
      },

      setState: function(key, value) {
        this.state[key] = value;
        return value;
      },

      init: function() {
        this.state.mediaModeRoot = this.container.querySelector(this.selectors.mediaModeRoot);
        this.state.mobileHost = this.container.querySelector(this.selectors.mobileHost);
        this.state.desktopHost = this.container.querySelector(this.selectors.desktopHost);
        this.state.desktopGridTemplate = this.container.querySelector(this.selectors.desktopGridTemplate);
        this.state.desktopGridSpinTemplate = this.container.querySelector(this.selectors.desktopGridSpinTemplate);

        this.product.initSpin360();

        if (!this._desktopMq) {
          this._desktopMq = window.matchMedia('(min-width: 769px)');
        }

        if (!this._boundMqChange) {
          this._boundMqChange = this.handleMqChange.bind(this);
        }

        this.mountActiveMode();
        this.product.ensureVariantMediaListener();
        this.initActiveMode();

        if (typeof this._desktopMq.addEventListener === 'function') {
          this._desktopMq.removeEventListener('change', this._boundMqChange);
          this._desktopMq.addEventListener('change', this._boundMqChange);
        } else if (typeof this._desktopMq.addListener === 'function') {
          this._desktopMq.removeListener(this._boundMqChange);
          this._desktopMq.addListener(this._boundMqChange);
        }
      },

      destroy: function() {
        this.unmountActiveMode();

        if (this._desktopMq && this._boundMqChange) {
          if (typeof this._desktopMq.removeEventListener === 'function') {
            this._desktopMq.removeEventListener('change', this._boundMqChange);
          } else if (typeof this._desktopMq.removeListener === 'function') {
            this._desktopMq.removeListener(this._boundMqChange);
          }
        }

        this._desktopMq = null;
        this._boundMqChange = null;

        this.state.mediaModeRoot = null;
        this.state.mobileHost = null;
        this.state.desktopHost = null;
        this.state.desktopGridTemplate = null;
        this.state.desktopGridSpinTemplate = null;
        this.state.desktopGridFlickities = [];
        this.state.desktopGridVideoIds = [];
        this.state.defaultModeVideoIds = [];
        this.state.defaultModePhotoswipe = null;
        this.state.desktopGridPhotoswipe = [];
      },

      handleMqChange: function() {
        this.unmountActiveMode();
        this.mountActiveMode();
        this.initActiveMode();
      },

      getCurrentMode: function() {
        return this._desktopMq && this._desktopMq.matches ? 'desktop-grid' : 'default';
      },

      mountActiveMode: function() {
        this.unmountActiveMode();

        if (!this.state.mediaModeRoot) return;

        this.state.mediaMode = this.getCurrentMode();
        if (this.state.mediaMode === 'desktop-grid') {
          this.mountDesktopGridMode();
        } else {
          this.mountDefaultMediaMode();
        }

        this.product.cacheElements();
        this.product.syncActiveMediaStateFromDOM();
      },

      initActiveMode: function() {
        if (this.state.mediaMode === 'desktop-grid') {
          this.initDesktopGridMode();
          return;
        }

        this.product.productSetup();
        this.product.videoSetup();
        this.product.customMediaListeners();
        this.product.initInstagramDotsResizeHandler();
      },

      unmountActiveMode: function() {
        if (!this.state.mediaModeRoot) return;

        if (this.state.mediaMode === 'desktop-grid') {
          this.destroyDesktopGridMode();
          if (this.state.desktopHost) {
            this.state.desktopHost.innerHTML = '';
          }
        } else if (this.state.mediaMode === 'default') {
          this.destroyDefaultMediaMode();
        }

        this.state.mediaMode = null;
        this.product.cacheElements();
      },

      mountDefaultMediaMode: function() {
        if (!this.state.mobileHost || !this.state.mediaModeRoot) return;
        this.state.mediaModeRoot.classList.remove('is-building-desktop-media');
        if (this.state.desktopHost) {
          this.state.desktopHost.setAttribute('hidden', '');
          this.state.desktopHost.setAttribute('aria-hidden', 'true');
        }
        this.setMobileVideosInert(false);
      },

      mountDesktopGridMode: function() {
        if (!this.state.desktopGridTemplate || !this.state.desktopHost) return;
        // Clear SSR stub (pre-rendered poster from liquid) before appending the real grid template
        this.state.desktopHost.innerHTML = '';
        this.state.desktopHost.appendChild(this.state.desktopGridTemplate.content.cloneNode(true));
        this.state.desktopHost.removeAttribute('hidden');
        this.state.desktopHost.setAttribute('aria-hidden', 'false');
        this.state.mediaModeRoot.classList.add('is-building-desktop-media');
        this.setMobileVideosInert(true);
      },

      setMobileVideosInert: function(inert) {
        if (!this.state.mobileHost) return;
        var mobileVideos = this.state.mobileHost.querySelectorAll('video');
        mobileVideos.forEach(function(video) {
          if (inert) {
            video.dataset.originalPreload = video.getAttribute('preload') || 'metadata';
            video.setAttribute('preload', 'none');
          } else {
            video.setAttribute('preload', video.dataset.originalPreload || 'metadata');
          }
        });
      },

      destroyDefaultMediaMode: function() {
        this.product.destroyPhotoswipeInstance('defaultModePhotoswipe');
        this.product.destroyVideoPlayers(this.state.defaultModeVideoIds);
        this.state.defaultModeVideoIds = [];
        this.product.destroySpin360({ preserveFeatureState: true });

        if (this.product.flickity && typeof this.product.flickity.destroy === 'function') {
          this.product.flickity.destroy();
          this.product.flickity = null;
        }
      },

      destroyDesktopGridMode: function() {
        this.product.destroyDesktopGridCarousels();
        this.product.destroyVideoPlayers(this.state.desktopGridVideoIds);
        this.state.desktopGridVideoIds = [];
        this.product.destroyPhotoswipeInstance('desktopGridPhotoswipe');
        this.product.destroySpin360({ preserveFeatureState: true });
        this.product.currentDesktopGridEffectiveMediaGroup = null;
        this.product.currentDesktopGridVisibleMediaSignature = null;
        this.product.currentDesktopGridSpinUrl = null;
      },

      getDesktopGridImageSetName: function() {
        if (!this.state.mobileHost) return null;

        var groupedMedia = Array.prototype.slice.call(this.state.mobileHost.querySelectorAll('.product-main-slide[data-variant-group]')).find(function(node) {
          return node.dataset.variantGroup;
        });

        return groupedMedia ? groupedMedia.dataset.variantGroup : null;
      },

      syncActiveMediaStateFromDOM: function() {
        var product = this.product;
        var mediaScope = product._getMediaScope();
        product.firstProductImage = product.cache.mainSlider ? product.cache.mainSlider.querySelector('img') : mediaScope.querySelector('img');
        product.settings.hasImages = !!product.firstProductImage;

        var dataSetEl = mediaScope.querySelector('[data-set-name]');
        var nextImageSetName = dataSetEl ? dataSetEl.dataset.setName : null;

        if (!nextImageSetName && product._useDesktopGridMediaArchitecture()) {
          nextImageSetName = this.getDesktopGridImageSetName();
        }

        if (nextImageSetName) {
          product.settings.imageSetName = nextImageSetName;
        }

        if (product.settings.imageSetName) {
          var variantWrapper = product.container.querySelector('.variant-input-wrap[data-handle="' + product.settings.imageSetName + '"]');
          if (variantWrapper) {
            product.settings.imageSetIndex = variantWrapper.dataset.index;
            product.ensureVariantMediaListener();
          }
        }
      },

      initDesktopGridMode: function() {
        if (!this.product.variants || !this.product.variants.currentVariant) return;

        this.buildDesktopGridFromNodes(this.product.variants.currentVariant);
      },

      // ============================================
      // 1. SOURCE DOM READ & FILTER
      // ============================================

      getDesktopGridVariantState: function(variant) {
        var product = this.product;
        var optionValue = product.settings.imageSetIndex != null
          ? variant[product.settings.imageSetIndex]
          : null;
        var visibleMedia = this.getVisibleMediaNodes(variant);
        var visibleImages = visibleMedia.filter(function(item) { return item.is_image; });
        var visibleVideos = visibleMedia.filter(function(item) { return item.is_video; });
        var effectiveMediaGroup = product.settings.imageSetIndex != null
          ? product.getVariantGroup(product.settings.imageSetName, optionValue)
          : null;
        var visibleMediaSignature = this.getDesktopGridMediaSignature(visibleMedia);
        var spinUrl = product.getSpin360UrlForVariant(variant);

        return {
          visibleMedia: visibleMedia,
          visibleImages: visibleImages,
          visibleVideos: visibleVideos,
          effectiveMediaGroup: effectiveMediaGroup,
          visibleMediaSignature: visibleMediaSignature,
          spinUrl: spinUrl,
          hasSpin: !!spinUrl
        };
      },

      // ============================================
      // 3. DESKTOP GRID BUILD
      // ============================================

      buildDesktopGridFromNodes: function(variant) {
        var product = this.product;
        var desktopGridRoot = this.state.mediaModeRoot && this.state.mediaModeRoot.querySelector(this.selectors.desktopGridRoot);
        var desktopGridList = this.state.mediaModeRoot && this.state.mediaModeRoot.querySelector(this.selectors.desktopGridList);
        if (!desktopGridRoot || !desktopGridList) return;

        var variantState = this.getDesktopGridVariantState(variant);
        var visibleImages = variantState.visibleImages;
        var visibleVideos = variantState.visibleVideos;
        var spinUrl = variantState.spinUrl;
        var staticImages = visibleImages.slice(1, 4);
        var remainingImages = visibleImages.slice(4);

        this.destroyDesktopGridMode();
        desktopGridList.innerHTML = '';

        /*
         * CORE ARCHITECTURE RULE (Rule #18):
         * When 360 Spin is active, Image 1 is intentionally EXCLUDED from being mounted 
         * into the Desktop Grid because the Spin card occupies Slot 1.
         * However, Image 1 MUST STILL EXIST in the mobile source DOM and in visibleImages.
         * If no Spin is present, Image 1 mounts securely into Slot 1.
         */
        if (spinUrl) {
          this.appendDesktopGridSpinCard(desktopGridList, spinUrl);
        } else if (visibleImages[0]) {
          this.appendDesktopGridMediaCard(desktopGridList, visibleImages[0].node, 'image');
        }

        staticImages.forEach(function(item) {
          this.appendDesktopGridMediaCard(desktopGridList, item.node, 'image');
        }.bind(this));

        if (remainingImages.length === 1) {
          this.appendDesktopGridMediaCard(desktopGridList, remainingImages[0].node, 'image');
        } else if (remainingImages.length > 1) {
          this.appendDesktopGridCarouselCard(desktopGridList, remainingImages.map(function(x){return x.node;}), 'images');
        }

        if (visibleVideos.length === 1) {
          this.appendDesktopGridMediaCard(desktopGridList, visibleVideos[0].node, 'video');
        } else if (visibleVideos.length > 1) {
          this.appendDesktopGridCarouselCard(desktopGridList, visibleVideos.map(function(x){return x.node;}), 'videos');
        }

        this.initDesktopGridPhotoswipes(desktopGridRoot);
        this.refreshDesktopGridImageAnimations(desktopGridRoot);
        this.initDesktopGridCarousels();
        this.videoSetupDesktopGrid();

        product.spinManager.bindElements({
          container: this.state.mediaModeRoot.querySelector('[data-desktop-grid-spin-container]'),
          sirvEl: this.state.mediaModeRoot.querySelector('[data-desktop-grid-spin-element]')
        });
        product.spinManager.setCurrentUrl(spinUrl);
        product.currentDesktopGridEffectiveMediaGroup = variantState.effectiveMediaGroup;
        product.currentDesktopGridVisibleMediaSignature = variantState.visibleMediaSignature;
        product.currentDesktopGridSpinUrl = spinUrl;
        product.settings.currentMediaType = spinUrl ? 'spin360' : 'images';

        if (spinUrl) {
          product.spinManager.showPoster(spinUrl);
          product.spinManager.scheduleLazyMount();
        }
      },

      refreshDesktopGridImageAnimations: function(scope) {
        if (!scope) return;

        var imageElements = scope.querySelectorAll('image-element[data-aos="image-fade-in"]');
        if (!imageElements.length) return;

        imageElements.forEach(function(element) {
          element.classList.add('aos-init');
        });

        if (window.AOS && typeof window.AOS.refreshHard === 'function') {
          window.AOS.refreshHard();
          return;
        }

        imageElements.forEach(function(element) {
          element.classList.add('aos-animate');
        });
      },

      // ============================================
      // 2. CLONE NORMALIZATION
      // ============================================

      cloneAndNormalizeMediaNode: function(sourceNode) {
        if (!sourceNode) return null;
        
        var clone = sourceNode.cloneNode(true);
        var mediaId = clone.dataset.mediaId;
        
        var attributesToModify = ['aria-controls', 'aria-describedby', 'aria-labelledby', 'for'];
        
        var cloneInnerElements = clone.querySelectorAll('*');
        var processElement = function(el) {
          if (el.id && el.id.indexOf('-desktop-clone') === -1) {
            el.id = el.id + '-desktop-clone';
          }
          attributesToModify.forEach(function(attr) {
            var val = el.getAttribute(attr);
            if (val && val.indexOf('-desktop-clone') === -1) {
              el.setAttribute(attr, val + '-desktop-clone');
            }
          });
        };

        processElement(clone);
        cloneInnerElements.forEach(processElement);

        clone.classList.remove('is-selected', 'flickity-cell');
        clone.style.cssText = '';

        var sirvContainer = clone.querySelector('.Sirv');
        if (sirvContainer) {
          sirvContainer.innerHTML = '';
          sirvContainer.classList.remove('sirv-spin-container-ready', 'sirv-spin-container-loaded');
        }

        var aosElements = clone.querySelectorAll('[data-aos]');
        aosElements.forEach(function(el) {
          el.classList.remove('aos-init', 'aos-animate');
        });

        return clone;
      },

      appendDesktopGridSpinCard: function(container, spinUrl) {
        var card = document.createElement('div');
        card.className = 'product-media-desktop-grid__card product-media-desktop-grid__card--spin';

        if (this.state.desktopGridSpinTemplate) {
          card.appendChild(this.state.desktopGridSpinTemplate.content.cloneNode(true));
        }

        var spinElement = card.querySelector('[data-desktop-grid-spin-element]');
        if (spinElement && spinUrl) {
          spinElement.setAttribute('data-src', spinUrl);
        }

        container.appendChild(card);
      },

      appendDesktopGridMediaCard: function(container, sourceNode, type) {
        var clone = this.cloneAndNormalizeMediaNode(sourceNode);
        if (!clone) return;

        clone.classList.add('is-selected');
        
        var zoomBtn = clone.querySelector('.js-photoswipe__zoom');
        if (zoomBtn) zoomBtn.remove();

        var card = document.createElement('div');
        card.className = 'product-media-desktop-grid__card product-media-desktop-grid__card--' + type;
        card.setAttribute('data-desktop-grid-card-type', type);
        card.appendChild(clone);
        container.appendChild(card);
      },

      appendDesktopGridCarouselCard: function(container, nodes, type) {
        if (!nodes || !nodes.length) return;

        var card = document.createElement('div');
        card.className = 'product-media-desktop-grid__card product-media-desktop-grid__card--' + type + '-carousel';
        card.setAttribute('data-desktop-grid-card-type', type + '-carousel');

        var carousel = document.createElement('div');
        carousel.className = 'product-media-desktop-grid__carousel';
        carousel.setAttribute('data-desktop-grid-carousel-track', type);
        carousel.setAttribute('aria-label', type === 'videos' ? 'Product videos carousel' : 'Product images carousel');

        nodes.forEach(function(sourceNode) {
          var clone = this.cloneAndNormalizeMediaNode(sourceNode);
          if (!clone) return;
          carousel.appendChild(clone);
        }.bind(this));

        card.appendChild(carousel);
        container.appendChild(card);
      },

      getDesktopGridMountedImageElement: function(root, mediaId) {
        if (!root || mediaId == null) return null;

        return root.querySelector('.product-main-slide[data-media-id="' + mediaId + '"] .photoswipe__image');
      },

      getDesktopGridPhotoswipeItem: function(root, mediaId) {
        if (mediaId == null) return null;

        var mountedImage = this.getDesktopGridMountedImageElement(root, mediaId);
        if (!mountedImage) return null;

        return {
          msrc: mountedImage.currentSrc || mountedImage.src,
          src: mountedImage.getAttribute('data-photoswipe-src'),
          w: mountedImage.getAttribute('data-photoswipe-width'),
          h: mountedImage.getAttribute('data-photoswipe-height'),
          el: mountedImage,
          initialZoomLevel: 0.5,
          mediaId: String(mediaId)
        };
      },

      getDesktopGridPhotoswipeItems: function(root) {
        var currentVariant = this.product.variants && this.product.variants.currentVariant;
        if (!currentVariant) return [];

        var variantState = this.getDesktopGridVariantState(currentVariant);

        return (variantState.visibleImages || []).map(function(item) {
          return this.getDesktopGridPhotoswipeItem(root, item.media_id);
        }.bind(this)).filter(Boolean);
      },

      getDesktopGridPhotoswipeIndex: function(target, targets, items) {
        if (!target || !items || !items.length) {
          return 0;
        }

        var mediaId = target.dataset ? target.dataset.mediaId : target.getAttribute('data-media-id');
        if (!mediaId) {
          return 0;
        }

        return items.findIndex(function(item) {
          return item && item.mediaId === String(mediaId);
        }) + 1;
      },

      initDesktopGridPhotoswipes: function(root) {
        if (!root || !root.querySelector('.js-photoswipe__zoom')) {
          this.state.desktopGridPhotoswipe = [];
          return;
        }

        this.state.desktopGridPhotoswipe = [
          new theme.Photoswipe(root, this.product.sectionId + '-desktop-grid', {
            sharedImageScopeRoot: root,
            getItems: function() {
              return this.getDesktopGridPhotoswipeItems(root);
            }.bind(this),
            getTargetIndex: function(target, targets, items) {
              return this.getDesktopGridPhotoswipeIndex(target, targets, items);
            }.bind(this)
          })
        ];
      },

      initDesktopGridCarousels: function() {
        var product = this.product;
        if (!this.state.mediaModeRoot) return;

        this.state.mediaModeRoot.querySelectorAll(this.selectors.desktopGridCarousel).forEach(function(track) {
          var slides = track.querySelectorAll('.product-main-slide');
          if (slides.length <= 1) return;
          track.__desktopGridCurrentIndex = 0;

          var slideshow = new theme.Slideshow(track, {
            dragThreshold: 25,
            adaptiveHeight: true,
            avoidReflow: true,
            initialIndex: 0,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            callbacks: {
              onInit: function(slide) {
                this.prepDesktopGridMediaOnSlide(slide);
              }.bind(this),
              onChange: function(index) {
                var currentSlides = track.querySelectorAll('.flickity-slider .product-main-slide');
                var prevIndex = track.__desktopGridCurrentIndex || 0;
                var prevSlide = currentSlides[prevIndex] || currentSlides[0];
                var nextSlide = currentSlides[index];
                if (prevSlide) {
                  this.stopDesktopGridMediaOnSlide(prevSlide);
                }
                if (nextSlide) {
                  this.prepDesktopGridMediaOnSlide(nextSlide);
                }
                track.__desktopGridCurrentIndex = index;
                product.updateInstagramDotsForFlickity(slideshow.slideshow, {
                  mobileOnly: false
                });
              }.bind(this)
            }
          });

          product.setupInstagramDotsForFlickity(slideshow.slideshow, {
            mobileOnly: false
          });
          this.state.desktopGridFlickities.push(slideshow);
        }.bind(this));
      },

      prepDesktopGridMediaOnSlide: function(slide) {
        if (!slide) return;
        var video = slide.querySelector('.product__video');
        if (video && this.product._getVideoType(video) === 'mp4') {
          this.product.playMp4Video(video.id);
        }
      },

      stopDesktopGridMediaOnSlide: function(slide) {
        if (!slide) return;
        var video = slide.querySelector('.product__video');
        if (video && this.product._getVideoType(video) === 'mp4') {
          this.product.stopMp4Video(video.id);
        }
      },

      videoSetupDesktopGrid: function() {
        var product = this.product;
        if (!this.state.mediaModeRoot) return;

        this.state.desktopGridVideoIds = [];
        var desktopGridVideos = this.state.mediaModeRoot.querySelectorAll('.product-media-desktop-grid .product__video');

        product._debugVideoLog('desktop-grid:scan', null, {
          count: desktopGridVideos.length
        });

        desktopGridVideos.forEach(function(vid) {
          this.state.desktopGridVideoIds.push(vid.id);
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            product.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            product.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            product.initMp4Video(vid);
          }
        }.bind(this));
      },

      getVisibleMediaNodes: function(variant) {
        var product = this.product;
        if (!this.state.mobileHost) return [];

        var allNodes = Array.prototype.slice.call(this.state.mobileHost.querySelectorAll('.product-main-slide'));
        var mediaSelection = product.resolveVariantMediaSelection(variant, allNodes);
        var selectors = mediaSelection ? mediaSelection.selectors : [];
        var normalizedOptionValue = mediaSelection ? mediaSelection.normalizedOptionValue : null;
        var materialGroup = mediaSelection ? mediaSelection.materialGroup : null;
        var hasGroupSelector = mediaSelection ? mediaSelection.hasGroupSelector : false;
        var hasExactSelector = mediaSelection ? mediaSelection.hasExactSelector : false;

        return allNodes.filter(function(node) {
          var type = node.dataset.mediaType;
          if (type === 'model') return false;

          var group = node.dataset.group;
          var variantGroup = node.dataset.variantGroup;
          var variantValue = node.dataset.variantValue;

          if (!selectors.length) return true;
          if (!group) return true;
          if (selectors.includes(group)) return true;

          if (product.settings.imageSetName && variantGroup === product.settings.imageSetName) {
            if (normalizedOptionValue && variantValue === normalizedOptionValue) {
              return true;
            }

            if (!hasGroupSelector && !hasExactSelector && materialGroup) {
              var itemMaterialGroup = product.getVariantGroup(variantGroup, variantValue);
              if (itemMaterialGroup === materialGroup) {
                return true;
              }
            }
          }

          return false;
        }).map(function(node) {
          return {
            media_id: node.dataset.mediaId,
            media_type: node.dataset.mediaType,
            is_image: node.dataset.mediaType === 'image',
            is_video: node.dataset.mediaType === 'video' || node.dataset.mediaType === 'external_video',
            node: node
          };
        });
      },

      getVisibleDesktopGridImagesForVariant: function(variant) {
        return this.getVisibleMediaNodes(variant).filter(function(item) {
          return item.is_image;
        });
      },

      getVisibleDesktopGridVideosForVariant: function(variant) {
        return this.getVisibleMediaNodes(variant).filter(function(item) {
          return item.is_video;
        });
      },

      getDesktopGridMediaSignature: function(visibleMedia) {
        return (visibleMedia || []).map(function(item) {
          return item.media_id;
        }).join('|');
      },

      updateDesktopGridForVariant: function(variant) {
        var product = this.product;
        if (!variant || this.state.mediaMode !== 'desktop-grid') return;

        var variantState = this.getDesktopGridVariantState(variant);
        var currentHasSpin = !!product.currentDesktopGridSpinUrl;
        var nextHasSpin = variantState.hasSpin;
        var shouldSkipRebuild =
          product.currentDesktopGridEffectiveMediaGroup === variantState.effectiveMediaGroup &&
          product.currentDesktopGridVisibleMediaSignature === variantState.visibleMediaSignature &&
          currentHasSpin === nextHasSpin;

        if (shouldSkipRebuild) {
          if (product.currentDesktopGridSpinUrl !== variantState.spinUrl) {
            product.currentDesktopGridSpinUrl = variantState.spinUrl;
            product.spinManager.setCurrentUrl(variantState.spinUrl);
            product.resetSpin360Element(variantState.spinUrl);
            if (variantState.spinUrl) {
              product.spinManager.cancelLazyMount();
              product.spinManager.scheduleLazyMount();
            }
          }
          return;
        }
        this.buildDesktopGridFromNodes(variant);
      }
    };

    return MediaModeController;
  })();

  theme.MediaTabsController = (function() {
    function MediaTabsController(product) {
      this.product = product;
      this.container = product.container;
      this.selectors = product.selectors;
    }

    MediaTabsController.prototype = {
      getAvailableTabs: function(variant) {
        if (!variant) {
          return [];
        }

        var availableTabs = ['image', 'video', 'model']
          .filter(function(type) {
            return this.product._hasMediaForVariant(variant, type);
          }.bind(this))
          .map(function(type) {
            return type === 'image' ? 'images' : type + 's';
          });

        if (this.product.spinManager.hasData() && this.product.getSpin360UrlForVariant(variant)) {
          availableTabs.push('spin360');
        }

        return availableTabs;
      },

      updateVisibility: function(variant) {
        var tabsContainer = this.product.cache.mediaTabs;
        if (!tabsContainer) return;

        var availableTabs = this.getAvailableTabs(variant);

        tabsContainer.setAttribute('data-tabs-enabled', availableTabs.length > 1 ? 'true' : 'false');

        this.getButtons().forEach(function(button) {
          var hasMedia = availableTabs.includes(button.dataset.tab);
          button.style.display = hasMedia ? '' : 'none';
          button.setAttribute('aria-hidden', hasMedia ? 'false' : 'true');
        });

        if (this.product.settings.currentMediaType && !availableTabs.includes(this.product.settings.currentMediaType) && availableTabs.length > 0) {
          this.switchTab(availableTabs[0]);
        }

        tabsContainer.classList.toggle('is-hidden', availableTabs.length <= 1);
        this.updateIndicatorVars();
      },

      init: function() {
        var tabsNav = this.product.cache.mediaTabs;
        var panelsWrap = this.product.cache.mediaTabsContent;
        if (!tabsNav || !panelsWrap) return;

        var visibleButtons = this.getVisibleButtons();
        var current = visibleButtons.find(function(button) {
          return button.classList.contains('is-active');
        });
        var initial = current ? current.dataset.tab : (visibleButtons[0] && visibleButtons[0].dataset.tab);
        if (initial) {
          this.switchTab(initial);
        }

        if (this.product._mediaTabsBound) return;
        this.product._mediaTabsBound = true;

        this.product._onMediaTabClick = function(e) {
          var btn = e.target && e.target.closest('.media-tabs .tab-button');
          if (!btn || !this.container.contains(btn)) return;
          e.preventDefault();
          var tab = btn.dataset.tab;
          if (tab) this.switchTab(tab);
        }.bind(this);

        this.container.addEventListener('click', this.product._onMediaTabClick);
      },

      getButtons: function() {
        return this.product.cache.mediaTabs
          ? Array.prototype.slice.call(this.product.cache.mediaTabs.querySelectorAll('.tab-button'))
          : [];
      },

      getPanels: function() {
        return this.product.cache.mediaTabsContent
          ? Array.prototype.slice.call(this.product.cache.mediaTabsContent.querySelectorAll('.media-tab-panel'))
          : [];
      },

      getVisibleButtons: function(excludeTab) {
        var tabsNav = this.product.cache.mediaTabButtonsWrap;
        if (!tabsNav) return [];

        return Array.prototype.slice.call(tabsNav.querySelectorAll('.tab-button')).filter(function(button) {
          return button.style.display !== 'none' && !button.hidden && button.dataset.tab !== excludeTab;
        });
      },

      getFirstAvailableTab: function(excludeTab) {
        var visibleButtons = this.getVisibleButtons(excludeTab);
        return visibleButtons[0] ? visibleButtons[0].dataset.tab : null;
      },

      updateIndicatorVars: function() {
        var tabsNav = this.product.cache.mediaTabButtonsWrap;
        if (!tabsNav) return;

        var visibleButtons = this.getVisibleButtons();
        var activeIndex = visibleButtons.findIndex(function(button) {
          return button.classList.contains('is-active');
        });

        tabsNav.style.setProperty('--tab-count', visibleButtons.length || 1);
        tabsNav.style.setProperty('--active-tab-index', Math.max(activeIndex, 0));
      },

      setActiveTabUI: function(tab, buttons, panels) {
        buttons.forEach(function(btn) {
          var isActive = btn.dataset.tab === tab;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function(panel) {
          var isActive = panel.dataset.tab === tab;
          panel.classList.toggle('is-active', isActive);
          panel.classList.toggle('is-hidden', !isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      },

      syncSpinForTab: function(tab) {
        this.product.spinManager.syncForTab(tab);
      },

      updateThumbsForTab: function(tab) {
        if (tab === 'spin360') {
          return;
        }

        if (this.product.settings.imageSetName) {
          this.product.updateImageSetThumbs(this.product.getCurrentMaterialSet());
        } else {
          this.product.updateImageSetThumbs(null);
        }
      },

      switchTab: function(tab) {
        var product = this.product;
        var tabsNav = product.cache.mediaTabs;
        var panelsWrap = product.cache.mediaTabsContent;
        if (!tabsNav || !panelsWrap) return;

        var buttons = this.getButtons();
        var panels = this.getPanels();

        this.setActiveTabUI(tab, buttons, panels);

        var previousMainSlider = product.cache.mainSlider;
        if (product.flickity && typeof product.flickity.destroy === 'function') {
          try {
            product.flickity.destroy();
            product.flickity = null;
          } catch (err) {
            console.warn('Error destroying slider on tab switch:', err);
          }
        }

        if (previousMainSlider) {
          previousMainSlider.querySelectorAll('.is-selected').forEach(function(slide) {
            slide.classList.remove('is-selected');
          });
        }

        product.settings.currentMediaType = tab;

        var activePanel = panels.find(function(panel) {
          return panel.dataset.tab === tab;
        });
        var sliderEl = activePanel ? activePanel.querySelector(this.selectors.mainSlider) : null;

        if (sliderEl) {
          product.cache.mainSlider = sliderEl;
          product.settings.currentSlideIndex = 0;
          product.initProductSlider();
        }

        this.syncSpinForTab(tab);

        if (product.cache.thumbSlider) {
          product.cache.thumbSlider.classList.toggle('is-hidden', tab === 'spin360');
        }

        this.updateThumbsForTab(tab);
        this.updateIndicatorVars();

        tabsNav.dispatchEvent(new CustomEvent('mediaTabs:change', {
          bubbles: true,
          detail: { tab: tab }
        }));
      },

      destroy: function() {
        if (this.product._onMediaTabClick) {
          this.container.removeEventListener('click', this.product._onMediaTabClick);
          this.product._onMediaTabClick = null;
        }

        this.product._mediaTabsBound = false;
      }
    };

    return MediaTabsController;
  })();

  theme.Product = (function() {

    // Configuration constants for Instagram-style dots
    var INSTAGRAM_DOTS_CONFIG = {
      MOBILE_BREAKPOINT: 768,
      MAX_VISIBLE_DOTS: 5,
      RESIZE_DEBOUNCE_MS: 250,
      INIT_DELAY_MS: 0, // Performance optimized: No delay
      DISTANCE_CLASSES: ['dot-distance-0', 'dot-distance-1', 'dot-distance-2', 'dot-distance-3', 'dot-distance-4'],
      // Performance optimizations
      USE_REQUEST_ANIMATION_FRAME: true,
      BATCH_DOM_UPDATES: true,
      DEFER_DOTS_RENDERING: false,
      // DOM operation batching
      BATCH_SIZE: 10,
      USE_DOM_FRAGMENT: false
    };

    // Instagram dots specific constants (extend existing architecture)
    var instagramDotsClasses = {
      dotVisible: 'flickity-dot-visible',
      flickitySlider: 'flickity-slider'
    };

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      lowInventory: 'inventory--low',
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',
    };

    var materialPreset = [
      "14k-white",
      "14k-gold",
      "14k-rose",
      "18k-white",
      "18k-gold",
      "18k-rose",
      "platinum"
    ];

    // Config object for variant group resolution.
    // Keep this in parity with the SSR normalization in snippets/product-media-tabs.liquid.
    const VARIANT_MAPPINGS = {
      material: {
        white: ['14k-white', '18k-white', '14K White', '18K White'],
        gold: ['14k-gold', '18k-gold', '14K Gold', '18K Gold'],
        rose: ['14k-rose', '18k-rose', '14K Rose', '18K Rose']
      },
      // Color, style, ... any variants for future
      color: {
        white: ['white', 'platinum', 'silver'],
        yellow: ['yellow-gold', 'gold', 'yellow'],
        rose: ['rose-gold', 'rose', 'pink']
      }
    };

    // Generic function
    function getVariantMapping(type) {
      return VARIANT_MAPPINGS[type] || {};
    }

    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');

      this.inModal = (container.dataset.modal === 'true');
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',

        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',

        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
        addToCartPrice: '[data-add-to-cart-price]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
        dynamicVariantsEnabled: '[data-dynamic-variants-enabled]',

        availabilityContainer: '[data-store-availability-holder]',
        productMaterial: '.product-material__text',
        productMaterialContainer: '.product-material__',
        productCustomName: '[data-product-custom-name]',
        variantCustomNames: '[data-variant-custom-name]',

        mediaModeRoot: '[data-product-media-mode]',
        mobileHost: '[data-product-media-mobile-host]',
        desktopHost: '[data-product-media-desktop-host]',
        desktopGridTemplate: '[data-desktop-grid-template]',
        desktopGridSpinTemplate: '[data-desktop-grid-spin-template]',
        desktopGridRoot: '[data-desktop-grid-root]',
        desktopGridList: '[data-desktop-grid-list]',
        desktopGridCarousel: '[data-desktop-grid-carousel-track]',
        desktopGridImageContainer: '[data-desktop-grid-image-container]'
      };

      this.desktopMediaArchitectureEnabled =
        !this.inModal &&
        container.dataset.productContext === 'main-product' &&
        container.dataset.mediaTabsEnabled === 'true' &&
        container.dataset.desktopTwoColumnMedia === 'true';

      this.currentDesktopGridEffectiveMediaGroup = null;
      this.currentDesktopGridVisibleMediaSignature = null;
      this.currentDesktopGridSpinUrl = null;
      this.videoManager = new theme.VideoManager();
      this.spinManager = new theme.SpinViewerManager(this);
      this.mediaModeController = new theme.MediaModeController(this);
      this.mediaTabsController = new theme.MediaTabsController(this);
      defineMediaModeStateAccessors(this);

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider ? this.cache.mainSlider.querySelector('img') : null;

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider ? this.cache.mainSlider.querySelector('[data-set-name]') : null;
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    // Cache selectors to avoid query DOM many times
    Product.prototype.cacheVariantElements = function() {
      if (!this.cache.mainSlider) {
        return;
      }

      this.variantCache = {
        mainSlider: this.cache.mainSlider,
        materialGroups: {
          white: this.cache.mainSlider.querySelector('[data-group="material_white"]'),
          gold: this.cache.mainSlider.querySelector('[data-group="material_gold"]'),
          rose: this.cache.mainSlider.querySelector('[data-group="material_rose"]')
        },
        fallbackGroups: {} // Cache fallback elements
      };
    };

    // Only cache elements when using material grouping
    Product.prototype.initMaterialGrouping = function() {
      if (this.materialGroupingInitialized) return;

      this.cacheVariantElements();
      this.materialGroupingInitialized = true;
    },

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          if (!this._boundModalOpenProduct) {
            this._boundModalOpenProduct = this.openModalProduct.bind(this);
          }
          if (!this._boundModalCloseProduct) {
            this._boundModalCloseProduct = this.closeModalProduct.bind(this);
          }
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this._boundModalOpenProduct);
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this._boundModalCloseProduct);
        }

        if (!this.inModal) {
          if (this._useDesktopGridMediaArchitecture()) {
            this.initBaseProduct();
            this.initDesktopMediaArchitecture();
            return;
          }

          this.formSetup();
          this.productSetup();
          this.videoSetup();
          // If media tabs are enabled, initial Flickity init will be handled by switchMediaTab()
          this.customMediaListeners();
          this.addIdToRecentlyViewed();
          this.initInfoModal();
          this.initInstagramDotsResizeHandler();
        }
      },
      _hasMediaTabs: function() {
        return !!this.cache.mediaTabs;
      },

      _useDesktopGridMediaArchitecture: function() {
        return !!this.desktopMediaArchitectureEnabled;
      },

      _getMediaScope: function() {
        if (this._useDesktopGridMediaArchitecture() && this.mediaModeRoot && this.mediaModeRoot.childElementCount) {
          return this.mediaModeRoot;
        }

        return this.container;
      },

      cacheElements: function() {
        var mediaScope = this._getMediaScope();

        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: mediaScope.querySelector(this.selectors.mainSlider),
          thumbSlider: mediaScope.querySelector(this.selectors.thumbSlider),
          thumbScroller: mediaScope.querySelector(this.selectors.thumbScroller),
          productImageMain: mediaScope.querySelector(this.selectors.productImageMain),

          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
          productCustomName: this.container.querySelector(this.selectors.productCustomName),
          listNameElm: this.container.querySelectorAll(this.selectors.variantCustomNames),

          // Media tabs
          mediaTabs: mediaScope.querySelector('.media-tabs'),
          mediaTabsContent: mediaScope.querySelector('.media-tabs__content'),
          mediaTabButtonsWrap: mediaScope.querySelector('.media-tabs .tab-buttons')
        };
      },

      initBaseProduct: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
        this.initStickyAddToCartButton();
        this.addIdToRecentlyViewed();
        this.initInfoModal();
      },

      initDesktopMediaArchitecture: function() {
        this.mediaModeController.init();
      },

      handleDesktopMediaMqChange: function() {
        this.mediaModeController.handleMqChange();
      },

      getCurrentDesktopMediaMode: function() {
        return this.mediaModeController.getCurrentMode();
      },

      mountActiveMediaMode: function() {
        this.mediaModeController.mountActiveMode();
      },

      initActiveMediaMode: function() {
        this.mediaModeController.initActiveMode();
      },

      unmountActiveMediaMode: function() {
        this.mediaModeController.unmountActiveMode();
      },

      mountDefaultMediaMode: function() {
        this.mediaModeController.mountDefaultMediaMode();
      },

      mountDesktopGridMode: function() {
        this.mediaModeController.mountDesktopGridMode();
      },

      destroyDefaultMediaMode: function() {
        this.mediaModeController.destroyDefaultMediaMode();
      },

      destroyDesktopGridMode: function() {
        this.mediaModeController.destroyDesktopGridMode();
      },

      destroyDesktopGridCarousels: function() {
        if (!this.desktopGridFlickities) return;

        this.desktopGridFlickities.forEach(function(instance) {
          if (instance && instance.slideshow) {
            this._cleanupInstagramDotsController(instance.slideshow);
          }
          if (instance && typeof instance.destroy === 'function') {
            instance.destroy();
          }
        }.bind(this));

        this.desktopGridFlickities = [];
      },

      destroyVideoPlayers: function(videoIds) {
        if (!videoIds || !videoIds.length) return;
        this.videoManager.destroyList(videoIds, this.container);
      },

      destroyDesktopGridVideos: function() {
        this.destroyVideoPlayers(this.desktopGridVideoIds);
        this.desktopGridVideoIds = [];
      },

      destroyDefaultModeVideos: function() {
        this.destroyVideoPlayers(this.defaultModeVideoIds);
        this.defaultModeVideoIds = [];
      },

      destroyPhotoswipeInstance: function(instanceKey) {
        var instance = instanceKey ? this[instanceKey] : null;

        if (!instanceKey || !instance) {
          this[instanceKey] = null;
          return;
        }

        if (Array.isArray(instance)) {
          instance.forEach(function(item) {
            if (item && typeof item.destroy === 'function') {
              item.destroy();
            }
          });
          this[instanceKey] = [];
          return;
        }

        if (typeof instance.destroy !== 'function') {
          this[instanceKey] = null;
          return;
        }

        instance.destroy();
        this[instanceKey] = null;
      },

      _bindAndTrack: function(event, methodName) {
        if (!event || !methodName || typeof this[methodName] !== 'function') {
          return;
        }

        var key = '_bound_' + methodName;
        var trackedEvent = event + '.' + methodName;

        if (!this[key]) {
          this[key] = this[methodName].bind(this);
        }

        this.container.off(trackedEvent);
        this.container.on(trackedEvent, this[key]);

        this._trackedBindings = this._trackedBindings || [];

        if (!this._trackedBindings.some(function(binding) {
          return binding.event === trackedEvent && binding.key === key;
        })) {
          this._trackedBindings.push({ event: trackedEvent, key: key });
        }
      },

      _unbindAllTracked: function() {
        (this._trackedBindings || []).forEach(function(binding) {
          this.container.off(binding.event);
          this[binding.key] = null;
        }.bind(this));

        this._trackedBindings = [];
      },

      ensureVariantMediaListener: function() {
        if (this._boundUpdateImageSet) {
          return;
        }

        this._boundUpdateImageSet = this.updateImageSet.bind(this);
        this.container.on('variantChange' + this.settings.namespace, this._boundUpdateImageSet);

        if (!this._boundDocumentVariantChange) {
          this._boundDocumentVariantChange = function(evt) {
            var detail = evt && evt.detail ? evt.detail : {};
            var sourceSectionId = detail.productSection;

            if (!sourceSectionId && detail.sourceContainer && detail.sourceContainer.getAttribute) {
              sourceSectionId = detail.sourceContainer.getAttribute('data-section-id');
            }

            if (sourceSectionId !== this.sectionId) {
              return;
            }

            if (detail.sourceContainer === this.container) {
              return;
            }

            this.updateImageSet(evt);
          }.bind(this);

          document.addEventListener('variant:change', this._boundDocumentVariantChange);
        }
      },

      getDesktopGridImageSetName: function() {
        return this.mediaModeController.getDesktopGridImageSetName();
      },

      syncActiveMediaStateFromDOM: function() {
        return this.mediaModeController.syncActiveMediaStateFromDOM();
      },

      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }

        // Initialize slider after variants are set up to ensure proper material grouping
        if (!this._hasMediaTabs() && !this.flickity) {
          this.initProductSlider();
        }
      },

      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        // Only initialize media tabs if they exist and are enabled
        if (this._hasMediaTabs()) {
          this.initSpin360();
          if (this.variants && this.variants.currentVariant) {
            this.updateMediaTabsVisibility(this.variants.currentVariant);
          }
          this.initMediaTabs();
        }
      },



      setImageSizes: function() {
        if (!this.settings.hasImages || !this.firstProductImage) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      initInfoModal: function(){
        var infoContainer = this.container.querySelectorAll('.product-logo__item');
        if (!infoContainer) return;

        infoContainer.forEach(elm => {
          // Setup Info modal
          var modalId = 'ProductInfoModal-' + elm.id;
          var name = 'product-info-modal-' + elm.id;

          // Use theme's standard modal behavior
          var modal = new theme.Modals(modalId, name);

          // Add mobile scroll blocking like theme does
          if (elm.classList.contains('product__ring-sizer')) {
            this.addMobileScrollBlocking(modalId);
          }
        })
      },

      addMobileScrollBlocking: function(modalId) {
        var modal = document.getElementById(modalId);
        if (!modal) return;

        // Follow Impulse convention: lock/unlock mobile scrolling via a11y helpers
        document.addEventListener('modalOpen.' + modalId, function() {
          var main = document.querySelector('#MainContent');
          theme.a11y.lockMobileScrolling('.modal-' + modalId, main);
        });

        document.addEventListener('modalClose.' + modalId, function() {
          var main = document.querySelector('#MainContent');
          theme.a11y.unlockMobileScrolling('.modal-' + modalId, main);
        });
      },

      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };

        theme.utils.trimRecentlyViewedCache(
          theme.recentlyViewed.recent,
          theme.recentlyViewed.productCards,
          theme.config.recentlyViewedStorageLimit
        );

        if (theme.config.hasLocalStorage) {
          theme.utils.safeStorageSet(window.localStorage, 'theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(selectors.dynamicVariantsEnabled)

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled,
          initModal: true
        };

        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }

        this.variants = new theme.Variants(options);

        if (theme.VariantScroller && !this.inModal && this.container.querySelector('[data-variant-scroller]')) {
          this.variantScroller = new theme.VariantScroller(this.container);
        }

        if (theme.VariantCollapse && !this.inModal && this.container.querySelector('[data-variant-collapse]')) {
          this.variantCollapse = new theme.VariantCollapse(this.container);
        }

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this._bindAndTrack('variantChange' + this.settings.namespace, 'updateAvailability');
        }

        if (this.variantScroller || this.variantCollapse) {
          this._bindAndTrack('variantChange' + this.settings.namespace, 'updateVariantLayouts');
        }

        this._bindAndTrack('variantChange' + this.settings.namespace, 'updateCartButton');
        this._bindAndTrack('variantImageChange' + this.settings.namespace, 'updateVariantImage');
        this._bindAndTrack('variantPriceChange' + this.settings.namespace, 'updatePrice');
        this._bindAndTrack('variantUnitPriceChange' + this.settings.namespace, 'updateUnitPrice');

        if (this.container.querySelector(this.selectors.sku)) {
          this._bindAndTrack('variantSKUChange' + this.settings.namespace, 'updateSku');
        }

        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;

          // Update inventory on page load
          this.updateInventory({ detail: { variant: this.variants.currentVariant } });

          this._bindAndTrack('variantChange' + this.settings.namespace, 'updateInventory');
        }

        var materialMark = this.container.querySelector(this.selectors.productMaterial);
        if(materialMark) {
          this._bindAndTrack('variantChange' + this.settings.namespace, 'updateDetailInfo');
        }

        // Update individual variant availability on each selection
        if (dynamicVariantsEnabled) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.ensureVariantMediaListener();
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },

      initAjaxProductForm: function() {
        new theme.AjaxProduct(this.cache.form);
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateVariantLayouts: function() {
        if (this.variantScroller) {
          this.variantScroller.scrollToSelected();
        }

        if (this.variantCollapse) {
          this.variantCollapse.syncToSelected();
        }
      },

      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        // this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
        var variantColorNames = this.container.querySelectorAll(this.selectors.colorLabel + `[data-index="${index}"`);
        variantColorNames.forEach(elm => {
          elm.textContent = color;
        })
      },

      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);

        if (!cartBtn) return;

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }

        this.scheduleStickyAddToCartSync();
      },

      updatePrice: function(evt) {
        var variant = evt.detail.variant;

        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);

          // Update add-to-cart button price
          var addToCartPrice = this.container.querySelector(this.selectors.addToCartPrice);
          var addToCartButton = this.container.querySelector(this.selectors.addToCart);

          if (addToCartPrice) {
            var formattedPrice = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
            addToCartPrice.textContent = ' — ' + formattedPrice;

            // Show/hide price based on availability
            if (variant.available) {
              addToCartPrice.style.display = 'inline';
              if (addToCartButton) {
                addToCartButton.disabled = false;
              }
            } else {
              addToCartPrice.style.display = 'none';
              if (addToCartButton) {
                addToCartButton.disabled = true;
              }
            }
          }

          this.scheduleStickyAddToCartSync();

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');

            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },

      initStickyAddToCartButton: function() {
        this.teardownStickyAddToCartButton();

        if (this.container.dataset.productContext !== 'main-product' ||
            this.container.dataset.stickyAddToCartEnabled !== 'true') {
          return;
        }

        this._stickyAddToCart = this.container.querySelector('[data-sticky-add-to-cart]');
        this._stickyAddToCartBtn = this.container.querySelector('[data-sticky-add-to-cart-btn]');
        this._stickyAddToCartText = this.container.querySelector('[data-sticky-add-to-cart-text]');
        this._stickyAddToCartPrice = this.container.querySelector('[data-sticky-add-to-cart-price]');
        this._addToCartForm = this.cache.form || this.container.querySelector(this.selectors.form);
        this._footerEl = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('.site-footer');
        this._stickyAddToCartNamespace = this.settings.namespace + '-sticky-atc';

        if (!this._stickyAddToCart || !this._stickyAddToCartBtn || !this._addToCartForm) {
          return;
        }

        this._boundStickyAddToCartClick = this.onStickyAddToCartClick.bind(this);
        this._boundStickyAddToCartTouchEnd = this.onStickyAddToCartTouchEnd.bind(this);
        this._stickyAddToCartBtn.addEventListener('click', this._boundStickyAddToCartClick);
        this._stickyAddToCartBtn.addEventListener('touchend', this._boundStickyAddToCartTouchEnd, { passive: false });
        this._boundStickyAddToCartResponsive = this.refreshStickyAddToCartButton.bind(this);

        window.off('resize' + this._stickyAddToCartNamespace);
        window.on('resize' + this._stickyAddToCartNamespace, this._boundStickyAddToCartResponsive);

        this.refreshStickyAddToCartButton();
      },

      teardownStickyAddToCartButton: function() {
        if (this._stickyAddToCartNamespace) {
          window.off('resize' + this._stickyAddToCartNamespace);
        }

        if (this._stickyAddToCartBtn && this._boundStickyAddToCartClick) {
          this._stickyAddToCartBtn.removeEventListener('click', this._boundStickyAddToCartClick);
        }
        if (this._stickyAddToCartBtn && this._boundStickyAddToCartTouchEnd) {
          this._stickyAddToCartBtn.removeEventListener('touchend', this._boundStickyAddToCartTouchEnd);
        }

        this.disableStickyAddToCartButton();

        if (this._stickyAddToCart) {
          this._stickyAddToCart.classList.remove('is-visible');
        }

        document.body.classList.remove('product-sticky-atc-visible');
        document.body.style.removeProperty('--product-sticky-atc-offset');

        this._stickyAddToCart = null;
        this._stickyAddToCartBtn = null;
        this._stickyAddToCartText = null;
        this._stickyAddToCartPrice = null;
        this._addToCartForm = null;
        this._primaryAddToCartBtn = null;
        this._stickyAddToCartButtons = null;
        this._footerEl = null;
        this._stickyAddToCartObserver = null;
        this._boundStickyAddToCartClick = null;
        this._boundStickyAddToCartTouchEnd = null;
        this._boundStickyAddToCartResponsive = null;
        this._boundStickyAddToCartVisibility = null;
        this._boundStickyAddToCartSync = null;
        this._stickyAddToCartNamespace = null;
        this._stickyAddToCartEnabled = false;
        this._stickyAddToCartVisibilityFrame = null;
        this._stickyAddToCartSyncFrame = null;
        this._lastStickyAddToCartTouchAt = 0;
      },

      getStickyAddToCartButtons: function() {
        if (!this._addToCartForm) {
          return [];
        }

        if (!this._stickyAddToCartButtons) {
          this._stickyAddToCartButtons = Array.prototype.slice.call(this._addToCartForm.querySelectorAll(this.selectors.addToCart));
        }

        return this._stickyAddToCartButtons;
      },

      isStickyAddToCartButtonVisible: function(button) {
        if (!button) {
          return false;
        }

        var style = window.getComputedStyle(button);
        var rect = button.getBoundingClientRect();

        return style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.width > 0 &&
          rect.height > 0;
      },

      resolvePrimaryAddToCartButton: function() {
        var buttons = this.getStickyAddToCartButtons();
        var visibleButtons = buttons.filter(this.isStickyAddToCartButtonVisible.bind(this));

        if (visibleButtons.length) {
          this._primaryAddToCartBtn = visibleButtons[0];
          return;
        }

        this._primaryAddToCartBtn = buttons.length ? buttons[0] : null;
      },

      refreshStickyAddToCartButton: function() {
        if (!this._stickyAddToCart || !this._stickyAddToCartBtn || !this._addToCartForm) {
          return;
        }

        // Keep this aligned with the mobile CSS breakpoint: max-width 768px / min-width 769px.
        if (window.innerWidth > 768) {
          this.disableStickyAddToCartButton();
          return;
        }

        if (!this._stickyAddToCartEnabled) {
          this.enableStickyAddToCartButton();
        }

        this.scheduleStickyAddToCartSync();
      },

      enableStickyAddToCartButton: function() {
        if (this._stickyAddToCartEnabled) {
          return;
        }

        this._stickyAddToCartEnabled = true;
        this._boundStickyAddToCartVisibility = this.scheduleStickyAddToCartVisibility.bind(this);
        this._boundStickyAddToCartSync = this.onStickyAddToCartMutations.bind(this);

        this._stickyAddToCartObserver = new MutationObserver(this._boundStickyAddToCartSync);
        this._stickyAddToCartObserver.observe(this._addToCartForm, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'style'],
          childList: true,
          subtree: true
        });

        window.off('scroll' + this._stickyAddToCartNamespace);
        window.on('scroll' + this._stickyAddToCartNamespace, this._boundStickyAddToCartVisibility);
      },

      disableStickyAddToCartButton: function() {
        if (this._stickyAddToCartObserver) {
          this._stickyAddToCartObserver.disconnect();
          this._stickyAddToCartObserver = null;
        }

        if (this._stickyAddToCartNamespace) {
          window.off('scroll' + this._stickyAddToCartNamespace);
        }

        if (this._stickyAddToCartVisibilityFrame) {
          window.cancelAnimationFrame(this._stickyAddToCartVisibilityFrame);
          this._stickyAddToCartVisibilityFrame = null;
        }

        if (this._stickyAddToCartSyncFrame) {
          window.cancelAnimationFrame(this._stickyAddToCartSyncFrame);
          this._stickyAddToCartSyncFrame = null;
        }

        this._stickyAddToCartEnabled = false;

        if (this._stickyAddToCart) {
          this._stickyAddToCart.classList.remove('is-visible');
        }

        document.body.classList.remove('product-sticky-atc-visible');
        document.body.style.removeProperty('--product-sticky-atc-offset');
      },

      scheduleStickyAddToCartSync: function() {
        if (!this._stickyAddToCartEnabled || this._stickyAddToCartSyncFrame) {
          return;
        }

        this._stickyAddToCartSyncFrame = window.requestAnimationFrame(function() {
          this._stickyAddToCartSyncFrame = null;
          this.syncStickyAddToCartState();
        }.bind(this));
      },

      scheduleStickyAddToCartVisibility: function() {
        if (!this._stickyAddToCartEnabled || this._stickyAddToCartVisibilityFrame) {
          return;
        }

        this._stickyAddToCartVisibilityFrame = window.requestAnimationFrame(function() {
          this._stickyAddToCartVisibilityFrame = null;
          this.updateStickyAddToCartVisibility();
        }.bind(this));
      },

      onStickyAddToCartMutations: function(mutations) {
        if (mutations && mutations.some(function(mutation) {
          return mutation.type === 'childList';
        })) {
          this._stickyAddToCartButtons = null;
        }

        this.scheduleStickyAddToCartSync();
      },

      syncStickyAddToCartState: function() {
        this.resolvePrimaryAddToCartButton();
        this.syncStickyAddToCartButton();
        this.updateStickyAddToCartVisibility();
      },

      getStickyAddToCartMirroredClasses: function(button) {
        if (!button) {
          return [];
        }

        return Array.prototype.filter.call(button.classList, function(className) {
          return className === 'btn' ||
            className === 'custom-add-to-cart' ||
            className.indexOf('btn--') === 0;
        });
      },

      syncStickyAddToCartButton: function() {
        if (!this._stickyAddToCartBtn || !this._primaryAddToCartBtn) {
          return;
        }

        var mirroredClasses = this.getStickyAddToCartMirroredClasses(this._primaryAddToCartBtn);
        var buttonText = this._primaryAddToCartBtn.querySelector(this.selectors.addToCartText);
        var buttonPrice = this._primaryAddToCartBtn.querySelector(this.selectors.addToCartPrice);
        var nextText = buttonText ? buttonText.textContent.trim() : this._primaryAddToCartBtn.textContent.trim();
        var nextPrice = buttonPrice ? buttonPrice.textContent : '';
        var shouldShowPrice = !!(buttonPrice && window.getComputedStyle(buttonPrice).display !== 'none');
        var nextClassName = mirroredClasses.concat(['product-sticky-atc__btn']).join(' ').trim();
        var nextAriaDisabled = this._primaryAddToCartBtn.disabled ? 'true' : 'false';
        var nextPriceDisplay = shouldShowPrice ? 'inline' : 'none';

        if (this._stickyAddToCartBtn.className !== nextClassName) {
          this._stickyAddToCartBtn.className = nextClassName;
        }

        if (this._stickyAddToCartBtn.disabled !== this._primaryAddToCartBtn.disabled) {
          this._stickyAddToCartBtn.disabled = this._primaryAddToCartBtn.disabled;
        }

        if (this._stickyAddToCartBtn.getAttribute('aria-disabled') !== nextAriaDisabled) {
          this._stickyAddToCartBtn.setAttribute('aria-disabled', nextAriaDisabled);
        }

        if (this._stickyAddToCartText && this._stickyAddToCartText.textContent !== nextText) {
          this._stickyAddToCartText.textContent = nextText;
        }

        if (this._stickyAddToCartPrice) {
          if (this._stickyAddToCartPrice.textContent !== nextPrice) {
            this._stickyAddToCartPrice.textContent = nextPrice;
          }

          if (this._stickyAddToCartPrice.style.display !== nextPriceDisplay) {
            this._stickyAddToCartPrice.style.display = nextPriceDisplay;
          }
        }
      },

      updateStickyAddToCartVisibility: function() {
        if (!this._stickyAddToCart || !this._primaryAddToCartBtn) {
          return;
        }

        // Keep this aligned with the mobile CSS breakpoint: max-width 768px / min-width 769px.
        if (window.innerWidth > 768) {
          this._stickyAddToCart.classList.remove('is-visible');
          document.body.classList.remove('product-sticky-atc-visible');
          document.body.style.removeProperty('--product-sticky-atc-offset');
          return;
        }

        var stickyHeader = document.querySelector('.site-header--stuck');
        var viewportTopOffset = stickyHeader ? stickyHeader.getBoundingClientRect().bottom : 0;
        var primaryButtonRect = this._primaryAddToCartBtn.getBoundingClientRect();
        var footerVisible = this._footerEl ? this._footerEl.getBoundingClientRect().top <= window.innerHeight : false;
        var isPrimaryVisibleInViewport = primaryButtonRect.bottom > viewportTopOffset && primaryButtonRect.top < window.innerHeight;
        var isPrimaryAboveHeader = primaryButtonRect.bottom <= viewportTopOffset;
        var shouldShow = !footerVisible && !isPrimaryVisibleInViewport && isPrimaryAboveHeader;

        this._stickyAddToCart.classList.toggle('is-visible', shouldShow);
        document.body.classList.toggle('product-sticky-atc-visible', shouldShow);
        if (shouldShow) {
          document.body.style.setProperty('--product-sticky-atc-offset', this._stickyAddToCart.offsetHeight + 'px');
        } else {
          document.body.style.removeProperty('--product-sticky-atc-offset');
        }
      },

      triggerStickyAddToCart: function() {
        if (!this._primaryAddToCartBtn || this._primaryAddToCartBtn.disabled || this._primaryAddToCartBtn.classList.contains('btn--loading')) {
          return;
        }

        if (this._stickyAddToCartBtn) {
          this._stickyAddToCartBtn.classList.add('btn--loading');
        }

        this.scheduleStickyAddToCartSync();
        this._primaryAddToCartBtn.click();
      },

      onStickyAddToCartTouchEnd: function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this._lastStickyAddToCartTouchAt = Date.now();
        this.triggerStickyAddToCart();
      },

      onStickyAddToCartClick: function(evt) {
        evt.preventDefault();

        if (this._lastStickyAddToCartTouchAt && (Date.now() - this._lastStickyAddToCartTouchAt) < 750) {
          return;
        }

        evt.stopPropagation();
        this.triggerStickyAddToCart();
      },

      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      imageSetArguments: function(variant) {
        variant = variant || this.variants?.currentVariant;
        if (!variant || !this.settings.imageSetName || this.settings.imageSetIndex == null) return;

        var mediaSelection = this.resolveVariantMediaSelection(variant);
        if (!mediaSelection || !mediaSelection.primarySelector) return;

        this.settings.currentImageSet = mediaSelection.setValue;
        var selector = '[data-group="' + mediaSelection.primarySelector + '"]';

        return {
          cellSelector: selector,
          imageSet: mediaSelection.primarySelector,
          initialIndex: 0
        };
      },

      updateImageSet: function(evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }

        if (this._useDesktopGridMediaArchitecture() && this.mediaMode === 'desktop-grid') {
          this.mediaModeController.updateDesktopGridForVariant(variant);
          return;
        }

        var mediaSelection = this.resolveVariantMediaSelection(variant);
        if (!mediaSelection) {
          return;
        }

        // Already on the current image group
        if (this.settings.currentImageSet === mediaSelection.setValue) {
          return;
        }

        // Store new image set for later use
        this.settings.currentImageSet = mediaSelection.setValue;

        // Handle media tabs logic
        if (this._hasMediaTabs()) {
          this.updateMediaTabsVisibility(variant);
          // Re-init slider if already exists, otherwise let switchMediaTab() handle it
          if (this.flickity) {
            this.initProductSlider(variant);
          }
          return;
        }

        // Default behaviour when media tabs are disabled
        this.initProductSlider(variant);
      },





      _getAvailableMediaTabs: function(variant) {
        return this.mediaTabsController.getAvailableTabs(variant);
      },

      // Update media tabs visibility based on current variant
      updateMediaTabsVisibility: function(variant) {
        return this.mediaTabsController.updateVisibility(variant);
      },

      // Check if variant has media of specific type
      _hasMediaForVariant: function(variant, mediaType) {
        if (!variant) return false;

        var mediaSelection = this.resolveVariantMediaSelection(variant);
        var selectors = mediaSelection ? mediaSelection.selectors : [];

        if (!selectors.length) {
          return this._hasMediaInPanel(mediaType);
        }

        // Check if any selector has the requested media type
        return selectors.some(format =>
          this._checkMediaTypeWithSelector('[data-group="' + format + '"]', mediaType)
        );
      },

      _hasMediaInPanel: function(mediaType) {
        var panelMap = {
          image: 'images',
          video: 'videos',
          model: 'models'
        };
        var panelTab = panelMap[mediaType];
        if (!panelTab) return false;

        var panel = this.container.querySelector('.media-tab-panel[data-tab="' + panelTab + '"]');
        if (!panel) return false;

        var mediaTypeMap = {
          image: ['image'],
          video: ['video', 'external_video'],
          model: ['model']
        };

        return (mediaTypeMap[mediaType] || [mediaType]).some(function(type) {
          return !!panel.querySelector('[data-media-type="' + type + '"]');
        });
      },

      // Helper function to check media type with a specific selector
      _checkMediaTypeWithSelector: function(selector, mediaType) {
        // Special case: check for any media type
        if (mediaType === 'any') {
          return !!this.container.querySelector(selector + '[data-media-type]');
        }

        var mediaTypeMap = {
          'video': ['video', 'external_video'],
          'image': ['image'],
          'model': ['model']
        };

        var mediaTypes = mediaTypeMap[mediaType] || [mediaType];
        return mediaTypes.some(type =>
          this.container.querySelector(selector + '[data-media-type="' + type + '"]')
        );
      },

      resolveVariantMediaSelection: function(variant, nodes) {
        variant = variant || this.variants?.currentVariant;
        if (!variant || !this.settings.imageSetName || this.settings.imageSetIndex == null) {
          return null;
        }

        var optionName = this.settings.imageSetName;
        var optionValue = variant[this.settings.imageSetIndex];

        if (!optionValue) {
          return null;
        }

        var normalizedOptionValue = this.getImageSetName(optionValue);
        var materialGroup = this.getVariantGroup(optionName, optionValue);
        var groupSelector = materialGroup ? optionName + '_' + materialGroup : null;
        var exactSelector = optionName + '_' + normalizedOptionValue;
        var hasSelector = function(selector, matchVariantValue) {
          if (!selector) return false;

          if (nodes && nodes.length) {
            return nodes.some(function(node) {
              return node.dataset.group === selector ||
                (matchVariantValue &&
                 node.dataset.variantGroup === optionName &&
                 node.dataset.variantValue === normalizedOptionValue);
            });
          }

          return this._checkMediaTypeWithSelector('[data-group="' + selector + '"]', 'any');
        }.bind(this);
        var hasGroupSelector = hasSelector(groupSelector, false);
        var hasExactSelector = hasSelector(exactSelector, true);
        var selectors = [];

        if (hasGroupSelector) {
          selectors = [groupSelector];
        } else if (hasExactSelector) {
          selectors = [exactSelector];
        } else if (materialGroup) {
          selectors = this._getMaterialGroupSelectors(materialGroup, true);
        } else {
          selectors = [exactSelector];
        }

        selectors = selectors.filter(function(selector, index, arr) {
          return !!selector && arr.indexOf(selector) === index;
        });

        return {
          exactSelector: exactSelector,
          groupSelector: groupSelector,
          hasExactSelector: hasExactSelector,
          hasGroupSelector: hasGroupSelector,
          materialGroup: materialGroup,
          normalizedOptionValue: normalizedOptionValue,
          primarySelector: selectors[0] || null,
          selectors: selectors,
          setValue: selectors[0] ? selectors[0].replace(optionName + '_', '') : normalizedOptionValue
        };
      },

      // Helper function to get material group selectors with fallbacks
      _getMaterialGroupSelectors: function(materialGroup, includeNewFormat = true) {
        var selectors = [];

        if (includeNewFormat) {
          var newFormatSelector = this.settings.imageSetName + '_' + materialGroup;
          var hasNewFormat = this._checkMediaTypeWithSelector('[data-group="' + newFormatSelector + '"]', 'any');

          if (hasNewFormat) {
            selectors.push(newFormatSelector);
          }
        }

        [
          this.settings.imageSetName + '_14k-' + materialGroup,
          this.settings.imageSetName + '_18k-' + materialGroup
        ].forEach(function(selector) {
          var hasSelector = this._checkMediaTypeWithSelector('[data-group="' + selector + '"]', 'any');

          if (hasSelector) {
            selectors.push(selector);
          }
        }.bind(this));

        return selectors.filter(function(selector, index, arr) {
          return !!selector && arr.indexOf(selector) === index;
        });
      },

      // Show/hide thumbnails based on current image set and media type
      updateImageSetThumbs: function(set) {
        if (!this.cache.thumbSlider) return;

        var currentMediaType = this.settings.currentMediaType;

        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          // Filter by material group
          var shouldHide = set && thumb.dataset.group !== set;

          // Filter by media type when media tabs are enabled
          if (currentMediaType && thumb.dataset.mediaType) {
            var mediaTypeMap = {
              'images': ['image'],
              'videos': ['video', 'external_video'],
              'models': ['model']
            };

            var allowedTypes = mediaTypeMap[currentMediaType] || [];
            shouldHide = shouldHide || !allowedTypes.includes(thumb.dataset.mediaType);
          }

          thumb.classList.toggle(classes.hidden, shouldHide);
        });
      },

      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },

      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function(evt) {
        var variant = evt.detail.variant;

        // Override to display in stock message for sold out variants with policy set to continue
        // Must be set to true in order to display in stock message for sold out variants
        const inStockForOOSAndContinueSelling = false;

        if (!variant) {
          // Variant is unavailable
          // So we want to hide both the inventory quantity + incoming transfer notice
          this.toggleInventoryQuantity('hidden', false);
          this.toggleIncomingInventory(false);
          return;
        }

        // Inventory management is nil
        // So we want to hide the low inventory message but show an In stock status
        // And hide the incoming transfer notice
        if (!variant.inventory_management) {
          this.toggleInventoryQuantity('visible', false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          const variantInventoryObject = window.inventories[this.productId][variant.id];

          const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};

          this.toggleInventoryQuantity(undefined, quantity);

          if (inStockForOOSAndContinueSelling) {
            if (quantity <= 0 && policy === 'continue') {
              this.toggleInventoryQuantity('visible', false);
              this.toggleIncomingInventory(false);
              return;
            }
          }

          if ((incoming && !variant.available) || (quantity <= 0 && policy === 'continue')) {
            this.toggleIncomingInventory(true, next_incoming_date, policy);
          } else {
            this.toggleIncomingInventory(false);
          }
        }
      },

      updateDetailInfo: function(evt) {
        var variant = evt.detail.variant;
        var materialName = '';
        materialPreset.forEach(_value => {
          var elm = this.container.querySelector(this.selectors.productMaterialContainer + _value);
          if(!elm) return;
          var variantName = variant.name.toLowerCase().replace(/ /g,'-');
          if(variantName.includes(_value)) {
            elm.classList.remove('hide');
            elm.classList.add('is-display');
            materialName = _value;
          } else {
            elm.classList.remove('is-display');
            elm.classList.add('hide');
          }
        })

        this.container.querySelector(this.selectors.productMaterial).innerText = materialName.replace('-',' ');
      },

      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      updateCustomName: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        if (!this.cache.listNameElm || this.cache.listNameElm.length == 0) {
          return;
        }

        var arrayList =  Array.from(this.cache.listNameElm);
        arrayList.every(elm => {
          var innerText = elm.innerText.trim();
          var splitText = innerText.split("#");

          if (splitText[0] == variant.sku && splitText[1]) {
            this.cache.productCustomName.innerHTML = splitText[1];
            return false;
          }
          else return true;
        })
      },

      toggleInventoryQuantity: function(state = undefined, quantity) {
        const productInventoryEl = this.container.querySelector(this.selectors.inventory);
        const inventorySalesPoint = productInventoryEl.closest('.sales-point');

        if (state && state === 'hidden') {
          // variant is unavailable
          // hide and return
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }

          return;
        }

        let showLowInventoryMessage = false;

        // Check if we should show low inventory message
        if (parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) && parseInt(quantity) > 0) {
          showLowInventoryMessage = true;
        }

        if (parseInt(quantity) > 0 || (state && state === 'visible')) {
          if (showLowInventoryMessage) {
            productInventoryEl.parentNode.classList.add(classes.lowInventory);
            if (quantity > 1) {
              productInventoryEl.textContent = theme.strings.otherStockLabel.replace('[count]', quantity);
            } else {
              productInventoryEl.textContent = theme.strings.oneStockLabel.replace('[count]', quantity);
            }
          } else {
            productInventoryEl.parentNode.classList.remove(classes.lowInventory);
            productInventoryEl.textContent = theme.strings.inStockLabel;
          }

          if (inventorySalesPoint) {
            inventorySalesPoint.classList.remove(classes.hidden);
          }

        } else {
          if (inventorySalesPoint) {
            inventorySalesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function(showIncomingInventory, incomingInventoryDate, policy) {

        const incomingInventoryEl = this.container.querySelector(this.selectors.incomingInventory);
        const incomingInventoryIcon = incomingInventoryEl.querySelector('.icon-and-text');

        if (!incomingInventoryEl) return;

        const incomingInventoryBlockEnabled = incomingInventoryEl.dataset.enabled === 'true';
        const textEl = incomingInventoryEl.querySelector('.js-incoming-text');

        // If incoming inventory block is disabled, hide it
        if (!incomingInventoryBlockEnabled) {
          incomingInventoryEl.classList.add(classes.hidden);
          return;
        }

        if (showIncomingInventory) {
          if (incomingInventoryDate) {
            textEl.textContent = theme.strings.willBeInStockAfter.replace('[date]', incomingInventoryDate);
            incomingInventoryEl.classList.remove(classes.hidden);
          } else {
            textEl.textContent = theme.strings.waitingForStock;
            incomingInventoryEl.classList.remove(classes.hidden);
          }

          // When OOS and incoming inventory and continue selling disabled, update icon to low inventory
          if (incomingInventoryIcon) {
            if (policy !== 'continue') {
              incomingInventoryIcon.classList.add(classes.lowInventory);
            } else {
              incomingInventoryIcon.classList.remove(classes.lowInventory);
            }
          }

        } else {
          incomingInventoryEl.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        if (!this.cache.mainSlider) {
          return false;
        }

        this.defaultModeVideoIds = [];
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach(vid => {
          this.defaultModeVideoIds.push(vid.id);
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'vimeo') {
            this.initVimeoVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function(div) {
        this.videoManager.register(
          div.id,
          new theme.YouTube(
            div.id,
            {
              videoId: div.dataset.videoId,
              videoParent: selectors.videoParent,
              autoplay: false, // will handle this in callback
              style: div.dataset.videoStyle,
              loop: div.dataset.videoLoop,
              events: {
                onReady: this.youtubePlayerReady.bind(this),
                onStateChange: this.youtubePlayerStateChange.bind(this)
              }
            }
          )
        );
      },

      initVimeoVideo: function(div) {
        this.videoManager.register(
          div.id,
          new theme.VimeoPlayer(
            div.id,
            div.dataset.videoId,
            {
              videoParent: selectors.videoParent,
              autoplay: false,
              style: div.dataset.videoStyle,
              loop: div.dataset.videoLoop,
            }
          )
        )
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;

        var obj = this.videoManager.get(iframeId);

        if (!obj) {
          // No youtube player data
          return;
        }

        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute();
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
        obj.parent.classList.add('video-interactable'); // Previously, video was only interactable after slide change

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      _isFirstSlide: function(id) {
        if (!this.cache.mainSlider) {
          return false;
        }
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = this.videoManager.get(iframeId);

        if (!obj) {
          return;
        }

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function(div) {
        this.videoManager.register(div.id, {
          id: div.id,
          type: 'mp4'
        });

        div.dataset.mp4RecoveryAttempted = 'false';
        this._bindMp4LoadingState(div);
        this._setVideoWrapperLoadingState(div);

        if (div.readyState >= 2) {
          this._setVideoWrapperLoadedState(div);
        }

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
      stopVideos: function() {
        this.videoManager.stopAll(this.container);
      },

      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },

      _getVideoDivId: function(video) {
        return video.id;
      },

      _isVideoDebugEnabled: function() {
        try {
          return window.localStorage && window.localStorage.getItem('debugProductVideo') === '1';
        } catch (error) {
          return false;
        }
      },

      _getVideoDebugState: function(player) {
        if (!player) {
          return {};
        }

        return {
          id: player.id,
          currentSrc: player.currentSrc || player.getAttribute('src') || null,
          currentTime: typeof player.currentTime === 'number' ? player.currentTime : null,
          networkState: typeof player.networkState === 'number' ? player.networkState : null,
          paused: typeof player.paused === 'boolean' ? player.paused : null,
          readyState: typeof player.readyState === 'number' ? player.readyState : null
        };
      },

      _debugVideoLog: function(action, player, extra) {
        if (!this._isVideoDebugEnabled()) {
          return;
        }

        var payload = Object.assign({
          action: action,
          mediaMode: this.mediaMode,
          sectionId: this.sectionId
        }, this._getVideoDebugState(player), extra || {});

        console.log('[ProductVideoDebug]', payload);
      },

      _setVideoWrapperLoadingState: function(player) {
        var wrapper = player && player.closest ? player.closest(selectors.videoParent) : null;
        if (!wrapper) return;

        wrapper.classList.add('loading');
        wrapper.classList.remove('loaded');
        wrapper.classList.remove('video-interactable');
        this._debugVideoLog('wrapper:loading', player);
      },

      _setVideoWrapperLoadedState: function(player) {
        var wrapper = player && player.closest ? player.closest(selectors.videoParent) : null;
        if (!wrapper) return;

        wrapper.classList.remove('loading');
        wrapper.classList.add('loaded');
        wrapper.classList.add('video-interactable');
        this._debugVideoLog('wrapper:loaded', player);
      },

      _getPreferredMp4Source: function(player) {
        if (!player || !player.querySelector) {
          return null;
        }

        return player.querySelector('source[type="video/mp4"]');
      },

      _isStreamingVideoSource: function(player) {
        if (!player) {
          return false;
        }

        var currentSrc = player.currentSrc || player.getAttribute('src') || '';
        return currentSrc.indexOf('.m3u8') > -1 || currentSrc.indexOf('/videos/c/vp/') > -1;
      },

      _enableManualMp4Playback: function(player, reason) {
        if (!player) {
          return;
        }

        player.setAttribute('controls', '');
        player.muted = false;
        player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
        this._setVideoWrapperLoadedState(player);
        this._debugVideoLog('play:manual-fallback', player, {
          reason: reason || null
        });
      },

      _forceMp4Source: function(player, reason) {
        var mp4Source = this._getPreferredMp4Source(player);
        if (!mp4Source || !mp4Source.src) {
          this._debugVideoLog('source:mp4-missing', player, {
            reason: reason || null
          });
          return false;
        }

        if (player.dataset.forcedMp4Src === mp4Source.src) {
          return true;
        }

        player.dataset.forcedMp4Src = mp4Source.src;
        player.src = mp4Source.src;
        player.load();
        this._debugVideoLog('source:forced-mp4', player, {
          reason: reason || null,
          mp4Src: mp4Source.src
        });
        return true;
      },

      _preferMp4Source: function(player, reason) {
        if (!player || !this._getPreferredMp4Source(player)) {
          return;
        }

        if (this._isStreamingVideoSource(player) || !player.getAttribute('src')) {
          this._forceMp4Source(player, reason);
        }
      },

      _recoverMp4Playback: function(player, reason) {
        if (!player) {
          return;
        }

        if (player.dataset.mp4RecoveryAttempted === 'true') {
          this._enableManualMp4Playback(player, reason || 'recovery-exhausted');
          return;
        }

        player.dataset.mp4RecoveryAttempted = 'true';
        this._debugVideoLog('play:recover-attempt', player, {
          reason: reason || null
        });

        this._forceMp4Source(player, reason || 'recover');
        this.playMp4Video(player.id);
      },

      _bindMp4LoadingState: function(player) {
        if (!player || player.dataset.videoStateBound === 'true') {
          return;
        }

        player.dataset.videoStateBound = 'true';
        this._preferMp4Source(player, 'bind');

        player.addEventListener('loadeddata', function() {
          player.dataset.mp4RecoveryAttempted = 'false';
          this._debugVideoLog('event:loadeddata', player);
          this._setVideoWrapperLoadedState(player);
        }.bind(this));

        player.addEventListener('canplay', function() {
          this._debugVideoLog('event:canplay', player);
          this._setVideoWrapperLoadedState(player);
        }.bind(this));

        player.addEventListener('playing', function() {
          this._debugVideoLog('event:playing', player);
          this._setVideoWrapperLoadedState(player);
        }.bind(this));

        player.addEventListener('waiting', function() {
          this._debugVideoLog('event:waiting', player);
          this._setVideoWrapperLoadingState(player);
        }.bind(this));

        ['stalled', 'suspend', 'abort', 'emptied', 'error'].forEach(function(eventName) {
          player.addEventListener(eventName, function() {
            var mediaError = player.error ? {
              code: player.error.code,
              message: player.error.message || null
            } : null;

            if (eventName === 'stalled' || eventName === 'emptied') {
              this._setVideoWrapperLoadingState(player);

              if (this._isStreamingVideoSource(player) || player.dataset.forcedMp4Src) {
                this._recoverMp4Playback(player, eventName);
              }
            }

            if (eventName === 'error') {
              this._enableManualMp4Playback(player, eventName);
            }

            this._debugVideoLog('event:' + eventName, player, {
              mediaError: mediaError
            });
          }.bind(this));
        }.bind(this));
      },

      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (!player) {
          this._debugVideoLog('play:missing-player', null, {
            id: id
          });
          return;
        }

        this._debugVideoLog('play:attempt', player);
        this._preferMp4Source(player, 'play');
        this._setVideoWrapperLoadingState(player);

        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise.then(function() {
            this._debugVideoLog('play:resolved', player);
            this._setVideoWrapperLoadedState(player);
          }.bind(this))
          .catch(function(error) {
            this._debugVideoLog('play:rejected', player, {
              error: error && error.message ? error.message : error
            });

            this._enableManualMp4Playback(player, 'play-rejected');
          }.bind(this));
        } else {
          this._debugVideoLog('play:no-promise', player);
        }
      },

      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }

        if (this.mediaMode === 'desktop-grid') {
          if (this.desktopGridPhotoswipe && typeof this.desktopGridPhotoswipe.destroy === 'function') {
            this.desktopGridPhotoswipe.destroy();
          }
          this.desktopGridPhotoswipe = new theme.Photoswipe(container, this.sectionId + '-desktop-grid');
        } else {
          if (this.defaultModePhotoswipe && typeof this.defaultModePhotoswipe.destroy === 'function') {
            this.defaultModePhotoswipe.destroy();
          }
          this.defaultModePhotoswipe = new theme.Photoswipe(container, this.sectionId);
        }

        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },

      initMediaTabs: function() {
        return this.mediaTabsController.init();
      },

      _getMediaTabButtons: function() {
        return this.mediaTabsController.getButtons();
      },

      _getMediaTabPanels: function() {
        return this.mediaTabsController.getPanels();
      },

      initSpin360: function() {
        var currentVariant = this.variants && this.variants.currentVariant;
        return this.spinManager.init(currentVariant);
      },

      parseSpin360Data: function() {
        return this.spinManager.parseData();
      },

      getSpin360UrlForVariant: function(variant) {
        return this.spinManager.getUrlForVariant(variant);
      },

      updateSpin360State: function(evt) {
        this.spinManager.updateState(evt);
      },

      ensureSirvScript: function() {
        return this.spinManager.ensureSirvScript();
      },

      activateSpin360: function() {
        this.spinManager.activate();
      },

      deactivateSpin360: function() {
        this.spinManager.deactivate();
      },

      disableSpin360Feature: function() {
        this.spinManager.disableFeature();
      },

      resetSpin360Element: function(nextUrl) {
        this.spinManager.resetElement(nextUrl);
      },

      _hasRenderedSpin360Content: function() {
        return this.spinManager.hasRenderedContent();
      },

      _clearSpin360MountWatchdog: function() {
        this.spinManager.clearMountWatchdog();
      },

      _startSpin360MountWatchdog: function(requestedUrl, requestedElement) {
        this.spinManager.startMountWatchdog(requestedUrl, requestedElement);
      },

      _getVisibleMediaTabButtons: function(excludeTab) {
        return this.mediaTabsController.getVisibleButtons(excludeTab);
      },

      _getFirstAvailableMediaTab: function(excludeTab) {
        return this.mediaTabsController.getFirstAvailableTab(excludeTab);
      },

      _updateTabIndicatorVars: function() {
        return this.mediaTabsController.updateIndicatorVars();
      },

      _setActiveMediaTabUI: function(tab, buttons, panels) {
        return this.mediaTabsController.setActiveTabUI(tab, buttons, panels);
      },

      _syncSpin360ForTab: function(tab) {
        return this.mediaTabsController.syncSpinForTab(tab);
      },

      _updateThumbsForMediaTab: function(tab) {
        return this.mediaTabsController.updateThumbsForTab(tab);
      },

      switchMediaTab: function(tab) {
        return this.mediaTabsController.switchTab(tab);
      },

      getCurrentMaterialSet: function() {
        // Try to get from imageSetArguments if available
        if (this.settings.imageSetName && this.variants && this.variants.currentVariant) {
          var imageSetArgs = this.imageSetArguments(this.variants.currentVariant);
          if (imageSetArgs && imageSetArgs.imageSet) {
            return imageSetArgs.imageSet;
          }
        }

        // Fallback: get from currently selected slide
        if (this.cache.mainSlider) {
          var selectedSlide = this.cache.mainSlider.querySelector(selectors.currentSlide);
          if (selectedSlide && selectedSlide.dataset.group) {
            return selectedSlide.dataset.group;
          }
        }

        // Final fallback: find any available material group
        if (this.cache.mainSlider) {
          var anyMaterialSlide = this.cache.mainSlider.querySelector('[data-group^="material_"]');
          if (anyMaterialSlide && anyMaterialSlide.dataset.group) {
            return anyMaterialSlide.dataset.group;
          }
        }

        // Default fallback
        return 'material_white';
      },

      getThumbIndex: function(target) {
        return target.dataset.index;
      },

      updateVariantImage: function(evt) {
        const variant = evt.detail.variant;
        if (!variant?.featured_media) return;

        if (this._useDesktopGridMediaArchitecture() && this.mediaMode === 'desktop-grid') {
          return;
        }

        // Lazy init material grouping
        if (this.settings.imageSetName && this.settings.imageSetIndex != null) {
          this.initMaterialGrouping();
          if (this.switchToVariantMedia(variant)) {
            return;
          }
        }

        /* Fallback – default logic of Impulse */
        var thumb = this.container.querySelector(
          '.product__thumb[data-id="' + variant.featured_media.id + '"]'
        );
        var idx = this.getThumbIndex(thumb);
        if (typeof idx !== 'undefined' && this.flickity) this.flickity.goToSlide(idx);
      },


      // Function to determine material group
      getVariantGroup: function(variantName, variantValue) {
        if (!variantName || !variantValue) return null;

        const mapping = getVariantMapping(variantName.toLowerCase());
        if (!mapping) return null;

        const normalizedValue = variantValue.toLowerCase().replace(/\s+/g, '-');

        return Object.entries(mapping).find(([group, values]) =>
          values.some(item =>
            item.toLowerCase().replace(/\s+/g, '-') === normalizedValue
          )
        )?.[0] || null;
      },

      switchToVariantMedia: function(variant) {
        if (!variant || !this.flickity) return false;

        var mediaSelection = this.resolveVariantMediaSelection(variant);
        var selectors = mediaSelection ? mediaSelection.selectors : [];
        var target = null;

        // Try to find target using any of the selectors
        for (var i = 0; i < selectors.length && !target; i++) {
          target = this.cache.mainSlider.querySelector(`[data-group="${selectors[i]}"]`);
        }

        if (!target) return false;

        // Find the actual index of target slide in current filtered context
        // When cellSelector is active, goToSlide(0) means first in filtered results, not data-index="0"
        var targetDataIndex = target.getAttribute('data-index');
        var allFilteredSlides = this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide');
        var targetIndex = -1;

        for (var i = 0; i < allFilteredSlides.length; i++) {
          if (allFilteredSlides[i].getAttribute('data-index') === targetDataIndex) {
            targetIndex = i;
            break;
          }
        }

        if (targetIndex >= 0) {
          this.flickity.goToSlide(targetIndex);
        } else {
          // Fallback to index 0 if not found
          this.flickity.goToSlide(0);
        }
        return true;
      },

      initProductSlider: function(variant) {
        // Check if we need Flickity for media functionality (videos, models)
        var slides = this.cache.mainSlider.querySelectorAll(selectors.slide);
        var hasVideoOrModel = Array.from(slides).some(slide => {
          var mediaType = slide.dataset.mediaType;
          return mediaType === 'video' || mediaType === 'external_video' || mediaType === 'model';
        });

        // Only create Flickity for multiple slides
        var shouldCreateFlickity = slides.length > 1;
        if (!shouldCreateFlickity) {
          // Single slide - no Flickity needed
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');

            // Only trigger prepMediaOnSlide when media tabs are enabled
            // This maintains original flow for non-media-tab products
            if (hasVideoOrModel && this._hasMediaTabs()) {
              this.prepMediaOnSlide(slide);
            }
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // Ensure material grouping is initialized before slider setup
        if (this.settings.imageSetName && this.settings.imageSetIndex != null) {
          this.initMaterialGrouping();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide) ||
                            this.cache.mainSlider.querySelector(selectors.currentSlide) ||
                            this.cache.mainSlider.querySelector(selectors.slide);
          this.settings.currentSlideIndex = activeSlide ? this._slideIndex(activeSlide) : 0;
        }

        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };

        // Clear any existing is-selected classes
        this.cache.mainSlider.querySelectorAll(selectors.currentSlide).forEach(function(slide) {
          slide.classList.remove('is-selected');
        });

        // Apply image set (material) filtering if enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          if (imageSetArgs) {
            mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
            if (imageSetArgs.imageSet) {
              // Apply thumbnail filtering immediately before slider initialization
              this.updateImageSetThumbs(imageSetArgs.imageSet);
            }
          }
        }

        // Initialize Flickity and store on instance
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);

        // Setup Instagram-style dots for mobile
        this.setupInstagramDots();

        // Chỉ chạy khi media tabs được bật (luồng gốc không cần)
        if (this._hasMediaTabs()) {
          // Normalize any stale selection classes outside the active Flickity slider
          this.normalizeSelectedState();
        }
      },

      onSliderInit: function(slide) {
        // Initialize any videos/media when they are first slide
        this.prepMediaOnSlide(slide);
      },

      onSlideChange: function(index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');

        // Get the next slide from the current Flickity instance
        var nextSlide = this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index];

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;

        // Update Instagram dots if enabled
        this.updateInstagramDots();
      },

      setupInstagramDots: function() {
        if (!this._shouldEnableInstagramDots()) return;

        // Clean up existing setup first
        this._cleanupInstagramDots();

        var flickityInstance = this.flickity.slideshow;
        this._instagramDotsFlickity = flickityInstance;
        this.setupInstagramDotsForFlickity(flickityInstance, {
          mobileOnly: true
        });
      },

      // Helper function for dots update execution
      _executeDotsUpdate: function(updateHandler) {
        try {
          updateHandler();
        } catch (error) {
          this._handleDotsError('Instagram dots initialization failed', error);
        }
      },

      // Remove any .is-selected left on slides that are not inside an active Flickity slider
      normalizeSelectedState: function() {
        try {
          var allSlideshows = this.container.querySelectorAll('.product-slideshow');
          allSlideshows.forEach(function(slideshowEl) {
            var staleSelected = slideshowEl.querySelectorAll('.product-main-slide.is-selected');
            staleSelected.forEach(function(slideEl) {
              if (!slideEl.closest('.flickity-slider')) {
                slideEl.classList.remove('is-selected');
              }
            });
          });
        } catch(err) {
          // Fail silently; normalization is a safety net
        }
      },

      /**
       * Check if Instagram dots should be enabled based on screen size and Flickity availability
       * @returns {boolean} True if dots should be enabled
       */
      _shouldEnableInstagramDots: function() {
        return this._shouldEnableInstagramDotsForFlickity(this.flickity && this.flickity.slideshow, {
          mobileOnly: true
        });
      },

      _shouldEnableInstagramDotsForFlickity: function(flickityInstance, options) {
        if (!flickityInstance) {
          return false;
        }

        if (options && options.mobileOnly === false) {
          return true;
        }

        return window.innerWidth <= INSTAGRAM_DOTS_CONFIG.MOBILE_BREAKPOINT;
      },

      // Create dots update handler with enhanced error handling
      _createDotsUpdateHandler: function(flickityInstance) {
        var self = this;
        return function() {
          try {
            self._validateFlickityInstance(flickityInstance);
            self._updateInstagramDotsVisibility(flickityInstance);
          } catch (error) {
            self._handleDotsError('Failed to update Instagram dots', error);
          }
        };
      },

      updateInstagramDots: function() {
        if (!this._shouldEnableInstagramDots()) return;

        this.updateInstagramDotsForFlickity(this.flickity.slideshow, {
          mobileOnly: true
        });
      },

      setupInstagramDotsForFlickity: function(flickityInstance, options) {
        if (!this._shouldEnableInstagramDotsForFlickity(flickityInstance, options)) return;

        this._cleanupInstagramDotsController(flickityInstance);

        var updateHandler = this._createDotsUpdateHandler(flickityInstance);
        flickityInstance.__instagramDotsEvents = [
          { target: flickityInstance, event: 'select', handler: updateHandler },
          { target: flickityInstance, event: 'ready', handler: updateHandler }
        ];

        flickityInstance.__instagramDotsEvents.forEach(function(eventConfig) {
          eventConfig.target.on(eventConfig.event, eventConfig.handler);
        });

        var self = this;
        if (INSTAGRAM_DOTS_CONFIG.INIT_DELAY_MS > 0) {
          setTimeout(function() {
            self._executeDotsUpdate(updateHandler);
          }, INSTAGRAM_DOTS_CONFIG.INIT_DELAY_MS);
          return;
        }

        requestAnimationFrame(function() {
          self._executeDotsUpdate(updateHandler);
        });
      },

      updateInstagramDotsForFlickity: function(flickityInstance, options) {
        if (!this._shouldEnableInstagramDotsForFlickity(flickityInstance, options)) return;

        try {
          this._validateFlickityInstance(flickityInstance);
          this._updateInstagramDotsVisibility(flickityInstance);
        } catch (error) {
          this._handleDotsError('Failed to update Instagram dots on slide change', error);
        }
      },

      /**
       * Update Instagram dots visibility with optimized performance
       * Reduced complexity from 15 to 8, nesting from 6 to 3 levels
       * @param {Object} flickityInstance - Flickity slider instance
       */
      _updateInstagramDotsVisibility: function(flickityInstance) {
        var dotsData = this._getDotsData(flickityInstance);
        if (!dotsData) return;

        // Batch DOM operations for better performance
        var updates = this._prepareDotsUpdates(dotsData);
        var visibleRange = this._calculateVisibleRange(
          dotsData.selectedIndex,
          dotsData.totalDots,
          INSTAGRAM_DOTS_CONFIG.MAX_VISIBLE_DOTS
        );

        // Execute immediately
        this._applyVisibilityUpdates(updates, visibleRange, dotsData.selectedIndex);
        this._commitDOMUpdates(updates);
      },

      // Helper: Extract dots data with validation (Complexity: 2)
      _getDotsData: function(flickityInstance) {
        if (!flickityInstance || !flickityInstance.pageDots || !flickityInstance.pageDots.dots) {
          return null;
        }

        return {
          dots: flickityInstance.pageDots.dots,
          selectedIndex: flickityInstance.selectedIndex,
          totalDots: flickityInstance.pageDots.dots.length,
          distanceClasses: INSTAGRAM_DOTS_CONFIG.DISTANCE_CLASSES
        };
      },

      // Helper: Prepare updates array (Complexity: 3)
      _prepareDotsUpdates: function(dotsData) {
        var updates = [];
        var removeClasses = [instagramDotsClasses.dotVisible].concat(dotsData.distanceClasses);

        for (var i = 0; i < dotsData.dots.length; i++) {
          updates.push({
            element: dotsData.dots[i],
            remove: removeClasses,
            add: []
          });
        }

        return updates;
      },

      // Helper: Apply visibility logic (Complexity: 4)
      _applyVisibilityUpdates: function(updates, visibleRange, selectedIndex) {
        for (var i = visibleRange.start; i <= visibleRange.end; i++) {
          if (i >= 0 && i < updates.length) {
            var distance = Math.abs(i - selectedIndex);
            var distanceClass = INSTAGRAM_DOTS_CONFIG.DISTANCE_CLASSES[
              Math.min(distance, INSTAGRAM_DOTS_CONFIG.DISTANCE_CLASSES.length - 1)
            ];

            updates[i].add.push(instagramDotsClasses.dotVisible, distanceClass);
          }
        }
      },

      // Helper: Commit DOM changes (Complexity: 3) - Performance optimized
      _commitDOMUpdates: function(updates) {
        // Batch class operations for better performance
        var batchUpdates = [];

        for (var i = 0; i < updates.length; i++) {
          var update = updates[i];
          if (update.remove.length || update.add.length) {
            batchUpdates.push(update);
          }
        }

        // Use requestAnimationFrame for batch DOM updates
        if (batchUpdates.length > 0) {
          requestAnimationFrame(() => {
            for (var j = 0; j < batchUpdates.length; j++) {
              var batchUpdate = batchUpdates[j];
              if (batchUpdate.remove.length) {
                batchUpdate.element.classList.remove.apply(batchUpdate.element.classList, batchUpdate.remove);
              }
              if (batchUpdate.add.length) {
                batchUpdate.element.classList.add.apply(batchUpdate.element.classList, batchUpdate.add);
              }
            }
          });
        }
      },

      /**
       * Calculate visible range for Instagram dots (Pure function)
       * @param {number} selectedIndex - Currently selected dot index
       * @param {number} totalDots - Total number of dots
       * @param {number} maxVisible - Maximum visible dots
       * @returns {Object} Range object with start and end properties
       */
      _calculateVisibleRange: function(selectedIndex, totalDots, maxVisible) {
        if (totalDots <= maxVisible) {
          return { start: 0, end: totalDots - 1 };
        }

        var half = Math.floor(maxVisible / 2);

        if (selectedIndex <= half) {
          return { start: 0, end: maxVisible - 1 };
        }

        if (selectedIndex >= totalDots - half - 1) {
          return { start: totalDots - maxVisible, end: totalDots - 1 };
        }

        return { start: selectedIndex - half, end: selectedIndex + half };
      },

      // Input validation for Flickity instances
      _validateFlickityInstance: function(flickityInstance) {
        if (!flickityInstance) {
          throw new Error('Flickity instance is required');
        }

        if (!flickityInstance.pageDots) {
          throw new Error('Flickity pageDots not initialized');
        }

        if (!Array.isArray(flickityInstance.pageDots.dots)) {
          throw new Error('Invalid dots array');
        }

        return true;
      },

      // Centralized error handling
      _handleDotsError: function(message, error) {
        if (typeof console !== 'undefined') {
          console.warn('[Instagram Dots]', message, error);
        }

        // Optional: Send to error tracking service
        if (window.errorTracker && typeof window.errorTracker.track === 'function') {
          window.errorTracker.track('instagram-dots-error', {
            message: message,
            error: error.message,
            stack: error.stack
          });
        }
      },

      initInstagramDotsResizeHandler: function() {
        if (this._resizeHandler) return; // Prevent duplicate handlers

        var self = this;
        var resizeTimeout;

        this._resizeHandler = function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            try {
              if (self._shouldEnableInstagramDots()) {
                self.setupInstagramDots();
              } else {
                self._cleanupInstagramDots();
              }
            } catch (error) {
              self._handleDotsError('Instagram dots resize handler failed', error);
            }
          }, INSTAGRAM_DOTS_CONFIG.RESIZE_DEBOUNCE_MS);
        };

        window.addEventListener('resize', this._resizeHandler);
      },

      // Cleanup method to prevent memory leaks
      _cleanupInstagramDots: function() {
        this._cleanupInstagramDotsController(this._instagramDotsFlickity);
        this._instagramDotsFlickity = null;

        if (this._resizeHandler) {
          window.removeEventListener('resize', this._resizeHandler);
          this._resizeHandler = null;
        }
      },

      _cleanupInstagramDotsController: function(flickityInstance) {
        if (!flickityInstance || !flickityInstance.__instagramDotsEvents) {
          return;
        }

        for (var i = 0; i < flickityInstance.__instagramDotsEvents.length; i++) {
          var eventConfig = flickityInstance.__instagramDotsEvents[i];
          eventConfig.target.off(eventConfig.event, eventConfig.handler);
        }

        if (flickityInstance.pageDots && Array.isArray(flickityInstance.pageDots.dots)) {
          var classesToRemove = [instagramDotsClasses.dotVisible].concat(INSTAGRAM_DOTS_CONFIG.DISTANCE_CLASSES);
          flickityInstance.pageDots.dots.forEach(function(dot) {
            dot.classList.remove.apply(dot.classList, classesToRemove);
          });
        }

        flickityInstance.__instagramDotsEvents = null;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          var videoObject = this.videoManager.get(videoId);
          if (videoType === 'youtube') {
            if (videoObject && videoObject.videoPlayer) {
              videoObject.videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          // onInit can fire before assignment of this.flickity completes.
          // Guard reposition to avoid null access without using timers.
          if (this.flickity && typeof this.flickity.reposition === 'function') {
            this.flickity.reposition();
          }
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          var videoObject = this.videoManager.get(videoId);
          if (videoType === 'youtube') {
            if (videoObject && videoObject.videoPlayer && videoObject.options.style !== 'sound') {
              videoObject.videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;

          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);

            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');

              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }

              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });

            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            if (form) {
              var formId = form.getAttribute('id');
              blocks.querySelectorAll('[form]').forEach(el => {
                el.setAttribute('form', formId);
              });
            }

            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');

            this.cacheElements();

            this.formSetup();
            this.updateModalProductInventory();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.productId
              }
            }));
          }.bind(this));

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              this._boundQuickviewLoaded = this._boundQuickviewLoaded || function(evt) {
                if (evt.detail.productId === this.productId) {
                  this.initProductSlider();
                  document.removeEventListener('quickview:loaded', this._boundQuickviewLoaded);
                  this._boundQuickviewLoaded = null;
                }
              }.bind(this);
              document.addEventListener('quickview:loaded', this._boundQuickviewLoaded);
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListeners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.productId
          }
        }));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },

      closeModalProduct: function() {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function() {
        if (this._boundShopifyXrLaunch) {
          document.removeEventListener('shopify_xr_launch', this._boundShopifyXrLaunch);
        }

        this._boundShopifyXrLaunch = function() {
          var currentMedia = this.container.querySelector(
            this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
          );
          currentMedia.dispatchEvent(
            new CustomEvent('xrLaunch', {
              bubbles: true,
              cancelable: true
            })
          );
        }.bind(this);

        document.addEventListener('shopify_xr_launch', this._boundShopifyXrLaunch);
      },

      _unbindCustomMediaListeners: function() {
        if (this._closeMediaClickBindings) {
          this._closeMediaClickBindings.forEach(function(binding) {
            binding.element.removeEventListener('click', binding.handler);
          });
          this._closeMediaClickBindings = null;
        }

        if (this._modelViewerMediaBindings) {
          this._modelViewerMediaBindings.forEach(function(binding) {
            binding.element.removeEventListener(binding.event, binding.handler);
          });
          this._modelViewerMediaBindings = null;
        }
      },

      customMediaListeners: function() {
        this._unbindCustomMediaListeners();

        this._closeMediaClickBindings = [];
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(function(el) {
          var handler = function() {
            if (!this.cache.mainSlider) return;
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            if (!slide) return;
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this);

          el.addEventListener('click', handler);
          this._closeMediaClickBindings.push({
            element: el,
            handler: handler
          });
        }.bind(this));

        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          this._modelViewerMediaBindings = [];
          modelViewers.forEach(function(el) {
            var playHandler = this.mediaLoaded.bind(this);
            var pauseHandler = this.mediaUnloaded.bind(this);

            el.addEventListener('shopify_model_viewer_ui_toggle_play', playHandler);
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', pauseHandler);

            this._modelViewerMediaBindings.push({
              element: el,
              event: 'shopify_model_viewer_ui_toggle_play',
              handler: playHandler
            });
            this._modelViewerMediaBindings.push({
              element: el,
              event: 'shopify_model_viewer_ui_toggle_pause',
              handler: pauseHandler
            });
          }.bind(this));
        }
      },

      customMediaListners: function() {
        return this.customMediaListeners();
      },

      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function() {
        if (this.variantScroller) {
          this.variantScroller.destroy();
        }
        if (this.variantCollapse) {
          this.variantCollapse.destroy();
        }
        theme.ProductMedia.removeSectionModels(this.sectionId);
        this.mediaModeController.destroy();
        this.mediaTabsController.destroy();
        this.destroySpin360();
        this.videoManager.destroyAll(this.container);
        this._unbindCustomMediaListeners();
        this._unbindAllTracked();

        // Cleanup Instagram dots to prevent memory leaks
        this._cleanupInstagramDots();
        this.teardownStickyAddToCartButton();

        if (this._boundUpdateImageSet) {
          this.container.off('variantChange' + this.settings.namespace, this._boundUpdateImageSet);
          this._boundUpdateImageSet = null;
        }

        if (this._boundDocumentVariantChange) {
          document.removeEventListener('variant:change', this._boundDocumentVariantChange);
          this._boundDocumentVariantChange = null;
        }

        if (this._boundModalOpenProduct) {
          document.removeEventListener('modalOpen.QuickShopModal-' + this.productId, this._boundModalOpenProduct);
          this._boundModalOpenProduct = null;
        }

        if (this._boundModalCloseProduct) {
          document.removeEventListener('modalClose.QuickShopModal-' + this.productId, this._boundModalCloseProduct);
          this._boundModalCloseProduct = null;
        }

        if (this._boundQuickviewLoaded) {
          document.removeEventListener('quickview:loaded', this._boundQuickviewLoaded);
          this._boundQuickviewLoaded = null;
        }

        if (this._boundShopifyXrLaunch) {
          document.removeEventListener('shopify_xr_launch', this._boundShopifyXrLaunch);
          this._boundShopifyXrLaunch = null;
        }

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      destroySpin360: function(options) {
        this.spinManager.destroy({
          preserveData: options && options.preserveFeatureState
        });
      }
    });

    return Product;
  })();

  theme.RecentlyViewed = (function() {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }

        init = true;

        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');

        // Request server-rendered custom product cards.
        var promises = [];
        var limit = parseInt(this.container.getAttribute('data-recent-count'), 10);
        Object.keys(theme.recentlyViewed.recent).reverse().filter(function(handle) {
          return handle !== 'undefined' && handle !== this.handle;
        }.bind(this)).slice(0, limit).forEach(function (handle) {
          promises.push(this.getProductCard(handle));
        }.bind(this));

        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
        }.bind(this));
      },

      getProductCard: function(handle) {
        if (theme.recentlyViewed.productCards.hasOwnProperty(handle)) {
          return Promise.resolve(theme.recentlyViewed.productCards[handle]);
        }

        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var url = root + 'products/' + encodeURIComponent(handle) + '?view=recently-viewed-card';

        return fetch(url).then(function(response) {
          if (!response.ok) {
            throw new Error('Unable to load recently viewed product: ' + handle);
          }
          return response.text();
        }).then(function(markup) {
          theme.recentlyViewed.productCards[handle] = markup;
          if (theme.config.hasSessionStorage) {
            theme.utils.safeStorageSet(sessionStorage, theme.config.recentlyViewedCardCacheKey, JSON.stringify(theme.recentlyViewed.productCards));
          }
          return markup;
        }).catch(function(error) {
          console.error(error);
          return '';
        });
      },

      setupOutput: function(cards) {
        var limit = parseInt(this.container.getAttribute('data-recent-count'), 10);
        var productMarkup = cards.filter(function(card) {
          return card.trim() !== '';
        }).slice(0, limit).join('');

        if (!productMarkup) {
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer.innerHTML = productMarkup;

        if (AOS) {
          AOS.refreshHard();
        }
      },

      onUnload: function() {
        init = false;
      }
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Testimonials;
  })();


  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    var roots = [];

    if (scope) {
      if (scope instanceof Element || scope instanceof Document) {
        roots = [scope];
      } else if (scope.length) {
        roots = Array.prototype.slice.call(scope);
      }
    } else {
      roots = [document];
    }

    if (AOS) {AOS.refreshHard()}

    if (!document.documentElement.classList.contains('modal-open')) {
      theme.initQuickShop(roots);
    }

    // Re-hook up collapsible box triggers
    roots.forEach(function(root) {
      if (root && root.querySelectorAll) {
        theme.collapsibles.init(root);
      }
    });

  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productCards = theme.config.hasSessionStorage && sessionStorage[theme.config.recentlyViewedCardCacheKey] ? JSON.parse(sessionStorage[theme.config.recentlyViewedCardCacheKey]) : {};
  theme.utils.trimRecentlyViewedCache(
    theme.recentlyViewed.recent,
    theme.recentlyViewed.productCards,
    theme.config.recentlyViewedStorageLimit
  );

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  theme.CustomTestimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };

    function CustomTestimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;

      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    CustomTestimonials.prototype = Object.assign({}, CustomTestimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },

      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return CustomTestimonials;
  })();

  var normalizeUrl = function(u){ return (u || '').replace(/^https?:/, ''); };
  // Shared controller for rail-style selectors used by filters, SliderRange and CaratSizer.
  var sharedCreateScrollableRail = function(options) {
    if (!options || !options.root || !options.viewport || !options.prevButton || !options.nextButton) {
      return null;
    }

    var root = options.root;
    var viewport = options.viewport;
    var prevButton = options.prevButton;
    var nextButton = options.nextButton;
    var content = options.content || viewport.firstElementChild || viewport;
    var tolerance = typeof options.tolerance === 'number' ? options.tolerance : 2;
    var boundaryTolerance = typeof options.boundaryTolerance === 'number' ? options.boundaryTolerance : tolerance;
    var measureMode = options.measureMode || 'content';
    var getActiveElement = typeof options.getActiveElement === 'function' ? options.getActiveElement : null;
    var selector = options.selector || null;
    var resizeObserver = null;
    var resizeHandler = null;
    var scrollHandler = null;
    var prevHandler = null;
    var nextHandler = null;
    var hasAlignedInitialActive = false;
    var scheduledFrame = null;
    var initialRetryTimer = null;
    var readyFrame = null;
    var lastState = null;
    var isMeasurableChild = function(el) {
      if (!el || typeof window.getComputedStyle !== 'function') return true;
      var position = window.getComputedStyle(el).position;
      return position !== 'absolute' && position !== 'fixed';
    };

    var getContentWidth = function() {
      if (measureMode === 'viewport') {
        return Math.max(
          viewport.scrollWidth || 0,
          viewport.offsetWidth || 0
        );
      }

      if (!content) return 0;

      var children = content.children || [];
      var measuredChildren = [];
      for (var i = 0; i < children.length; i++) {
        if (isMeasurableChild(children[i])) {
          measuredChildren.push(children[i]);
        }
      }
      var firstChild = measuredChildren.length ? measuredChildren[0] : null;
      var lastChild = measuredChildren.length ? measuredChildren[measuredChildren.length - 1] : null;
      var positionalWidth = 0;
      var rectWidth = 0;
      var summedWidth = 0;

      if (firstChild && lastChild) {
        positionalWidth = (lastChild.offsetLeft + lastChild.offsetWidth) - firstChild.offsetLeft;
        try {
          var firstRect = firstChild.getBoundingClientRect();
          var lastRect = lastChild.getBoundingClientRect();
          rectWidth = lastRect.right - firstRect.left;
        } catch(e) {}
      }

      for (var j = 0; j < measuredChildren.length; j++) {
        summedWidth += measuredChildren[j].offsetWidth || 0;
      }

      return Math.max(
        positionalWidth,
        rectWidth,
        summedWidth,
        content.scrollWidth || 0,
        content.offsetWidth || 0,
        viewport.scrollWidth || 0
      );
    };

    var getViewportWidth = function() {
      return Math.max(
        viewport.clientWidth || 0,
        viewport.offsetWidth || 0
      );
    };

    var getMaxScroll = function() {
      return Math.max(0, getContentWidth() - getViewportWidth());
    };

    var isElementFullyVisible = function(el) {
      if (!el) return false;

      var itemLeft = el.offsetLeft;
      var itemRight = itemLeft + el.offsetWidth;
      var viewportLeft = viewport.scrollLeft;
      var viewportRight = viewportLeft + viewport.clientWidth;

      return itemLeft >= viewportLeft && itemRight <= viewportRight;
    };

    var updateSelector = function() {
      if (!selector || !getActiveElement) return;

      var activeEl = getActiveElement();
      if (!activeEl) return;

      selector.style.setProperty('--selector-offset', activeEl.offsetLeft + 'px');
      selector.style.setProperty('--selector-width', activeEl.offsetWidth + 'px');
      selector.style.setProperty('--selector-height', activeEl.offsetHeight + 'px');
    };

    var canMarkReady = function() {
      if (getViewportWidth() <= 0) return false;
      if (!selector || !getActiveElement) return true;

      var activeEl = getActiveElement();
      return !!(activeEl && activeEl.offsetWidth > 0 && activeEl.offsetHeight > 0);
    };

    var scheduleReady = function() {
      if (root.classList.contains('is-ready') || readyFrame !== null) return;
      readyFrame = window.requestAnimationFrame(function() {
        readyFrame = null;
        root.classList.add('is-ready');
      });
    };

    var clearInitialRetry = function() {
      if (initialRetryTimer !== null) {
        window.clearTimeout(initialRetryTimer);
        initialRetryTimer = null;
      }
    };

    var update = function() {
      var contentWidth = getContentWidth();
      var viewportWidth = getViewportWidth();
      var isOverflowing = (contentWidth - viewportWidth) > tolerance;
      var maxScroll = Math.max(0, contentWidth - viewportWidth);
      var scrollLeft = Math.max(0, Math.min(maxScroll, viewport.scrollLeft));
      var isAtStart = !isOverflowing || scrollLeft <= boundaryTolerance;
      var isAtEnd = !isOverflowing || scrollLeft >= (maxScroll - boundaryTolerance);
      var stateChanged = !lastState ||
        lastState.isOverflowing !== isOverflowing ||
        lastState.isAtStart !== isAtStart ||
        lastState.isAtEnd !== isAtEnd ||
        lastState.scrollLeft !== scrollLeft ||
        lastState.viewportWidth !== viewportWidth ||
        lastState.maxScroll !== maxScroll;

      if (scrollLeft !== viewport.scrollLeft) {
        viewport.scrollLeft = scrollLeft;
      }

      if (stateChanged) {
        root.classList.toggle('is-overflowing', isOverflowing);
        root.classList.toggle('is-at-start', isAtStart);
        root.classList.toggle('is-at-end', isAtEnd);

        prevButton.disabled = !isOverflowing || isAtStart;
        nextButton.disabled = !isOverflowing || isAtEnd;
        prevButton.setAttribute('aria-disabled', prevButton.disabled ? 'true' : 'false');
        nextButton.setAttribute('aria-disabled', nextButton.disabled ? 'true' : 'false');
        prevButton.setAttribute('aria-hidden', (!isOverflowing) ? 'true' : 'false');
        nextButton.setAttribute('aria-hidden', (!isOverflowing) ? 'true' : 'false');

        updateSelector();

      }

      lastState = {
        isOverflowing: isOverflowing,
        isAtStart: isAtStart,
        isAtEnd: isAtEnd,
        scrollLeft: scrollLeft,
        viewportWidth: viewportWidth,
        maxScroll: maxScroll
      };

      if (!hasAlignedInitialActive && getActiveElement && viewportWidth > 0) {
        var activeEl = getActiveElement();
        if (activeEl) {
          scrollElementIntoView(activeEl);
          hasAlignedInitialActive = true;
        }
      }
    };

    var scrollByViewport = function(direction) {
      var step = viewport.clientWidth;
      var nextLeft = viewport.scrollLeft + (step * direction);
      nextLeft = Math.max(0, Math.min(getMaxScroll(), nextLeft));
      viewport.scrollTo({
        left: nextLeft,
        behavior: 'smooth'
      });
    };

    var scrollElementIntoView = function(el, options) {
      if (!el) return;

      options = options || {};
      var behavior = options.behavior || 'smooth';

      var itemLeft = el.offsetLeft;
      var itemRight = itemLeft + el.offsetWidth;
      var viewportLeft = viewport.scrollLeft;
      var viewportRight = viewportLeft + viewport.clientWidth;
      var nextLeft = null;

      if (itemLeft < viewportLeft) {
        nextLeft = itemLeft;
      } else if (itemRight > viewportRight) {
        nextLeft = itemRight - viewport.clientWidth;
      }

      if (nextLeft === null) return;

      nextLeft = Math.max(0, Math.min(getMaxScroll(), nextLeft));
      if (behavior === 'auto') {
        viewport.scrollLeft = nextLeft;
      } else {
        viewport.scrollTo({
          left: nextLeft,
          behavior: behavior
        });
      }
    };

    var alignActiveElement = function(immediate) {
      if (!getActiveElement || getViewportWidth() <= 0) return false;

      var activeEl = getActiveElement();
      if (!activeEl) return false;
      if (isElementFullyVisible(activeEl)) return true;

      scrollElementIntoView(activeEl, {
        behavior: immediate ? 'auto' : 'smooth'
      });
      return true;
    };

    var runInitialSync = function() {
      update();
      updateSelector();
      if (alignActiveElement(true)) {
        hasAlignedInitialActive = true;
      }
      if (canMarkReady()) {
        clearInitialRetry();
        scheduleReady();
        return true;
      }
      return false;
    };

    var requestUpdate = function() {
      if (scheduledFrame !== null) return;
      scheduledFrame = window.requestAnimationFrame(function() {
        scheduledFrame = null;
        update();
        alignActiveElement(true);
        if (canMarkReady()) {
          clearInitialRetry();
          scheduleReady();
        }
      });
    };

    var init = function() {
      scrollHandler = theme.utils.debounce(30, update);
      prevHandler = function(e) {
        e.preventDefault();
        scrollByViewport(-1);
      };
      nextHandler = function(e) {
        e.preventDefault();
        scrollByViewport(1);
      };

      viewport.addEventListener('scroll', scrollHandler, { passive: true });
      prevButton.addEventListener('click', prevHandler);
      nextButton.addEventListener('click', nextHandler);
      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(requestUpdate);
        resizeObserver.observe(viewport);
        resizeObserver.observe(root);
        if (content && content !== viewport) {
          resizeObserver.observe(content);
        }
      } else {
        resizeHandler = theme.utils.debounce(100, requestUpdate);
        window.addEventListener('resize', resizeHandler);
      }

      root.classList.remove('is-ready');
      runInitialSync();
      scheduledFrame = window.requestAnimationFrame(function() {
        scheduledFrame = null;
        if (!runInitialSync() && initialRetryTimer === null) {
          initialRetryTimer = window.setTimeout(function() {
            initialRetryTimer = null;
            runInitialSync();
          }, 180);
        }
      });
    };

    var destroy = function() {
      if (scrollHandler) {
        viewport.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
      }
      if (prevHandler) {
        prevButton.removeEventListener('click', prevHandler);
        prevHandler = null;
      }
      if (nextHandler) {
        nextButton.removeEventListener('click', nextHandler);
        nextHandler = null;
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        resizeHandler = null;
      }
      if (scheduledFrame !== null) {
        window.cancelAnimationFrame(scheduledFrame);
        scheduledFrame = null;
      }
      if (readyFrame !== null) {
        window.cancelAnimationFrame(readyFrame);
        readyFrame = null;
      }
      clearInitialRetry();
      root.classList.remove('is-ready');
      lastState = null;
    };

    return {
      init: init,
      update: update,
      destroy: destroy,
      scrollElementIntoView: scrollElementIntoView,
      alignActiveElement: alignActiveElement,
      updateSelector: updateSelector
    };
  };

  theme.SliderRange = (function(){
    // Constants
    var DEFAULT_INDEX = 0;
    var DEFAULT_OPACITY = 1;
    var DATA_SEPARATOR = '|||';
    var CLICK_DEBOUNCE = 300; // ms for mobile tap debounce
    var SLIDER_TYPES = {
      OVERLAY: 'overlay',
      OPACITY: 'opacity',
      CHANGE: 'change'
    };
    function SliderRange(container) {
      if (!container) return;
      container._sliderRangeInstance = this;
      this.container = container;

      // Optimized DOM queries - cache common parent first
      var contentArea = container.querySelector('.slider__content');

      this.markers = container.querySelectorAll('.slider--marker__labels-value');
      this.headers = container.querySelectorAll('.slider--header-item');
      this.contents = container.querySelectorAll('.slider--content-item');
      this.markerRail = container.querySelector('.slider--marker__rail');
      this.markerViewport = container.querySelector('.slider--marker__viewport');
      this.prevButton = container.querySelector('.slider--marker__nav--prev');
      this.nextButton = container.querySelector('.slider--marker__nav--next');

      // Query single image elements for change mode and other helpers
      if (contentArea) {
        this.singleImageWrap = contentArea.querySelector('.slider--image__single');
        this.singleImage = this.singleImageWrap ? this.singleImageWrap.querySelector('img') : null;
        this.subImage = contentArea.querySelector('.slider--image__sub-overlay');
        this.maskImage = contentArea.querySelector('.slider--image__mask-opacity');
      } else {
        this.singleImageWrap = container.querySelector('.slider--image__single');
        this.singleImage = this.singleImageWrap ? this.singleImageWrap.querySelector('img') : null;
        this.subImage = container.querySelector('.slider--image__sub-overlay');
        this.maskImage = container.querySelector('.slider--image__mask-opacity');
      }

      // Cache content elements for performance
      this.contentBox = container.querySelector('.slider--content-item');
      this.contentWrap = container.querySelector('.slider--content');

      this.sliderType = container.dataset.sliderType;

      // Parse JSON config if available (optimized data access)
      this._config = null;
      var configScript = container.querySelector('[data-slider-config]');
      if (configScript) {
        try {
          this._config = JSON.parse(configScript.textContent);
        } catch(e) {
          console.warn('SliderRange: Failed to parse JSON config', e);
        }
      }

      // Cache parsed data arrays to avoid re-splitting on every click
      this._cachedArrays = null;

      // Validate and clamp initial index
      var rawIndex = parseInt(container.dataset.activeIndex, 10) || DEFAULT_INDEX;
      var maxIdx = this.markers.length > 0 ? this.markers.length - 1 : 0;
      this._activeIdx = Math.max(0, Math.min(rawIndex, maxIdx));

      // Track last click time for debouncing
      this._lastClickTime = 0;
      this._markerRailController = null;

      this.bindEvents();
      this._initMarkerRail();
      this.activateIndex(this._activeIdx);
      // Ensure initial image is set for single-image mode
      if (this.sliderType === SLIDER_TYPES.CHANGE && this.singleImage) {
        this.updateChangeEffect(this._activeIdx);
      }
    }
    SliderRange.prototype = {
      // Parse and cache data arrays (avoid re-parsing on every click)
      _parseDataArrays: function() {
        if (this._cachedArrays) return this._cachedArrays;

        var arrays = {};

        // Prefer JSON config if available (faster parsing)
        if (this._config) {
          arrays.labels = this._config.labels || [];
          arrays.descriptions = this._config.descriptions || [];
          if (this.sliderType === SLIDER_TYPES.OVERLAY) {
            arrays.overlayZooms = this._config.overlayZooms || [];
            arrays.overlayOrigins = this._config.overlayOrigins || [];
            arrays.overlayPositions = this._config.overlayPositions || [];
            arrays.overlayImageUrls = this._config.overlayImageUrls || [];
            arrays.overlayImageSrcsets = this._config.overlayImageSrcsets || [];
          }
          if (this.sliderType === SLIDER_TYPES.OPACITY) {
            arrays.opacityValues = this._config.opacityValues || [];
          }
          if (this.sliderType === SLIDER_TYPES.CHANGE && this._config.imageUrls) {
            arrays.imageUrls = this._config.imageUrls || [];
            arrays.imageSrcsets = this._config.imageSrcsets || [];
          }
        } else {
          // Fallback to existing data-attribute config when JSON config is unavailable.
          var labelsStr = this.container.dataset.labels || '';
          var descStr = (this.contentWrap && this.contentWrap.dataset.descriptions) || '';

          arrays.labels = labelsStr ? labelsStr.split(DATA_SEPARATOR) : [];
          arrays.descriptions = descStr ? descStr.split(DATA_SEPARATOR) : [];

          if (this.sliderType === SLIDER_TYPES.OVERLAY) {
            var scaleStr = this.container.dataset.overlayZooms || '';
            var originStr = this.container.dataset.overlayOrigins || '';
            var posStr = this.container.dataset.overlayPositions || '';
            arrays.overlayZooms = scaleStr ? scaleStr.split(DATA_SEPARATOR) : [];
            arrays.overlayOrigins = originStr ? originStr.split(DATA_SEPARATOR) : [];
            arrays.overlayPositions = posStr ? posStr.split(DATA_SEPARATOR) : [];
            arrays.overlayImageUrls = [];
            arrays.overlayImageSrcsets = [];
          }

          if (this.sliderType === SLIDER_TYPES.OPACITY) {
            var opacityStr = this.container.dataset.opacityValues || '';
            arrays.opacityValues = opacityStr ? opacityStr.split(DATA_SEPARATOR) : [];
          }
        }

        this._cachedArrays = arrays;
        return arrays;
      },
      bindEvents: function() {
        var self = this;
        if (!self.markers || self.markers.length === 0) return;
        var TOUCH_MOVE_TOLERANCE = 10;

        // Use event delegation: single listener on container instead of multiple on each button
        // Store handler reference for proper cleanup
        // Add debounce for mobile to prevent double-tap and rapid clicks
        var activateFromEvent = function(e) {
          // Debounce: prevent rapid clicks on mobile
          var now = Date.now();
          if (now - self._lastClickTime < CLICK_DEBOUNCE) {
            e.preventDefault();
            return;
          }
          self._lastClickTime = now;

          var btn = e.target.closest('.slider--marker__labels-value');
          if (!btn || !self.container.contains(btn)) return;

          var idx = parseInt(btn.getAttribute('data-slider-index'), 10);
          if (isNaN(idx)) return;

          e.preventDefault();
          if (self._activeIdx !== idx) {
            self._activeIdx = idx;
            self.activateIndex(idx);
          }
        };
        this._clickHandler = activateFromEvent;
        this._keyHandler = function(e){
          // Support keyboard: Enter/Space on marker buttons
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var btn = e.target.closest('.slider--marker__labels-value');
          if (!btn || !self.container.contains(btn)) return;
          activateFromEvent(e);
        };
        this._touchStartHandler = function(e) {
          if (!e.touches || e.touches.length !== 1) {
            self._touchGesture = null;
            return;
          }
          var touch = e.touches[0];
          self._touchGesture = {
            x: touch.clientX,
            y: touch.clientY,
            moved: false
          };
        };
        this._touchMoveHandler = function(e) {
          if (!self._touchGesture || !e.touches || e.touches.length !== 1) return;
          var touch = e.touches[0];
          if (
            Math.abs(touch.clientX - self._touchGesture.x) > TOUCH_MOVE_TOLERANCE ||
            Math.abs(touch.clientY - self._touchGesture.y) > TOUCH_MOVE_TOLERANCE
          ) {
            self._touchGesture.moved = true;
          }
        };
        this._touchEndHandler = function(e){
          if (!self._touchGesture || self._touchGesture.moved) {
            self._touchGesture = null;
            return;
          }
          self._touchGesture = null;
          activateFromEvent(e);
        };
        this._touchCancelHandler = function() {
          self._touchGesture = null;
        };

        this.container.addEventListener('touchstart', this._touchStartHandler, { passive: true });
        this.container.addEventListener('touchmove', this._touchMoveHandler, { passive: true });
        this.container.addEventListener('touchend', this._touchEndHandler);
        this.container.addEventListener('touchcancel', this._touchCancelHandler, { passive: true });
        this.container.addEventListener('click', this._clickHandler);
        this.container.addEventListener('keydown', this._keyHandler);
      },
      _initMarkerRail: function() {
        if (!this.markerRail || !this.markerViewport || !this.prevButton || !this.nextButton) return;
        this._markerRailController = sharedCreateScrollableRail({
          root: this.markerRail,
          viewport: this.markerViewport,
          prevButton: this.prevButton,
          nextButton: this.nextButton,
          content: this.markerViewport.querySelector('.slider--marker__labels-container'),
          selector: this.container.querySelector('.slider--marker__selector'),
          measureMode: 'viewport',
          tolerance: 2,
          boundaryTolerance: 2,
          getActiveElement: function() {
            return this.markers && this.markers[this._activeIdx] ? this.markers[this._activeIdx] : null;
          }.bind(this)
        });
        if (this._markerRailController) {
          this._markerRailController.init();
        }
      },
      _scrollActiveMarkerIntoView: function() {
        if (this._markerRailController && this.markers && this.markers[this._activeIdx]) {
          this._markerRailController.scrollElementIntoView(this.markers[this._activeIdx]);
        }
      },
      _updateOverlayImage: function(idx) {
        if (!this.subImage) return;

        var arrays = this._parseDataArrays();
        var urls = arrays.overlayImageUrls || [];
        var srcsets = arrays.overlayImageSrcsets || [];
        var nextUrl = urls[idx] || urls[0];
        var nextSrcset = srcsets[idx] || srcsets[0] || '';

        if (!nextUrl) return;

        var currentUrl = this.subImage.currentSrc || this.subImage.src || '';
        if (normalizeUrl(currentUrl) === normalizeUrl(nextUrl)) {
          return;
        }

        var imgEl = this.subImage;
        imgEl.onload = function() {
          imgEl.onload = null;
        };
        imgEl.onerror = function() {
          imgEl.onerror = null;
        };

        if (nextSrcset) {
          imgEl.setAttribute('srcset', nextSrcset);
          imgEl.setAttribute('sizes', imgEl.getAttribute('sizes') || '25vw');
        }
        imgEl.src = nextUrl;
      },
      activateIndex: function(idx) {
        idx = parseInt(idx, 10) || DEFAULT_INDEX;

        // Validate index range
        var maxIdx = this.markers.length > 0 ? this.markers.length - 1 : 0;
        if (idx < 0) idx = DEFAULT_INDEX;
        if (idx > maxIdx) idx = maxIdx;

        // Update marker buttons with accessibility (optimized: use for loop instead of forEach)
        var markersLength = this.markers.length;
        for (var i = 0; i < markersLength; i++) {
          var btn = this.markers[i];
          var isActive = i === idx;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-current', isActive ? 'true' : 'false');
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        }

        // Update panel aria-labelledby to point to active tab (for screen readers)
        // aria-controls already establishes tab → panel relationship, this adds panel → tab
        if (this.contentBox && this.markers[idx]) {
          var activeBtnId = this.markers[idx].id;
          if (activeBtnId) {
            this.contentBox.setAttribute('aria-labelledby', activeBtnId);
          }
        }

        this._activeIdx = idx;

        // Update headers if they exist (optimized: use for loop)
        if(this.headers && this.headers.length > 0) {
          var headersLength = this.headers.length;
          for (var i = 0; i < headersLength; i++) {
            this.headers[i].style.display = (i === idx ? '' : 'none');
          }
        }

        // Update change effect (for change type)
        if(this.sliderType === SLIDER_TYPES.CHANGE) {
          this.updateChangeEffect(idx);
        } else if(this.sliderType === SLIDER_TYPES.OVERLAY) {
          this.updateOverlayEffect(idx);
        } else if(this.sliderType === SLIDER_TYPES.OPACITY) {
          this.updateOpacityEffect(idx);
        }

        // Update content block using cached arrays
        if(this.contentBox) {
          try {
            var arrays = this._parseDataArrays();
            var descText = arrays.descriptions[idx] || '';

            // Use textContent to prevent XSS instead of innerHTML
            this.contentBox.textContent = descText;

            // Update aria-live region if exists
            var liveRegion = this.container.querySelector('[aria-live]');
            if (liveRegion) {
              liveRegion.textContent = descText;
            }
          } catch(e) {
            console.warn('SliderRange: Error updating content', e);
          }
        }

        this._scrollActiveMarkerIntoView();
        if (this._markerRailController) {
          this._markerRailController.updateSelector();
        }
      },
      updateChangeEffect: function(idx) {
        // If we have single-image mode, just swap the src using JSON config
        if (this.singleImage) {
          var arrays = this._parseDataArrays();
          var urls = arrays.imageUrls || [];
          var srcsets = arrays.imageSrcsets || [];
          var nextUrl = urls[idx];
          var nextSrcset = srcsets[idx] || '';
          if (!nextUrl) return;
          if (this.singleImageWrap) {
            this.singleImageWrap.setAttribute('data-current-index', String(idx));
            this.singleImageWrap.classList.add('is-loading');
          }
          var imgEl = this.singleImage;
          // Normalize URLs (protocol-relative vs absolute) before compare
          var currentUrl = imgEl.currentSrc || imgEl.src || '';
          var sameUrl = normalizeUrl(currentUrl) === normalizeUrl(nextUrl);
          // If already same, just stop loading state
          if (sameUrl) {
            if (this.singleImageWrap) this.singleImageWrap.classList.remove('is-loading');
            return;
          }
          // Attach a one-time onload handler on the existing image element
          var self = this;
          imgEl.onload = function() {
            if (self.singleImageWrap) self.singleImageWrap.classList.remove('is-loading');
            imgEl.onload = null; // cleanup
          };
          imgEl.onerror = function() {
            if (self.singleImageWrap) self.singleImageWrap.classList.remove('is-loading');
            imgEl.onerror = null;
          };
          if (nextSrcset) {
            imgEl.setAttribute('srcset', nextSrcset);
            imgEl.setAttribute('sizes', imgEl.getAttribute('sizes') || '100vw');
          }
          // Swap URL directly
          imgEl.src = nextUrl;
          return;
        }

      },
      updateOverlayEffect: function(idx) {
        if (!this.subImage) {
          console.warn('SliderRange: subImage not found for overlay effect');
          return;
        }

        try {
          // Use cached arrays for better performance
          var arrays = this._parseDataArrays();

          if (!arrays.overlayZooms || !arrays.overlayOrigins) {
            return;
          }

          // Get values with defaults
          var scale = arrays.overlayZooms[idx] || arrays.overlayZooms[0] || 1;
          var origin = arrays.overlayOrigins[idx] || arrays.overlayOrigins[0] || '50% 50%';
          var pos = (arrays.overlayPositions && arrays.overlayPositions[idx]) ||
                    (arrays.overlayPositions && arrays.overlayPositions[0]) || '';

          this._updateOverlayImage(idx);
          this.subImage.style.setProperty('--overlay-scale', String(scale));
          this.subImage.style.setProperty('--overlay-origin', String(origin));
          if (pos) {
            this.subImage.style.setProperty('--overlay-position', String(pos));
          } else {
            this.subImage.style.removeProperty('--overlay-position');
          }
        } catch(e) {
          console.warn('SliderRange: Error updating overlay effect', e);
        }
      },
      updateOpacityEffect: function(idx) {
        if (!this.maskImage) {
          console.warn('SliderRange: maskImage not found for opacity effect');
          return;
        }

        try {
          // Use cached arrays for better performance
          var arrays = this._parseDataArrays();
          var opacity = arrays.opacityValues ? arrays.opacityValues[idx] : undefined;

          // Parse and validate opacity value
          if (opacity === undefined || opacity === null || opacity === '') {
            opacity = DEFAULT_OPACITY;
          } else {
            opacity = parseFloat(opacity);
            if (isNaN(opacity)) opacity = DEFAULT_OPACITY;
            // Clamp opacity between 0 and 1
            opacity = Math.max(0, Math.min(1, opacity));
          }

          this.maskImage.style.setProperty('--opacity-value', String(opacity));
        } catch(e) {
          console.warn('SliderRange: Error updating opacity effect', e);
        }
      },

      onUnload: function() {
        // Remove event listeners (both touch and click)
        if (this.container && this._clickHandler) {
          this.container.removeEventListener('touchstart', this._touchStartHandler);
          this.container.removeEventListener('touchmove', this._touchMoveHandler);
          this.container.removeEventListener('touchend', this._touchEndHandler);
          this.container.removeEventListener('touchcancel', this._touchCancelHandler);
          this.container.removeEventListener('click', this._clickHandler);
          this.container.removeEventListener('keydown', this._keyHandler);
          this._clickHandler = null;
          this._touchStartHandler = null;
          this._touchMoveHandler = null;
          this._touchEndHandler = null;
          this._touchCancelHandler = null;
          this._keyHandler = null;
        }
        if (this._markerRailController) {
          this._markerRailController.destroy();
          this._markerRailController = null;
        }
        if (this.container) {
          this.container._sliderRangeInstance = null;
        }
        // Clear cached data
        this._cachedArrays = null;
        this._config = null;
        // Clear references to help garbage collection
        this.markers = null;
        this.container = null;
        this.contentBox = null;
        this.contentWrap = null;
        this.markerRail = null;
        this.markerViewport = null;
        this.prevButton = null;
        this.nextButton = null;
        this.subImage = null;
        this.maskImage = null;
        this.singleImage = null;
        this.singleImageWrap = null;
      }
    };
    return SliderRange;
  })();

  theme.CaratSizer = (function() {
    function CaratSizer(container) {
      if (!container) return;
      this.container = container;
      this.elements = {
        desktopStrong: container.querySelector('.CaratSize__ShownWith--desktop strong'),
        mobileStrong: container.querySelector('.CaratSize__ShownWith--mobile strong'),
        buttons: container.querySelectorAll('.CaratSize__block'),
        rail: container.querySelector('.CaratSize__rail'),
        viewport: container.querySelector('.CaratSize__viewport'),
        items: container.querySelector('.CaratSize__items'),
        prevButton: container.querySelector('.CaratSize__nav--prev'),
        nextButton: container.querySelector('.CaratSize__nav--next'),
        selector: container.querySelector('.CaratSize__selector'),
        overlayImage: container.querySelector('.slider--image__sub-overlay')
      };
      this._config = null;
      this._activeIdx = 0;
      this._railController = null;
      this.init();
    }

    CaratSizer.prototype = {
      init: function() {
        this.parseConfig();
        this.setInitialIndex();
        this.bindEvents();
        this.initRail();
        this.activateIndex(this._activeIdx);
      },
      parseConfig: function() {
        var configScript = this.container.querySelector('[data-carat-sizer-config]');
        if (!configScript) return;
        try {
          this._config = JSON.parse(configScript.textContent);
        } catch(e) {
          console.warn('CaratSizer: Failed to parse JSON config', e);
          this._config = null;
        }
      },
      setInitialIndex: function() {
        var rawIndex = parseInt(this.container.dataset.activeIndex, 10) || 0;
        var maxIdx = this.elements.buttons.length > 0 ? this.elements.buttons.length - 1 : 0;
        this._activeIdx = Math.max(0, Math.min(rawIndex, maxIdx));
      },
      initRail: function() {
        if (!this.elements.rail || !this.elements.viewport || !this.elements.prevButton || !this.elements.nextButton) return;
        this._railController = sharedCreateScrollableRail({
          root: this.elements.rail,
          viewport: this.elements.viewport,
          prevButton: this.elements.prevButton,
          nextButton: this.elements.nextButton,
          content: this.elements.items,
          selector: this.elements.selector,
          measureMode: 'content',
          tolerance: 2,
          boundaryTolerance: 8,
          getActiveElement: function() {
            return this.elements.buttons && this.elements.buttons[this._activeIdx] ? this.elements.buttons[this._activeIdx] : null;
          }.bind(this)
        });
        if (this._railController) {
          this._railController.init();
        }
      },
      activateIndex: function(idx) {
        if (!this._config || !this.elements.buttons.length) return;
        idx = Math.max(0, Math.min(this.elements.buttons.length - 1, idx));
        this._activeIdx = idx;

        for (var i = 0; i < this.elements.buttons.length; i++) {
          var isActive = i === idx;
          this.elements.buttons[i].classList.toggle('is-active', isActive);
          this.elements.buttons[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        }

        this.updateOverlay(idx);
        this.updateDisplayText(this._config.labels[idx] || '');
        if (this._railController) {
          this._railController.updateSelector();
          this._railController.scrollElementIntoView(this.elements.buttons[this._activeIdx]);
          this._railController.update();
        }
      },
      updateOverlay: function(idx) {
        var scale = (this._config.overlayZooms && this._config.overlayZooms[idx]) || '1';
        var origin = (this._config.overlayOrigins && this._config.overlayOrigins[idx]) || '50% 50%';
        var position = (this._config.overlayPositions && this._config.overlayPositions[idx]) || '';
        var imageUrl = (this._config.overlayImageUrls && this._config.overlayImageUrls[idx]) || '';
        var imageSrcset = (this._config.overlayImageSrcsets && this._config.overlayImageSrcsets[idx]) || '';

        if (this.elements.overlayImage) {
          this.elements.overlayImage.style.setProperty('--overlay-scale', String(scale));
          this.elements.overlayImage.style.setProperty('--overlay-origin', String(origin));
          if (position) {
            this.elements.overlayImage.style.setProperty('--overlay-position', String(position));
          } else {
            this.elements.overlayImage.style.removeProperty('--overlay-position');
          }
        }

        if (this.elements.overlayImage && imageUrl) {
          var currentUrl = this.elements.overlayImage.currentSrc || this.elements.overlayImage.src || '';
          if (normalizeUrl(currentUrl) !== normalizeUrl(imageUrl)) {
            if (imageSrcset) {
              this.elements.overlayImage.setAttribute('srcset', imageSrcset);
              this.elements.overlayImage.setAttribute('sizes', this.elements.overlayImage.getAttribute('sizes') || '25vw');
            }
            this.elements.overlayImage.src = imageUrl;
          }
        }
      },
      updateDisplayText: function(label) {
        [this.elements.desktopStrong, this.elements.mobileStrong].forEach(function(elm) {
          if (elm) elm.textContent = label;
        });
      },
      bindEvents: function() {
        var self = this;
        this._clickHandler = function(evt) {
          var btn = evt.target.closest('.CaratSize__block');
          if (!btn) return;
          evt.preventDefault();
          var idx = parseInt(btn.dataset.caratIndex, 10);
          if (isNaN(idx)) return;
          self.activateIndex(idx);
        };
        this.container.addEventListener('click', this._clickHandler);
      },
      onUnload: function() {
        if (this.container && this._clickHandler) {
          this.container.removeEventListener('click', this._clickHandler);
          this._clickHandler = null;
        }
        if (this._railController) {
          this._railController.destroy();
          this._railController = null;
        }
        this._config = null;
        this.container = null;
      }
    };

    return CaratSizer;
  })();

  theme.CustomTab = (function(){
    var config = {
      tabHeader: '.custom-tab-header',
    }

    function CustomTab(container) {
      if (!container) {
        return;
      }

      if (container.dataset.tabType != 'tab_switch') {
        return;
      }

      this.container = container;
      this.tabHeaders = this.container.querySelectorAll(config.tabHeader);
      if (this.tabHeaders) {
        this.init();
      }
    }

    CustomTab.prototype = Object.assign({}, CustomTab.prototype, {
      init: function(){

        this.tabHeaders.forEach(elm => {

          // Only show active content on first load
          var tabContent = document.querySelector(`.${elm.id}`);
          if(tabContent) {
            if(elm.classList.contains('is-active')) {
              tabContent.style.display = 'block';
            } else {
              tabContent.style.display = 'none';
            }
          }

          // Register event
          var namespace = '.custom-tab-' + elm.id;
          elm.on('click' + namespace , this.select.bind(this));
        })
      },

      select: function(evt) {
        var tabId = evt.currentTarget.id;
        this.tabHeaders.forEach(elm => {
          var wkId = elm.id;
          var tabContent = document.querySelector(`.${wkId}`);
          if (!tabContent) return;

          if  (wkId == tabId) {
            elm.classList.add('is-active');
            tabContent.style.display = 'block';
          } else {
            elm.classList.remove('is-active');
            tabContent.style.display = 'none';
          }
        })

      },
    })

    return CustomTab;
  })();

  // Advanced Content - Mobile Tabs
  theme.AdvancedContentMobileTabs = (function(){
    function AdvancedContentMobileTabs(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id') || container.dataset.sectionId;

      // scope elements
      this.tabs = document.querySelectorAll('.mobile-tabs--' + this.sectionId + ' .mobile-tab');
      this.panels = container.querySelectorAll('.custom__item');

      if (!this.tabs || this.tabs.length === 0) return;
      this.init();
    }

    AdvancedContentMobileTabs.prototype = Object.assign({}, AdvancedContentMobileTabs.prototype, {
      init: function(){
        this.setActive(0);
        var self = this;

        // Use event delegation for better performance and simpler cleanup
        this._clickHandler = function(e) {
          var btn = e.target.closest('.mobile-tab');
          if (!btn || !self.container.querySelector('.mobile-tabs--' + self.sectionId).contains(btn)) return;

          var idx = parseInt(btn.getAttribute('data-target-index'), 10);
          if (isNaN(idx)) idx = 0;
          self.setActive(idx);
        };
        this.container.addEventListener('click', this._clickHandler);

        // Re-evaluate on resize to ensure desktop shows all panels (debounced)
        this._resizeHandler = theme.utils.debounce(250, function() {
          self.setActive(self._currentIndex || 0);
        });
        window.addEventListener('resize', this._resizeHandler);
      },

      setActive: function(index){
        // Validate index is a number (0-based)
        index = parseInt(index, 10);
        if (isNaN(index) || index < 0) index = 0;
        if (index >= this.panels.length) index = this.panels.length - 1;

        this._currentIndex = index;
        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        this.panels.forEach(function(p, i){
          var isActive = i === index; // 0-based comparison
          if (isMobile) {
            if (isActive) {
              p.classList.add('is-active');
              p.removeAttribute('hidden');
            } else {
              p.classList.remove('is-active');
              p.setAttribute('hidden', 'hidden');
            }
          } else {
            // Desktop: always visible
            p.classList.remove('is-active');
            p.removeAttribute('hidden');
          }
        }.bind(this));

        this.tabs.forEach(function(t, i){
          t.setAttribute('aria-selected', i === index ? 'true' : 'false'); // 0-based comparison
        });

        var activePanel = this.panels[index];
        if (activePanel) {
          window.requestAnimationFrame(function() {
            var sliderRanges = activePanel.querySelectorAll('[data-section-type="slider-range"]');
            sliderRanges.forEach(function(el) {
              var instance = el._sliderRangeInstance;
              if (instance && instance._markerRailController) {
                instance._markerRailController.alignActiveElement(true);
                instance._markerRailController.update();
              }
            });
          });
        }
      },

      onUnload: function(){
        // Clean up resize handler
        if (this._resizeHandler) {
          window.removeEventListener('resize', this._resizeHandler);
          this._resizeHandler = null;
        }
        // Clean up delegated click handler
        if (this._clickHandler) {
          this.container.removeEventListener('click', this._clickHandler);
          this._clickHandler = null;
        }
      }
    });

    return AdvancedContentMobileTabs;
  })();

  theme.SimplyCarousel = (function(){
    var config = {
      containerSelector: '.simply-carousel-',
      nextButtonSelector: '.simply-carousel__next--button-',
      prevButtonSelector: '.simply-carousel__prev--button-',
      buttonGroupSelector: '.simply-carousel__button-group-',
      namespace: '.simply-carousel'
    }

    function SimplyCarousel(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId =  this.container.dataset.sectionId;
      this.sectionColumns = this.container.dataset.sectionColumns;
      if (this.container.clientWidth <= 576) {
        this.sectionColumns = 1;
      } else if (this.container.clientWidth <= 768) {
        this.sectionColumns = 2;
      }
      this.carouselContainer = this.container.querySelector(config.containerSelector + this.sectionId);

      if(this.carouselContainer.childElementCount <= this.sectionColumns) {
        var btnGroup = this.container.querySelector(config.buttonGroupSelector + this.sectionId);
        if (btnGroup) {
          btnGroup.style.display = 'none';
          return;
        }
      }

      if (this.carouselContainer) {
        this.sp = {
          x: 0,
          y: 0
        };
        this.ep = {
            x: 0,
            y: 0
        };

        this.itemWidth = this.carouselContainer.children[0].clientWidth;
        this.numberOfItems = this.sectionColumns;
        this.transformWidth = 0;
        this.maxTransformWidth = this.itemWidth*(this.carouselContainer.childElementCount - this.numberOfItems);
        this.init();
      }
    }

    SimplyCarousel.prototype = Object.assign({}, SimplyCarousel.prototype, {
      init: function(){
        var nextButton = this.container.querySelector(config.nextButtonSelector + this.sectionId);
        if (nextButton) {
          nextButton.on('click' + config.nextButtonSelector + this.sectionId, this.nextItem.bind(this));
        }
        var prevButton = this.container.querySelector(config.prevButtonSelector + this.sectionId);
        if (prevButton) {
          prevButton.on('click' + config.prevButtonSelector + this.sectionId, this.prevItem.bind(this));
        }

        // Ref: https://stackoverflow.com/questions/17567344/detect-left-right-swipe-on-touch-devices-but-allow-up-down-scrolling
        this.carouselContainer.on('touchstart'+ config.namespace + this.sectionId, this.onTouchStart.bind(this));
        this.carouselContainer.on('touchend'+ config.namespace + this.sectionId, this.onTouchEnd.bind(this));
      },

      nextItem: function(evt) {
        if(!evt) return;

        if (this.transformWidth >= this.maxTransformWidth) {
          this.transformWidth = 0;
        } else {
          this.transformWidth += this.itemWidth;
        }
        this.carouselContainer.style.transform = `translate3d(-${this.transformWidth}px, 0px, 0px)`
      },

      prevItem: function(evt) {
        if(!evt) return;

        if(this.transformWidth <= 0) {
          this.transformWidth = this.maxTransformWidth;
        } else {
          this.transformWidth -= this.itemWidth;
        }
        this.carouselContainer.style.transform = `translate3d(-${this.transformWidth}px, 0px, 0px)`
      },

      onTouchStart: function(evt) {
        if(!evt) return;
        this.sp = {
          x: evt.touches[0].pageX,
          y: evt.touches[0].pageY
        }
      },

      onTouchEnd:function(evt) {
        if(!evt) return;

        var ep = {
          x: evt.changedTouches[0].pageX,
          y: evt.changedTouches[0].pageY
        }

        var x = ep.x - this.sp.x,
            xr = Math.abs(x),
            y = ep.y - this.sp.y,
            yr = Math.abs(y);

        if (xr > yr) {
          if (x < 0) {
            this.nextItem(evt);
          } else {
            this.prevItem(evt);
          }
        }
      }
    })

    return SimplyCarousel;
  })();

  // Image Gallery with Photoswipe
  theme.ImageGallery = (function() {
    function ImageGallery(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.photoswipe = null;

      this.init();
    }

    ImageGallery.prototype = Object.assign({}, ImageGallery.prototype, {
      init: function() {
        if (!this.container || this.container.dataset.zoom === 'false') {
          return;
        }

        if (!this.container.querySelector('.js-photoswipe__zoom')) {
          return;
        }

        this.photoswipe = new theme.Photoswipe(this.container, this.sectionId);
      },

      onUnload: function() {
        if (this.photoswipe && typeof this.photoswipe.destroy === 'function') {
          this.photoswipe.destroy();
        }

        this.photoswipe = null;
      }
    });

    return ImageGallery;
  })();

  // Custom Rich Media with Photoswipe
  theme.CustomRichMedia = (function() {
    function CustomRichMedia(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');

      this.init();
    }

     CustomRichMedia.prototype = Object.assign({}, CustomRichMedia.prototype, {
       init: function() {
         // Use the container itself since it has data-photoswipe="true"
         var photoswipeContainer = this.container;

         if (photoswipeContainer?.dataset?.photoswipe === 'true') {
           // Check if we have zoom buttons - use more efficient selector
           var zoomButtons = photoswipeContainer.querySelectorAll('.js-photoswipe__zoom');
           if (zoomButtons.length > 0) {
             // Hybrid approach: Load Photoswipe with small delay
             // This gives us best of both worlds - performance + UX
             var self = this;

             // Use requestAnimationFrame for better performance than setTimeout
             requestAnimationFrame(function() {
               requestAnimationFrame(function() {
                 try {
                   new theme.Photoswipe(photoswipeContainer, self.sectionId);
                 } catch (error) {
                   console.warn('Photoswipe initialization failed:', error);
                 }
               });
             });
           }
         }
       }
     });

    return CustomRichMedia;
  })();

  /* ============================================================
     theme.RingSizer
     Handles the interactive ring size conversion modal.
     Reads data via [data-ring-sizer] and [data-ring-sizer-json]
     — no Liquid template strings needed here.
     ============================================================ */
  theme.RingSizer = (function() {

    // ── Constants ────────────────────────────────────────────────
    var CLASSES = {
      sizeBtn:       'ring-sizer__size-btn',
      sizeBtnActive: 'ring-sizer__size-btn--active',
    };
    var RESULT_PLACEHOLDER  = '\u2014';
    var SCROLL_TOLERANCE_PX = 4;

    // WeakSet: O(1) lookup, doesn't prevent GC of removed nodes.
    var _initialised = new WeakSet();

    // WeakMap: stores per-container document listener refs for cleanup.
    var _listeners = new WeakMap();

    // ── private helpers ──────────────────────────────────────────

    function parseJSON(container) {
      var el = container.querySelector('[data-ring-sizer-json]');
      if (!el) return null;
      try {
        var raw = el.textContent.trim();
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function buildSelect(sel, data) {
      if (!data || !data.units_order) return;
      var frag = document.createDocumentFragment();
      data.units_order.forEach(function(unit) {
        var opt = document.createElement('option');
        opt.value = unit;
        opt.textContent = unit;
        frag.appendChild(opt);
      });
      sel.innerHTML = '';
      sel.appendChild(frag);
    }

    // Build buttons; store row.us in data-us for delegation (no per-button listener).
    function buildGrid(container, data, unit) {
      var grid     = container.querySelector('[data-ring-sizer-grid]');
      var resultEl = container.querySelector('[data-ring-sizer-result]');
      if (!grid || !data || !data.data) return;

      grid.innerHTML = '';
      if (resultEl) resultEl.textContent = RESULT_PLACEHOLDER;

      var frag = document.createDocumentFragment();
      data.data.forEach(function(row) {
        var val = row[unit];
        if (val == null) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = CLASSES.sizeBtn;
        btn.textContent = val;
        btn.dataset.us = (row.us != null) ? row.us : RESULT_PLACEHOLDER;
        frag.appendChild(btn);
      });
      grid.appendChild(frag);
    }

    function initContainer(container) {
      if (_initialised.has(container)) return;
      _initialised.add(container);

      var modalId  = container.getAttribute('data-modal-id');
      var data     = parseJSON(container);
      var sel      = container.querySelector('[data-ring-sizer-select]');
      var videoEl  = container.querySelector('[data-ring-sizer-video]');
      var video2El = container.querySelector('[data-ring-sizer-video2]');

      // Collect document listeners so we can remove them in onUnload.
      var docListeners = [];
      function addDocListener(event, handler) {
        document.addEventListener(event, handler);
        docListeners.push({ event: event, handler: handler });
      }

      // ── Tab 1: converter ─────────────────────────────────────────
      if (data && sel) {
        buildSelect(sel, data);
        buildGrid(container, data, sel.value);
        sel.addEventListener('change', function() {
          buildGrid(container, data, sel.value);
          requestAnimationFrame(checkGridFade);
        });
      }

      // ── Grid scroll-end fade indicator ────────────────────────────
      var grid     = container.querySelector('[data-ring-sizer-grid]');
      var resultEl = container.querySelector('[data-ring-sizer-result]');

      function checkGridFade() {
        if (!grid) return;
        var noScroll = grid.scrollHeight <= grid.clientHeight + SCROLL_TOLERANCE_PX;
        if (noScroll) {
          grid.setAttribute('data-scrolled-end', '');
        } else {
          var atBottom = grid.scrollHeight - grid.scrollTop <= grid.clientHeight + SCROLL_TOLERANCE_PX;
          if (atBottom) {
            grid.setAttribute('data-scrolled-end', '');
          } else {
            grid.removeAttribute('data-scrolled-end');
          }
        }
      }

      if (grid) {
        // One delegated click handler for all size buttons.
        grid.addEventListener('click', function(e) {
          var btn = e.target.closest('.' + CLASSES.sizeBtn);
          if (!btn) return;
          var prev = grid.querySelector('.' + CLASSES.sizeBtnActive);
          if (prev) prev.classList.remove(CLASSES.sizeBtnActive);
          btn.classList.add(CLASSES.sizeBtnActive);
          if (resultEl) resultEl.textContent = btn.dataset.us || RESULT_PLACEHOLDER;
        });

        grid.addEventListener('scroll', checkGridFade, { passive: true });
        requestAnimationFrame(checkGridFade);
      }

      // ── Tab switching ─────────────────────────────────────────────
      var tabs   = container.querySelectorAll('[data-ring-sizer-tab]');
      var panels = container.querySelectorAll('[data-ring-sizer-panel]');

      if (tabs.length > 0) {
        container.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-ring-sizer-tab]');
          if (!btn) return;
          var target = btn.getAttribute('data-ring-sizer-tab');

          for (var t = 0; t < tabs.length; t++) {
            var isActive = tabs[t].getAttribute('data-ring-sizer-tab') === target;
            tabs[t].classList.toggle('ring-sizer__tab--active', isActive);
            tabs[t].setAttribute('aria-selected', isActive ? 'true' : 'false');
          }

          for (var p = 0; p < panels.length; p++) {
            var isPanel = panels[p].getAttribute('data-ring-sizer-panel') === target;
            panels[p].classList.toggle('ring-sizer__panel--active', isPanel);
            if (isPanel) {
              panels[p].removeAttribute('hidden');
            } else {
              panels[p].setAttribute('hidden', '');
            }
          }
        });
      }

      // ── Video handling ────────────────────────────────────────────
      if (videoEl && modalId) {
        addDocListener('modalOpen.' + modalId, function() {
          try { videoEl.currentTime = 0; } catch (e) {}
          var p = videoEl.play && videoEl.play();
          if (p && typeof p.then === 'function') p.catch(function() {});
        });
        addDocListener('modalClose.' + modalId, function() {
          try { videoEl.pause && videoEl.pause(); } catch (e) {}
        });
      }

      if (video2El && modalId) {
        addDocListener('modalClose.' + modalId, function() {
          try { video2El.pause && video2El.pause(); } catch (e) {}
        });
      }

      // Store refs for cleanup
      _listeners.set(container, docListeners);
    }

    function initAll() {
      var containers = document.querySelectorAll('[data-ring-sizer]');
      for (var i = 0; i < containers.length; i++) {
        initContainer(containers[i]);
      }
    }

    function onUnload() {
      // Remove all stored per-container document listeners.
      // (WeakMap doesn't expose keys, so containers must be queried again.)
      var containers = document.querySelectorAll('[data-ring-sizer]');
      for (var i = 0; i < containers.length; i++) {
        var list = _listeners.get(containers[i]);
        if (list) {
          list.forEach(function(l) {
            document.removeEventListener(l.event, l.handler);
          });
          _listeners.delete(containers[i]);
        }
      }
      document.removeEventListener('modalOpen', initAll);
    }

    // Fire on every modal open via event delegation
    document.addEventListener('modalOpen', initAll);

    return { init: initAll, onUnload: onUnload };
  })();

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);
    theme.sections.register('custom-testimonials', theme.CustomTestimonials);
    theme.sections.register('slider-range', theme.SliderRange);
    theme.sections.register('custom-tab', theme.CustomTab);
    theme.sections.register('advanced-content-mobile-tabs', theme.AdvancedContentMobileTabs);
    theme.sections.register('simply-carousel', theme.SimplyCarousel);
    theme.sections.register('carat-sizer', theme.CaratSizer);
    theme.sections.register('image-gallery', theme.ImageGallery);
    theme.sections.register('custom-rich-media', theme.CustomRichMedia);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();
